let book2 = [];
book2[0] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "announcement",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7bfe943ea44ce0c0207e6071d6d2046e8967bb7c_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ə'naʊnsmənt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 1) a piece of information given to people by using a loudspeaker or microphone, esp. at an airport or railway station 广播通知",
                              "example": "This is an announcement for all passengers traveling on the 9:25 flight to Rome."
                          },
                          {
                              "explanation": "2) an important or official statement （重要或正式的）通告，公告，布告",
                              "example": "The minister made the announcement that he was to retire the following month."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Mandarin",
              "pee": [
                  {
                      "partOfSpeech": "/'mændərɪn/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 普通话",
                                "example": "",
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ef638d003980cb61b7debd79398cf435dbe80f84_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "prosperity",
              "pee": [
                  {
                      "partOfSpeech": "/prɒ'sperəti/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the state of being successful, esp. financially 兴隆； 发达；繁荣；昌盛",
                              "example": "A country's future prosperity depends, to an extent, upon the quality of education of its people."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b74018cfda00f7e03d94de9a860af11fd78edef2_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "urbanize",
              "pee": [
                  {
                      "partOfSpeech": "/'ɜːbəˌnaɪz/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE also urbanise) cause to take on urban characteristics 使城市化",
                              "example": "The area has been urbanized these years."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f5f914f06ef12c05a25af3836f1c4f7c91fefb7c_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "large-scale",
              "pee": [
                  {
                      "partOfSpeech": "/'lɑːdʒ ˌskeɪl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(only before noun) using or involving a lot of effort, people, supplies, etc. 大规模的",
                              "example": "We must improve our response to large-scale natural disasters."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6cea886ee4377f44dbc0a7452dd2a271a756cac3_96k.mp3#duration=2.7&t=.mp3"
          },
          {
              "word": "mechanized",
              "pee": [
                  {
                      "partOfSpeech": "/'mekəˌnaɪzd/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE also mechanised) using a machine to do sth. that used to be done by hand 机械化的",
                              "example": "Modern mechanized equipment has enormously reduced the number of personnel needed."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cd55a94f398b0c94b93dcec8a6e2259b03dd0db2_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "numerous",
              "pee": [
                  {
                      "partOfSpeech": "/'njuːmərəs/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "many 许多的；很多的",
                              "example": "He has been late on numerous occasions."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/74c65baf06b90cdd083d8629206d640a4de9197c_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "exhausting",
              "pee": [
                  {
                      "partOfSpeech": "/ɪgˈzɔːstɪŋ/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "making you feel extremely tired 使人精疲力竭的",
                              "example": "All of us who have raised children know how demanding and exhausting it can be."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2a26fe933dfdbdfd4575494aa509b0297d412ec6_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "soundproof",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsaʊndˌpruːf/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(also soundproofed) not allowing sound to go through 隔音的",
                              "example": "Regular sounds of everyday living can be heard through a poorly soundproof wall."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3b6e064633d7d114ac0416ea911a15bbbeb74cc9_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "booth",
              "pee": [
                  {
                      "partOfSpeech": "/buːð/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a small enclosed box-like space that a person can go into 小隔间",
                              "example": "I called her from a public phone booth near the entrance to the bar."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d36833e8fb40ed12a70871de574d1ffba5198762_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "marvelous",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmɑːvələs/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE marvellous) extremely good, enjoyable, impressive, etc. 极好的；绝妙的；了不起的",
                              "example": "We've achieved some marvelous results with this new drug."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/60d81921a49333f583fc1b7a3f28d7d686a27a55_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "gorgeous",
              "pee": [
                  {
                      "partOfSpeech": "/ˈgɔːdʒəs/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "extremely beautiful or attractive 非常漂亮的；极其吸引人的",
                              "example": "There is no denying the fact that this film looks absolutely gorgeous."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7c16b6b930781bd719fcd244dfeb6ef568993999_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "decoration",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdekəˈreɪʃn/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, usu. pl.];sth. pretty that you put onto sth. else in order to make it more attractive 装饰物",
                              "example": "We put up the decorations at the beginning of the holiday."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bcd7b4454a11abda4d31728ad4f9d2d4e45cfcdd_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "incredible",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈkredəbl/【a.】】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) extremely good, large, or great 极好的；极大的",
                              "example": "The wildflowers will be incredible after this rain."
                          },
                          {
                              "explanation": "2) impossible or very difficult to believe 难以置信的",
                              "example": "It seemed incredible that people would still want to play football during a war."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ce89a049ce645f62d7b5409fbb6b73358314b79f_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "exclusively",
              "pee": [
                  {
                      "partOfSpeech": "/ɪkˈskluːsɪvli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "only 专门地；独家地；仅仅",
                              "example": "Instruction in these subjects in undergraduate classes is almost exclusively by lecture."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9cad3415c02a80cf8e8f5df5ee16b906cfc5b327_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "growth",
              "pee": [
                  {
                      "partOfSpeech": "/grəʊθ/【n.】 [U, sing.]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) an increase in the value of goods or services produced and sold by a business or a country 增长；发展",
                              "example": "The company is preparing for zero growth this year."
                          },
                          {
                              "explanation": "2) an increase in amount, number, or size 增多；增长；增大；增强",
                              "example": "We've seen an enormous growth in the number of businesses using the Web."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/116752bbe723e814fbd5d66dec90f154e2b16c60_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "entrepreneur",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɒntrəprəˈnɜː/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] sb. who starts their own business, esp. when this involves risks 企业家",
                              "example": "He would not have succeeded in such a risky business if he had not been such a clever entrepreneur."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e4a567ec0216ee6cc00141b968aedb4c16cc76bf_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "skyline",
              "pee": [
                  {
                      "partOfSpeech": "/ˈskaɪˌlaɪn/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] the shape made by hills or buildings against the sky 天际线",
                              "example": "You get a good view of the New York skyline from the Statue of Liberty."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5ac3c88ece03f7dc543d1c9cc6e84fe33eacfc6f_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "highway",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhaɪˌweɪ/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (esp. AmE) a wide main road that joins one town to another 公路",
                              "example": "The interstate highways are usually faster, but smaller roads can be more scenic (景色优美的)."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f88d96de92f0c67d4282e07b009ef977f39a0d8b_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "joint venture",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdʒɔɪnt ˈventʃə/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a business or project in which two or more companies or individuals have invested, with the intention of working together 合营企业；合资企业",
                              "example": "The company has set up a joint venture with a firm in Austria."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d9c4c52c36bcef70944c81cce3337be36f2915f_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "high-end",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhaɪ ˌend/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(AmE) (usu. before noun) expensive and of high quality 高档的；高端的",
                              "example": "John Lewis is a high-end department store that operates throughout the UK."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f952babeffe9739c6fd1d151da6e428030881d61_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "drone",
              "pee": [
                  {
                      "partOfSpeech": "/drəʊn/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (technical) an aircraft without a pilot but is controlled by sb. on the ground 无人机",
                              "example": "Drones have opened up a lot of possibilities for photographers"
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "【vi.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make a continuous low dull sound 发出持续的嗡嗡声；嗡嗡作响",
                              "example": "Above him an invisible plane droned through the night sky."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0457b55fba9539fc904785948ff1828700679c60_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "VR",
              "pee": [
                  {
                      "partOfSpeech": "【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] (virtual reality) an environment produced by a computer that looks and seems real to the person experiencing it （计算机构筑的）虚拟现实",
                                "example": ""
                            }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ed402072fa5d13e4f4291a5c0b5af70efa8aca18_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "headset",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhedˌset/【n.】 [C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) a piece of head-worn equipment designed to see computer images or images from a camera in front of your eyes 头戴式视图器",
                              "example": "This VR headset allows you to enter a whole new world, all from the comfort of your own home."
                          },
                          {
                              "explanation": "2) a set of headphones, often with a microphone attached （常指带麦克风的）耳机",
                              "example": "This Bluetooth headset is very easy to use."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/73f4b65e70564cad7800a841eb920c02fa4e2145_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "perception",
              "pee": [
                  {
                      "partOfSpeech": "/pəˈsepʃn/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the way you think about sth. and your idea of what it is like 认识；观念；看法",
                              "example": "There is a general public perception that standards in schools are falling."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5e48f65e84a3285df70cb27c76b2889165fc8c2f_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "implementation",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɪmplɪmənˈteɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the process of taking action or making changes that you have officially decided should happen 实施；贯彻；执行",
                              "example": "Very little has been achieved in the implementation of the peace agreement signed last January."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b38608ae7fb3c4cea9362bf80d2c1670239c135e_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "innovative",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪnəʊˌveɪtɪv/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(also innovatory) using new methods or ideas 新颖的；创新的；革新的；采用新方法或新观念的",
                              "example": "Big companies are always looking for innovative products that can't be easily copied."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/164d493b26e99d8f7653966e70630043574d48d1_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "reliance",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈlaɪəns/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U, sing.] the state of depending on a particular person or thing 依靠；依赖",
                              "example": "The study program concentrates more on group work and places less reliance on lectures."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bf325ffb6f9368af6dd74677fe56f03e58f4e418_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "massive",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmæsɪv/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "very large in size, amount, or number 巨大的；可观的；大量的",
                              "example": "If you are a major sports star or top bank executive, the rewards are massive."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/aae24fa9a4b971823a5ff279649f0dae9e8437f2_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "per capita",
              "pee": [
                  {
                      "partOfSpeech": "/pə ˈkæpɪtə/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) used to describe the average amount of sth. in a particular place, calculated according to the number;of people who live there 人均的；平均每人的",
                              "example": "The significant increase in per capita income offers the potential of new markets to serve."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/adfec7fa0b7de9a6265ad1105fc89b76900fbdd7_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "lag",
              "pee": [
                  {
                      "partOfSpeech": "/læg/【vi.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "move or develop more slowly than others 落后；拖后",
                              "example": "He's lagging behind — we'd better wait for him to catch us up."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c1aa28b2d9ec7d47f541a048ff707200d382b160_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "undoubtedly",
              "pee": [
                  {
                      "partOfSpeech": "/ʌnˈdaʊtɪdli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "certainly or definitely; unquestionably 确定无疑地； 毫无疑问地",
                              "example": "She is an artist whose work will undoubtedly withstand the test of time.】"
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/28970b350c2b7d859d728445d42a599cf0bca806_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "impoverished",
              "pee": [
                  {
                      "partOfSpeech": "/ɪmˈpɒvərɪʃt/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "very poor 贫困的",
                              "example": "He devotes himself to creating sustainable solutions for impoverished people in Africa."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/eedfb93bf6c2371a55eb8e535328aa21208579d0_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "vow",
              "pee": [
                  {
                      "partOfSpeech": "/vaʊ/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make a serious promise to yourself or sb. else 立誓；起誓",
                              "example": "The president has vowed to help the earthquake victims."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a serious promise 誓言；誓约",
                              "example": "Jim made a vow that he would find his wife's killer."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7b36b45d955f48533169c841626f7017d27da7d2_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "eradicate",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7c8e7d52763d71fb089f6d73938e8701aebd77d4_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "get rid of sth. completely or destory sth. bad 根除；消灭",
                              "example": "The disease has now been successfully eradicated from the world."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "poverty",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpɒvəti/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the situation or experience of being poor 贫穷；贫困",
                              "example": "There are many areas where the problems of poverty and unemployment still persist."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a31ced58e7e073ae834af548bf63bd790f6c257f_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "charming",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtʃɑːmɪŋ/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "very pleasing or attractive 迷人的；有魅力的；有吸引力的",
                              "example": "There are lots of charming little restaurants along the river.】"
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3d4f175dcb73cae58d27d17000331d4c419ca84a_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "quiz",
              "pee": [
                  {
                      "partOfSpeech": "/kwɪz/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "ask sb. a lot of questions 询问；查问；盘问",
                              "example": "Four men have been quizzed about the murder, but no one has yet been charged."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(pl. quizzes) a competition or game in which people have to answer questions 问答比赛；智力竞赛",
                              "example": "The club has weekly quiz nights."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/13ba99778856a86e78d095520a1b98d256c4cf1f_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "trace",
              "pee": [
                  {
                      "partOfSpeech": "/treɪs/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) study or describe the history, development, or progress of sth. 研究...的历史；探索...的发展；追寻...的轨迹",
                              "example": "The book traces the changing nature of the relationship between men and women."
                          },
                          {
                              "explanation": "2) find sb. / sth. that has disappeared by searching for them carefully 仔细找寻",
                              "example": "Police are trying to trace a young woman who was seen near the accident."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7b384689149ac900525e8f12f65325276e09852f_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "yawn",
              "pee": [
                  {
                      "partOfSpeech": "/jɔːn/【vi.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (yawning gap / gulf / chasm) a very large difference between two groups, things, or people （两者之间的）巨大差距",
                              "example": "There exists a yawning gap between rich and poor."
                          },
                          {
                              "explanation": "2) open your mouth wide and breathe in deeply because you are tired or bored 打呵欠",
                              "example": "They looked bored and couldn't help yawning."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d0ed6da220eef4a3c57e508da726cf178815a199_96k.mp3#duration=2.2&t=.mp3"
          },
          {
            "word": "millennial",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8969a8e33c3ad3cc8f7a0fd21c015ad3e8d45b46_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/mɪˈleniəl/【n.】;[C, usu. pl.]",
                    "explanations_and_examples": [
                        {
                            "explanation": "a person who was born in the 1980s, 1990s, or early 2000s 千禧一代",
                            "example": "Millennials have grown up with the Internet and can't imagine a world without it."
                        }
                    ]
                }
            ]
        },
        {
            "word": "reminisce",
            "pee": [
                {
                    "partOfSpeech": "/ˌremɪˈnɪs/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "talk or think about pleasant events in your past 谈论， 追忆（快乐的往事）",
                            "example": "We sat side by side, reminiscing about the past."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0232fb2d1445462ca70aa5ce61c2cd96c9228ac9_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "regretfully",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈgretf(ə)li/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "feeling sad because you do not want to do what you are doing 遗憾地；惋惜地",
                            "example": "I must regretfully decline your invitation."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/246b9736dea8634da3dc742f7dc2d596e3866b93_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "remark",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈmɑːk/【v.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "say sth., esp. about sth. you have just noticed 评论，谈到，说起（尤指刚察觉的事）",
                            "example": "Anderson left the table, remarking that he had some work to do."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n. [C]",
                    "explanations_and_examples": [
                        {
                            "explanation": "sth. that you say when you express an opinion or say what you have noticed 言论；意见；评论",
                            "example": "He made a number of rude remarks about the food."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1573e4d5bdf0cb262243417da0c6dfa6add04a40_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "phenomenon",
            "pee": [
                {
                    "partOfSpeech": "/fəˈnɒmɪnən/【n.】;[C] (pl. phenomena)",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) a fact or an event in nature or society, esp. one that is not fully understood 现象",
                            "example": "Language is a social and cultural phenomenon."
                        },
                        {
                            "explanation": "2) sb. / sth. that is very unusual because of a rare quality or ability that they have 非凡的人（事物）；奇才；奇事",
                            "example": "The Beatles were a phenomenon — nobody had heard anything like them before. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/eac108b686fd46799469ac1091fd7426b49d25cd_96k.mp3#duration=2.8&t=.mp3"
        },
        {
            "word": "outpouring",
            "pee": [
                {
                    "partOfSpeech": "/ˈaʊtˌpɔːrɪŋ/【n.】;[C]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) a very large number of things produced at the same time 大量涌现；迸发",
                            "example": "Technology is offering us an outpouring of opportunities that will help us stay curious and creative."
                        },
                        {
                            "explanation": "2) an uncontrolled expression of strong feelings （强烈感情的）流露，倾吐",
                            "example": "The news of his death produced an instant outpouring of grief."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7a63a9300c9edb3bb26cd3dbbc9cd519e6154960_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "spontaneous",
            "pee": [
                {
                    "partOfSpeech": "/spɒnˈteɪniəs/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "happening or done in a natural, often sudden way, without any planning or without being forced 自发的；自然而生的；一时冲动的",
                            "example": "The audience broke into spontaneous applause."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f4d5eee202f3cadebab27430eea40d2a91519270_96k.mp3#duration=2.5&t=.mp3"
        },
        {
            "word": "amazement",
            "pee": [
                {
                    "partOfSpeech": "/əˈmeɪzmənt/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] a feeling of great surprise 吃惊；惊奇",
                            "example": "Much to the amazement of her family, she left school to pursue her acting career."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1129ea8e56b6ba8f1b2cd90259d5d40446e6f11d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "evolve",
            "pee": [
                {
                    "partOfSpeech": "/ɪˈvɒlv/【v.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) develop and change gradually over a long period of time 逐步形成；逐渐演变",
                            "example": "Computer software will continue to evolve in response to users' needs. "
                        },
                        {
                            "explanation": "2) (of plants, animals, etc.) change gradually over a long period of time （植物、动物等）进化，进化形成",
                            "example": "More complex animals gradually evolved from these very simple creatures."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/915d647f38675118028c16b2f8c7b215a8f02a61_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "hardship",
            "pee": [
                {
                    "partOfSpeech": "/ˈhɑːdʃɪp/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] a condition of life that causes difficulty or suffering 艰苦；贫困",
                            "example": "People suffered many hardships during that long winter."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a5c5e9185eaf3c1ec990fbf9dc5e78a30c8b664e_96k.mp3#duration=2.6&t=.mp3"
        },
        {
            "word": "downturn",
            "pee": [
                {
                    "partOfSpeech": "/ˈdaʊnˌtɜːn/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, usu. sing.] a reduction in economic, business, or other activity （经济、商业等活动的）下降，衰退",
                            "example": "There is evidence of a downturn in the housing market."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/63f336eaf46bdc1312c85b6c56f831fcfa2f6135_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "per annum",
            "pee": [
                {
                    "partOfSpeech": "/pər ˈænəm/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(abbr. p.a.) (fml.) for each year 每年",
                            "example": "The country exports goods worth $600 million per annum."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/227500c347295e4977e9aad406b459ac95a0fc94_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "sole",
            "pee": [
                {
                    "partOfSpeech": "/səʊl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(only before noun) only 唯一的",
                            "example": "The story was published with the sole purpose of selling newspapers."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9fc087f404067adeabd11474753dd1ba595d5301_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "capacity",
            "pee": [
                {
                    "partOfSpeech": "/kəˈpæsəti/【n.】 [C, U]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) sb.’s ability to do sth. 能力；才能",
                            "example": "They are worried about their capacity to invest for the future."
                        },
                        {
                            "explanation": "2) the amount of space a container, room, etc. has to hold things or people 容量；容积；容纳人数",
                            "example": "The newly-built theater has a seating capacity of 2,000."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b19c946e4adde5762bcf215a711120d8ce212891_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "youngster",
            "pee": [
                {
                    "partOfSpeech": "/ˈjʌŋstə/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a child or young person 孩童；年轻人",
                            "example": "These courses are specially designed for youngsters aged seven to nine."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c6af1a3ecd8bfba22dc7cba2d98f878ad32431e9_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "sophisticated",
            "pee": [
                {
                    "partOfSpeech": "/səˈfɪstɪˌkeɪtɪd/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "having a lot of experience of life, and good judgment about socially important things such as art, fashion, etc. 见多识广的；老练的；练达的",
                            "example": "Mark is a smart and sophisticated young man."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/70d2534a15b198af453d54ecfb5958c10e48e7f2_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "lifestyle",
            "pee": [
                {
                    "partOfSpeech": "/ˈlaɪfˌstail/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] the way in which a person or a group of people lives and works 生活方式",
                            "example": "Many people are trying to adopt a healthy lifestyle these days."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/052b7bd2e6751f945a1d83b41abf39e7749a90a9_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "individualistic",
            "pee": [
                {
                    "partOfSpeech": "/ˌɪndɪˌvɪdʒuəˈlɪstɪk/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) different from other people or things; doing things in your own way 特立独行的；独特的",
                            "example": "His music is highly individualistic and may not appeal to everyone. "
                        },
                        {
                            "explanation": "2) believing that what individual people want is more important than what society or the government wants 个人主义的",
                            "example": "A more individualistic society is also one with much more loneliness."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e333be6122a8cf193a7ea87b6777985c7a823766_96k.mp3#duration=3.1&t=.mp3"
        },
        {
            "word": "entrepreneurial",
            "pee": [
                {
                    "partOfSpeech": "/ˌɒntrəprəˈnɜːriəl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "having the qualities that are needed to succeed as an entrepreneur 具有创业素质的",
                            "example": "The successful candidate will be an entrepreneurial, goal-oriented problem solver. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f01b8313de8e15258c1c217ba6a3f953eaf8aa03_96k.mp3#duration=2.9&t=.mp3"
        },
        {
            "word": "confident",
            "pee": [
                {
                    "partOfSpeech": "/ˈkɒnfɪd(ə)nt/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) sure that you have the ability to do things well or deal with situations successfully 有信心的；自信的",
                            "example": "I feel much more confident about myself and my abilities these days."
                        },
                        {
                            "explanation": "2) (not before noun) sure that sth. will happen in the way that you want or expect 确信的；有把握的",
                            "example": "We are confident next year's profits will be higher."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/48f994845f73dff6e15a6cc92e3d587bb7e0bc25_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "considerable",
            "pee": [
                {
                    "partOfSpeech": "/kənˈsɪd(ə)rəbl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "fairly large, esp. large enough to have an effect or be important 相当大的（尤指能产生影响或很重要）",
                            "example": "Considerable progress has been made in finding a cure for the disease."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b308dcb0409b2cf31412db6e56987c7d9d0f352e_96k.mp3#duration=2.5&t=.mp3"
        },
        {
            "word": "daunting",
            "pee": [
                {
                    "partOfSpeech": "/ˈdɔːntɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "frightening in a way that makes you feel less confident 使人气馁的；吓人的",
                            "example": "They were faced with the daunting task of restoring the house."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2bd5a4d484efe4666e3554177658b9e028f4d582_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "navigate",
            "pee": [
                {
                    "partOfSpeech": "/ˈnævɪˌgeɪt/【v.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) understand or deal with sth. difficult 理解，应付（困难复杂的情况）",
                            "example": "This outlook helped her navigate through her later years with success."
                        },
                        {
                            "explanation": "2) find which way you need to go while traveling from one place to another （为...）导航，指引方向",
                            "example": "There weren't any road signs to help us navigate through the maze of one-way streets."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b6dc3451f9870c9ed4f2260a60398135bfc3a7ee_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "attribute",
            "pee": [
                {
                    "partOfSpeech": "/əˈtrɪbju:t/【vt.】 (~ … to …)",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) believe or say that sb. / sth. has a particular quality 认为...具有...的特征",
                            "example": "People were beginning to attribute superhuman qualities to him."
                        },
                        {
                            "explanation": "2) believe or say that a situation or event is caused by sth. 把...归因于...",
                            "example": "The fall in the number of deaths from heart disease is generally attributed to improvements in diet. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0b953c9822e62d5d70b882f965d2699ecd8ca0b3_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "savvy",
            "pee": [
                {
                    "partOfSpeech": "/ˈsævi/【a.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "(infml.) knowing a lot about sth. and able to make good judgments about it 有见识的；在行的",
                            "example": "She bought the laptop on the advice of a computer-savvy friend."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (infml.) practical knowledge and ability 实际知识和能力；见识",
                            "example": "He's obviously got a lot of political savvy."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4c9cb6e6c4dbf07677e21019a9d31fa40f962bff_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "progressive",
            "pee": [
                {
                    "partOfSpeech": "/prəʊˈgresɪv/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "supporting new or modern ideas and methods, esp. in politics and education （尤指在政治和教育方面） 进步的，先进的",
                            "example": "We're looking for progressive ideas to move the company forward."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/acc40bebbe0f68ada8890dd1da38b5841c235ef8_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "deem",
            "pee": [
                {
                    "partOfSpeech": "/di:m/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) think of sth. in a particular way or as having;a particular quality 认为；视为",
                            "example": "These buildings are deemed to be of architectural importance and must be protected."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/533f52fd804476e7172e9c053c9c37cc4e130a95_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "self-centered",
            "pee": [
                {
                    "partOfSpeech": "/ˌself ˈsentəd/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(BrE self-centred) tending to think only about yourself and not thinking about the needs or feelings of other people 自我中心的；自私的",
                            "example": "She sounds totally self-centered and is showing you no consideration."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f1a40ff44d1264a0fa74df2051255e0832a57ed5_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "entitled",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈtaɪtld/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "feeling that you have the right to do or have what you want without having to work for it or deserve it, just because of who you are （由于自身身份）认为应得的，有权利的，有资格的",
                            "example": "The college attracts both the entitled children of wealthy parents and many scholarship students."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/10efc8ae159fb5538d9c095a4f3fb4849fb026e5_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "consumption",
            "pee": [
                {
                    "partOfSpeech": "/kənˈsʌmpʃn/【n.】 [U]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) the act of buying and using products 购买；消费",
                            "example": "These products are not for national consumption, but for export."
                        },
                        {
                            "explanation": "2) the amount of energy, oil, electricity, etc. that is used （能源、油、电等的）消耗量",
                            "example": "The government is determined to reduce the UK's total energy consumption. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/685cbe9dc8de45b6574acc4f57cb7d92c398c4b9_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "forecast",
            "pee": [
                {
                    "partOfSpeech": "/ˈfɔːkɑːst/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(forecast, forecast; forecasted, forecasted) say what you expect to happen in the future 预测；预报",
                            "example": "They forecast a large drop in unemployment over the next two years."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a statement of what is expected to happen in the future, esp. in relation to a particular event or situation 预测；预报",
                            "example": "The weather forecast said it was going to rain. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ff0f71f0515fe9985c9ec8a361cdc2dad141e1b9_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "aspiration",
            "pee": [
                {
                    "partOfSpeech": "/ˌæspɪˈreɪʃn/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, usu. pl., U] a strong desire to have or achieve sth. 强烈愿望；志向；抱负",
                            "example": "When I was 12, I had aspirations to play professional basketball."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/de8818d1c2ba41356fcdbe86ead7c418f348a451_96k.mp3#duration=3.2&t=.mp3"
        },
        {
            "word": "furthermore",
            "pee": [
                {
                    "partOfSpeech": "/ˈfɜːðəmɔː/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) in addition to what has already been said 此外；而且；不仅如此；更有甚者",
                            "example": "She always arrives on time; furthermore, her work is always excellent."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/35f0eb1cd18768b1e8f9ae2933a2a36d3cca1fb8_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "e-commerce",
            "pee": [
                {
                    "partOfSpeech": "/ˌi: ˈkɒmɜːs/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (electronic commerce) the business of buying and selling of goods and services on the Internet 电子商务",
                            "example": "Travel companies have moved from the traditional bricks-and-mortar (实体的) environment to e-commerce."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6b8660bd271f21582dbab83f5dbdad58ac68181c_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "trendy",
            "pee": [
                {
                    "partOfSpeech": "/ˈtrendi/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "influenced by the most fashionable styles and ideas 时髦的；受新潮思想影响的",
                            "example": "He writes for some trendy magazine."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/978a8f3e73a8ebbfea2ef232d695daea1617062b_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "craze",
            "pee": [
                {
                    "partOfSpeech": "/kreɪz/【n.】;",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a fashion, game, type of music, etc. that becomes very popular for a short time 时尚；一时的狂热",
                            "example": "If history is any guide, this latest diet for losing weight is just another craze."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/62610b85ac7898e0d2c35f502534edfdbfbb429f_96k.mp3#duration=1.8&t=.mp3"
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "well off",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "having a lot of money or enough money to have a good standard of living 有钱的；富裕的",
                              "example": "They worked long hours and became very well off."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/478e3535f72f883a050eb97fbb06452ad86cb7d2_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "up to sth.",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used for stating a particular standard sth. can reach 达到（某个标准）",
                              "example": "I didn&rsquo;t think last night's performance was up to her usual standard."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2040a22c4a8a038468cf3a02909cf064e62eef73_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "packed with",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "completely full of 充满...的",
                              "example": "This book is packed with useful information."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/795ef3e2dd443700e3280273db43dcb638bd0844_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "try out",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "use sth. to discover if it works or if you like it 试用；试验；检验",
                              "example": "Don't forget to try out the equipment before setting up the experiment."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7bc913a01c1a71d67e7fa8226cf1b5ba9c5b39df_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "lag behind",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "fall behind 落后于",
                              "example": "Prices are rising sharply, while incomes are lagging far behind."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/280dee047a612f274be9593fe66f245e563a241c_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "in / by comparison (with / to)",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "when compared 相比之下；比较起来",
                              "example": "In comparison to other recent video games, this one isn't very exciting."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/eacde9358eb807e6b8c118909c41e40bb1b859ae_96k.mp3#duration=6.8&t=.mp3"
          },
          {
            "word": "other than",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "apart from 除了...以外",
                            "example": "Are you studying any science subjects other than chemistry?"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b8c9d68b0428d31428cf61fa2ed8aae0109a667d_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "in / by contrast (to / with)",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "used when you are comparing two things or people and saying that the second one is very different from the first 和...形成对照；相比之下",
                            "example": "The company lost $13 million this year, in contrast to a profit of $15 million last year."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1d17d0f2e41013d4efb802993cf15ef4aa7ba1ae_96k.mp3#duration=6.8&t=.mp3"
        },
        {
            "word": "as compared to / with",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "used for talking about the ways in which two things are different, or about the ways in which sth. has changed 相比于",
                            "example": "Unemployment in the region currently stands at 10.1 percent, as compared to a national average of 7.7 percent."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b73ec40d1d4b521115b7fb508df285ab4f9858f3_96k.mp3#duration=4.2&t=.mp3"
        },
        {
            "word": "speak to",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(figuratively) resonate with; feel emotionally relevant to 与...产生共鸣；与...产生情感联结",
                            "example": "If this story spoke to you, I very much want to hear from you."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1ec864a73a39c715e67b5cab90f0dc52b6cd22d3_96k.mp3#duration=2.3&t=.mp3"
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "San Francisco",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/27de0f3f09463e35e0bbcf0d299705a3ff5a2d22_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌsæn frənˈsɪskəʊ/;",
                      "explanations_and_examples": [
                          {
                              "explanation": "旧金山（美国城市，位于加利福尼亚州）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Tesla",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/663ebbb0ae7f7bdba7091ae3956aa209920e728d_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈteslə/",
                      "explanations_and_examples": [
                          {
                              "explanation": "特斯拉（汽车品牌）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Walmart",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d9a08a70b87509546ecf181826ec355739afdd91_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈwɔːlmɑːt/",
                      "explanations_and_examples": [
                          {
                              "explanation": "沃尔玛（连锁零售商）"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "Melbourne",
            "pee": [
                {
                    "partOfSpeech": "/ˈmelbən/",
                    "explanations_and_examples": [
                        {
                            "explanation": "墨尔本 (澳大利亚城市，位于维多利亚州)"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/294f67f0030202b4d121b7e6c40548c80c47258e_96k.mp3#duration=2.1&t=.mp3"
        }
      ]
  }

]

book2[1] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "roam",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d7c2d0b3055e91c416d6e240ebc450b54fdeb791_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/rəʊm/【v.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "walk or travel, usu. for a long time, with no clear purpose or direction 闲逛；漫步；漫步于",
                              "example": "Tigers once roamed far and wide across much of Southeast Asia."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "wander",
              "pee": [
                  {
                      "partOfSpeech": "/'wɒndə/【v.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "walk slowly across or around an area, usu. without a clear direction or purpose 徘徊；闲逛；漫步于",
                              "example": "After lunch he wandered aimlessly around the shopping mall. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e93b3474962f74070e741054d307cd7340ecd63c_96k.mp3#duration=2.9&t=.mp3"
          },
          {
              "word": "passionate",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpæʃ(ə)nət/【a.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "having or showing strong feelings of love or of anger, etc. 感情强烈的；热情的",
                              "example": "Sarah was greeted with a passionate embrace by her husband and children at Heathrow Airport on returning to London. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/beab35414802baf940436fada6b0b44ce841d629_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "dockside",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdɒkˌsaɪd/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[sing.] the edge of the land that is next to the water in a port 码头边；坞边",
                              "example": "The dockside was the busiest place he had ever seen."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dda362de038605c33bf956ed24f1bbb221bb7b75_96k.mp3#duration=3.1&t=.mp3"
          },
          {
              "word": "reunion",
              "pee": [
                  {
                      "partOfSpeech": "/ri:ˈju:niən/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C, U] the act of people coming together after they have been apart for some time 团圆；重逢",
                              "example": "It was a very emotional reunion, for the children weren't allowed to see her for nearly a week."
                          },
                          {
                              "explanation": "2) [C] a social occasion or party attended by a group of people who have not seen each other for a long time 聚会",
                              "example": "We all look forward to our class reunion, an awesome celebration with old friends!"
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2a52fe49fc5d8a79369826ccbcb2f7d4b4cd3f12_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "stern",
              "pee": [
                  {
                      "partOfSpeech": "/stɜːn/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "serious and strict, and showing strong disapproval of sb.'s behavior 严厉的；严格的；苛刻的",
                              "example": "The prime minister gave a stern warning to those who were on strike."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0c449640287adbb1b6be2b4a71cf2f23e9343581_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "fretful",
              "pee": [
                  {
                      "partOfSpeech": "/'fretfl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) marked by worry and distress; troublesome 令人烦恼的",
                              "example": "Mr. Royama and others are likely to find the coming week a very fretful one indeed."
                          },
                          {
                              "explanation": "2) anxious and complaining, and unable to relax 烦恼的；发牢骚的",
                              "example": "The boy appeared fretful and disappointed that he couldn't join the others on their trip."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/89592d34cb726a613f77530a20edbff8e44df025_96k.mp3#duration=3.1&t=.mp3"
          },
          {
              "word": "refugee",
              "pee": [
                  {
                      "partOfSpeech": "/ˌrefjʊˈdʒi:/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] sb. who has been forced to leave their country, esp. during a war, or for political or religious reasons 难民；避难者",
                              "example": "The refugees were packed shoulder to shoulder on the boat."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cbd6106482a544f13afa5b682bfb044ce81d81cb_96k.mp3#duration=3.7&t=.mp3"
          },
          {
              "word": "overloaded",
              "pee": [
                  {
                      "partOfSpeech": "/ˌəʊvəˈləʊdɪd/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "having or supplied with too much of sth. 超载的； 超负荷的",
                              "example": "More than 10 people were killed after an overloaded bus crashed into a pond."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d591d6fc430123286174f9019d2fd5bd33648b7_96k.mp3#duration=3.0&t=.mp3"
          },
          {
              "word": "lifeboat",
              "pee": [
                  {
                      "partOfSpeech": "/ˈlaɪfˌbəʊt/【n.】;[C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) a small boat carried by ships in order to save people if the ship sinks （船上备用的）救生艇",
                              "example": "The captain ordered all passengers and crew into lifeboats."
                          },
                          {
                              "explanation": "2) a boat that is sent out to help people who are in danger at sea （海上）救生艇（船）",
                              "example": "Sam's dog was saved by a lifeboat during the incident on Tuesday afternoon."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cb14554a8d6aae5569a9090c5abfe64d512df79d_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "singular",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsɪŋgjʊlə/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) single; unique 单个的；独一无二的",
                              "example": "She always thought of herself as singular, as his only daughter."
                          },
                          {
                              "explanation": "2) of or relating to the form of a word used when referring to one person or thing （词形）单数的",
                              "example": "Can you tell me the singular form of this noun? "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4d1b04731a1f5a74636666c6fa22811090d6e437_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "double-decker",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdʌbl ˈdekə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 双层公共汽车",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7e86dc93a1faa66145d4d91de69a83ff61703292_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "windmill",
              "pee": [
                  {
                      "partOfSpeech": "/ˈwIndˌmɪl/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 风车；风车磨坊",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b0eb71861f2000db7fcf7f9a0e8091dd04b598c1_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "sidewalk",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsaɪdˌwɔːk/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (BrE pavement) 人行道",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/15ad5664bb53cd9101647feec52d81ae3ebfb4c5_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "grasp",
              "pee": [
                  {
                      "partOfSpeech": "/grɑːsp/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[sing.] your ability to understand a complicated idea, situation, or subject （对复杂想法、状况或问题的）理解力，领悟力",
                              "example": "Steve has a good grasp of European legal system. "
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "vt.",
                      "explanations_and_examples": [
                          {
                              "explanation": "take and hold sth. firmly 抓牢；握紧",
                              "example": "I grasped his arm firmly and led him away."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/94b1e62292692ed4f4c960ee73c5f2c3748b2c07_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "queue",
              "pee": [
                  {
                      "partOfSpeech": "/kjuː/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(also ~ up) (AmE line, line up) form or join a line of people or vehicles waiting to do sth. or go somewhere 排队（等候）",
                              "example": "People are queuing to get in from seven o'clock in the morning."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (AmE line) a line of people waiting to enter a building, buy sth., etc. or a line of vehicles waiting to move （人或车辆为等候而排的）队，行列",
                              "example": "All of a sudden a woman elbowed her way to the front of the queue."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/48390e94b963f4529149f4ffced4a42162c9f9c1_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "wherever",
              "pee": [
                  {
                      "partOfSpeech": "/werˈevə/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "to or at any place, position, or situation 无论去哪里； 无论在哪里；无论什么情况下",
                              "example": "Wherever you choose to live, there are always going to be advantages and disadvantages."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fe5f1f54b2aa686dbdb3fd8f21fd3f1f7c7c252c_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "orderly",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɔːdəli/【a.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "arranged or organized in a sensible or neat way 有条理的；整齐的",
                              "example": "She put all the letters received in the last two years in three orderly piles."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a6dd6f614df752dfedd695c0477d66dd8f8db2a8_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "scramble",
              "pee": [
                  {
                      "partOfSpeech": "/ˈskræmbl/【vi.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) struggle or compete with other people to get or reach sth. 争夺；抢夺",
                              "example": "Thousands of people will be scrambling for tickets."
                          },
                          {
                              "explanation": "2) (always + ad. / prep.) climb up, down, or over sth. quickly and with difficulty, esp. using your hands to help you （迅速而吃力地）爬，攀登",
                              "example": "She scrambled down the tree as quickly as she could."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b6c702e81ef0573abd782a3fe69d3317df65b27a_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "aboard",
              "pee": [
                  {
                      "partOfSpeech": "/əˈbɔːd/【ad.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "on or onto a ship, plane, or train 在船（飞机、 火车）上；上船（飞机、火车）",
                              "example": "Given the early hour, the train was not crowded at all, with only about 30 passengers aboard."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "prep.",
                      "explanations_and_examples": [
                          {
                              "explanation": "on or onto a ship, plane, or train 在（船、飞机、 火车）上；上（船、飞机、火车）",
                              "example": "After all the troubles, they finally went aboard the plane."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f9ba45b211ae9853ca79c4b78b7075a8cdf0b4da_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "upside down",
              "pee": [
                  {
                      "partOfSpeech": "/ˌʌpsaɪd ˈdaʊn/【ad.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "with the top at the bottom and the bottom at the top 倒置地；颠倒地",
                              "example": "To get the plant out of the pot, turn it upside down and give it a gentle knock."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d0aa40aa0e1927b5080f095e49defeedc327951b_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "impulse",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪmpʌls/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a sudden strong desire to do sth. without thinking about whether it is wise to do 冲动；突然的欲望",
                              "example": "Mary felt a sudden impulse to play some music."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dae4292236dee287d4a7035e18bd6165ee2359e5_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "bounce",
              "pee": [
                  {
                      "partOfSpeech": "/baʊns/【v.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "(cause to) move up or away after hitting a surface （使）弹起；（使）反弹；（使）弹跳",
                              "example": "The ball bounced twice before he could reach it."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/825e8756876f15dab0414112c06a931d7e7f2cb8_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "humour",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhju:mə/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] (AmE humor) the ability to find things funny, the way in which people see that some things are funny, or the quality of being funny 幽默感；幽默",
                              "example": "Even a speech on a serious subject should be delivered with a little humour."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/07cddd19a7123ba394b86025931f35c794da0faf_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "Swiss",
              "pee": [
                  {
                      "partOfSpeech": "/swɪs/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (pl. Swiss) 瑞士人",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/516ba09fee8d0c422570461ceaaa59f114649c6e_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "Spanish",
              "pee": [
                  {
                      "partOfSpeech": "/ˈspænɪʃ/【n.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "(the ~) [pl.] 西班牙人",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a1f53dc268da25a18cc5cc163da0b54f2bb9362e_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "excite",
              "pee": [
                  {
                      "partOfSpeech": "/ɪkˈsaɪt/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (fml.) cause a particular feeling or reaction 引起； 激起",
                              "example": "This product has excited a great deal of media interest."
                          },
                          {
                              "explanation": "2) (not in progressive) make sb. feel happy, interested, or eager 使兴奋；使激动",
                              "example": "His playing is technically brilliant, but it doesn't excite me."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dcb7ae7ba31cee5142a60435195e83604127b4d1_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "childlike",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtʃaɪldˌlaɪk/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "having qualities that are typical of a child 孩子般的；像孩子似的；天真无邪的",
                              "example": "All her life she had a childlike trust in other people."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d612dc538b86bdd78d5f492e82541832335aaed2_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "ignorant",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪgnərənt/【a.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "not knowing information or facts that you ought to know 无知的；愚昧的",
                              "example": "They remained ignorant of the troubles that lay ahead."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0f814f408ff332811ace1b48d77197cf62040cb3_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "reliably",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈlaɪəbli/【ad.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "in a way that can be trusted or believed 可靠地；可信赖地",
                              "example": "The website helps you find what you want faster and more reliably."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d82c07f9155d9b9c078a56ea65e507d3b7619168_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "endanger",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈdeɪndʒə/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "put sb. / sth. in danger of being hurt, damaged, or destroyed 使处于险境；危及",
                              "example": "We must be careful not to do anything that might endanger the economic recovery."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9cee3693bef001f781c4ab818af05e72759defc7_96k.mp3#duration=3.6&t=.mp3"
          },
          {
              "word": "existence",
              "pee": [
                  {
                      "partOfSpeech": "/ɪgˈzɪst(ə)ns/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C, usu. sing.] a particular way of life 生活；生活方式",
                              "example": "Surfing the Internet has become part of our everyday existence."
                          },
                          {
                              "explanation": "2) [U] the state of existing 存在；实有",
                              "example": "The organization has been in existence for 25 years."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0a5af6bffa6983aea443fd68c69d5b6fd0ba560f_96k.mp3#duration=3.5&t=.mp3"
          },
          {
              "word": "chambermaid",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtʃeɪmbəˌmeɪd/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 打扫房间的女工；（尤指宾馆里的）客房女服务员",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/33b05a64a42cb6dbc27dd9d9b06328aff916b49b_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "packet",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpækɪt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (BrE) a small paper or cardboard container in which goods are packed for selling （装商品的）小包，小袋，小盒",
                              "example": "Could you please kindly bring me a few packets of biscuits? "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/13892c2184aadfd3427dcce58f73cfcde33b1e82_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "sniff",
              "pee": [
                  {
                      "partOfSpeech": "/snɪf/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "smell sth. by taking air in through your nose 嗅；闻",
                              "example": "She put perfume on her wrist and sniffed it."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "【vi.】;",
                      "explanations_and_examples": [
                          {
                              "explanation": "breathe air into your nose noisily, for example when you are crying or have a cold （因哭泣、感冒等）抽鼻子",
                              "example": "We all had colds and couldn't stop sniffing and sneezing."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9c743e945617873a6ae018631b0f77b54f440b60_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "puzzle",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3ae3cbc91af8c9c2483f9ac9fc09897e8bab96d2_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpʌzl/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "confuse sb. or make them feel slightly anxious because they do not understand sth. 使困惑；使迷惑",
                              "example": "The findings of the survey puzzled me — they were not at all what I would have expected."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 拼图游戏；拼图玩具",
                              "example": ""
                          }
                      ]
                  }
              ]
          },
          {
              "word": "charm",
              "pee": [
                  {
                      "partOfSpeech": "/tʃɑːm/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "attract sb. and make them like you, sometimes in order to make them do sth. for you 迷住；吸引",
                              "example": "We were charmed by the friendliness of the local people."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a quality that makes you like or feel attracted to sb. / sth. 魅力；吸引力",
                              "example": "Snow White and the Seven Dwarfs, the 1937 Disney classic, has lost none of its original charm. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/542092d2da14abcd17bc4646c6e82e57108372b1_96k.mp3#duration=2.8&t=.mp3"
          },
          {
            "word": "selfie",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c4282186e7ee6a626ad2819d32d46731c9807316_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈselfi/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (infml.) a photo you take of yourself, esp. using a mobile phone 自拍照",
                            "example": "em>I believe posting a new selfie online every day isn't necessary."
                        }
                    ]
                }
            ]
        },
        {
            "word": "flit",
            "pee": [
                {
                    "partOfSpeech": "/flɪt/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "move lightly or quickly and not stay in one place for very long 轻快地行进；掠过",
                            "example": " In the fading light we saw bats flitting around in the garden."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7791e28a71d71bb697663cd1297b93ccd3a13799_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "attraction",
            "pee": [
                {
                    "partOfSpeech": "/əˈtrækʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) [C] sth. interesting or enjoyable to see or do 吸引人之物；有魅力之物；诱惑物",
                            "example": " The beautiful beaches are the island's main attraction."
                        },
                        {
                            "explanation": "2) [C, U] a feeling of liking sb., esp. in a sexual way 喜爱；喜欢；（尤指两性间的）爱慕",
                            "example": " The attraction between them was almost immediate."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/649fed20705ed792cd32035a014e45457f896c9f_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "script",
            "pee": [
                {
                    "partOfSpeech": "/skrɪpt/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] the written form of a speech, play, film, etc. （演讲的）原稿，讲稿；（戏剧、电影等的）剧本",
                            "example": " This actor has only just been handed the script and knows little about the show."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d6c7fec5454183afd24b1fc84a7fda0536d3f0f_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "countless",
            "pee": [
                {
                    "partOfSpeech": "/ˈkaʊntləs/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(usu. before noun) too many to be counted 无数的； 数不清的",
                            "example": " I've heard the song played countless times on the radio."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/90daa935250a7a64724500c448ce1490343b53a8_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "photography",
            "pee": [
                {
                    "partOfSpeech": "/fəˈtɒgrəfi/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the skill, job, or process of producing photographs 摄影术；摄影业；摄影",
                            "example": " After I went on a photography course, my friend asked me to take some photos of her."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f686119334852cf601a89429166bdef6fb39e4c6_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "frame",
            "pee": [
                {
                    "partOfSpeech": "/freɪm/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a structure made of wood, metal, plastic, etc. that surrounds sth. such as a picture or window, and holds it in place 框架；边框",
                            "example": " Sharon kept a photograph of her mother in a silver frame on the kitchen wall. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/017deed3a19ef0896867713044a5c6fa6838d5b2_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "standardization",
            "pee": [
                {
                    "partOfSpeech": "/ˌstædədaɪˈzeɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (BrE also standardisation) the process of making things of the same type all have the same basic features 标准化",
                            "example": " Cars have been subjected to a good deal of standardization in matters concerning safety and pollution."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/90c689b46b0ad63c3ecd5e80c9b43aa9b4d5ee4e_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "guidebook",
            "pee": [
                {
                    "partOfSpeech": "/ˈgaɪdˌbʊk/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a book that gives information for visitors about a place, such as a city or country 旅行指南；旅游手册",
                            "example": " We booked hotels in advance, since the guidebooks said that they tended to be busy."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0fe5d5efb8520bebdcfde02ba269d3fc2d05e3d6_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "picturesque",
            "pee": [
                {
                    "partOfSpeech": "/ˌpɪktʃəˈresk/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(esp. of a place) attractive in appearance, esp. in an old-fashioned way （尤指某地）美丽的，古雅的， 如画的",
                            "example": " We booked a trip to a picturesque village in Switzerland at the very beginning of the ski season."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4b4df992c74810c47c4c2d452a9a9983433bb174_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "gadget",
            "pee": [
                {
                    "partOfSpeech": "/ˈgædʒɪt/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a small device or machine with a particular purpose 小器具；小玩意儿",
                            "example": " This handy little gadget is for separating egg yolks from whites."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/adc430e40eb150afb8804942a81668ddd8999111_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "clumsy",
            "pee": [
                {
                    "partOfSpeech": "/ˈklʌmzi/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) not easy to use and is often large and heavy 难用的；笨重的",
                            "example": " The first cellphones were heavy and clumsy to use, but nowadays they are much easier to handle. "
                        },
                        {
                            "explanation": "2) moving or doing things in a careless way, esp. so that you drop things, knock into things, etc. 笨拙的； 不灵活的",
                            "example": " She was very clumsy and was always walking into doors."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c41c70333b5ab3e24bb913550f3809a421686401_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "time-consuming",
            "pee": [
                {
                    "partOfSpeech": "/ˈtaɪm kənˌsju:mɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "taking a long time to do 耗费时间的",
                            "example": " Producing a dictionary is a very time-consuming job."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/92ac399521b9502c2b57b182fab68009286744a1_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "lightweight",
            "pee": [
                {
                    "partOfSpeech": "/ˈlaɪtˌweɪt/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "weighing only a little or less than average 比通常重量轻的",
                            "example": " I need a lightweight jacket for the summer evenings."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] sb. who has no importance or influence, or who does not have the ability to think deeply — used to show disapproval 微不足道的人，无足轻重的人，思想浅薄的人（含贬义）",
                            "example": " Brian considered Sam a lightweight, a real amateur."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4a6654dbb739526112231bb927657fe720ee9a90_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "foolproof",
            "pee": [
                {
                    "partOfSpeech": "/ˈfu:lˌpru:f/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of a plan or machine) so simple and easy to understand that it is unable to go wrong or be used wrongly （计划或机器）不出问题的，不会误用的， 操作简便的",
                            "example": " The new speech recognition system is not absolutely foolproof, but it is a huge breakthrough. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/10590820b999fd90c85a4fcee626689b73813bab_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "identical",
            "pee": [
                {
                    "partOfSpeech": "/aɪˈdentɪkl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "exactly the same, or very similar 完全相同的；极为相似的",
                            "example": " The picture is identical to the one in The Museum of Modern Art in New York."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1f529bff6f8f51e1d8009bc93a90e325e301113e_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "unknown",
            "pee": [
                {
                    "partOfSpeech": "/ʌnˈnəʊn/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "not known or familiar 不知道的；不熟悉的",
                            "example": " Yesterday the village was quite unknown, but today it's on the front page of all the newspapers."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/75e947a27f02045fef5e2de1f6f05bf86755a01e_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "obscurity",
            "pee": [
                {
                    "partOfSpeech": "/əbˈskjʊərəti/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the state of not being known or remembered 无名； 默默无闻",
                            "example": " He was briefly famous in his 40s but after that his life was spent in obscurity and loneliness."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bbaef472671aa1c15a708fb00f95514074d3feb8_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "circular",
            "pee": [
                {
                    "partOfSpeech": "/ˈsɜːkjʊlə/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) traveling or occurring in a cycle 兜圈子的；循环的；循环发生的",
                            "example": " Both sides of the river can be explored on this circular walk."
                        },
                        {
                            "explanation": "2) shaped like a circle 圆形的；环形的",
                            "example": " The villa has a circular courtyard with rooms leading off it in all directions."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0b5277d98c5128e77107d1f779c5f5b171395351_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "popularization",
            "pee": [
                {
                    "partOfSpeech": "/ˈpɒpjʊləraɪˈzeɪʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (BrE also popularisation) the act or process of becoming popular or making sth. become well known and liked 普及；推广",
                            "example": " She wrote a history of the popularization of Chinese food in the US."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6d22f22a45d53cf34a6dde9c750cad79327cca3b_96k.mp3#duration=2.5&t=.mp3"
        },
        {
            "word": "lookalike",
            "pee": [
                {
                    "partOfSpeech": "/ˈlʊkəˌlaɪk/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(also look-alike) very similar in appearance to sb. / sth. else 酷似的",
                            "example": " The product has been lost in a sea of lookalike competitors."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e7c287d00c4e0881f5d12c33efe539c928cb4eb2_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "possess",
            "pee": [
                {
                    "partOfSpeech": "/pəˈzes/【vt.】(not in progressive)",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (fml.) have or own sth. 拥有，持有（某物）",
                            "example": " Because of his gambling, he lost everything he possessed."
                        },
                        {
                            "explanation": "2) (fml.) have a particular quality or ability 拥有， 具有（某品质或能力）",
                            "example": " I'm afraid he doesn't possess a sense of humor."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c880220f2b500dade7f7ccf1ce491fffb098c576_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "photogenic",
            "pee": [
                {
                    "partOfSpeech": "/ˌfəʊtəʊˈdʒenɪk/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "always looking attractive in photographs 上镜的； 上相的",
                            "example": "The building, old but photogenic, stood among oaks and pines."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6ccc3ffd2d5f1e228e3fb17db2f5c706e72924b9_96k.mp3#duration=2.5&t=.mp3"
        },
        {
            "word": "souvenir",
            "pee": [
                {
                    "partOfSpeech": "/ˌsu:vəˈnɪə/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] an object that you buy or keep to remind yourself of a special occasion or a place you have visited 纪念品；纪念物",
                            "example": " He bought a model of a red London bus as a souvenir of his trip to London."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d0355a2cbdd22489ce43a8b62a93ddcbb0e16747_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "partial",
            "pee": [
                {
                    "partOfSpeech": "/ˈpɑːʃl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) unfairly supporting one person or one group against another 偏向一方的；偏袒的；不公平的",
                            "example": " The teacher sometimes seems partial to the cute girls, which makes the boys kind of angry."
                        },
                        {
                            "explanation": "2) not complete 部分的；不完全的",
                            "example": " To our disappointment, the exhibition was only a partial success."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/25bd1082f013f34119100215d0e868793ce6c46f_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "impartial",
            "pee": [
                {
                    "partOfSpeech": "/Imˈpɑːʃl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "not involved in a particular situation, and therefore able to give a fair opinion or piece of advice 不偏不倚的；公正的",
                            "example": " Historians try to be impartial, but they cannot free themselves entirely from their own opinions."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4e9fde9377a53fd1d7be7b19639e9e6ffb3b03e6_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "superficial",
            "pee": [
                {
                    "partOfSpeech": "/ˌsu:pəˈfɪʃl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "not studying or looking at sth. carefully and only seeing the most noticeable things 肤浅的；浅薄的； 不深入的",
                            "example": " Unfortunately I only had a very superficial knowledge of music. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/76b464179fd1d76c60f53b26c146db41d5dc5715_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "sustain",
            "pee": [
                {
                    "partOfSpeech": "/səˈsteIn/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "make sth. continue to exist or happen for a period of time 保持；维持；使持续",
                            "example": " She found it difficult to catch the children's attention and sustain their interest."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c671a50944cfc6bb9e52b07f63104c1afb0957d6_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "sustained",
            "pee": [
                {
                    "partOfSpeech": "/səˈsteɪnd/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(only before noun) continuing for a long time 持久的；持续的",
                            "example": " The government can't maintain conditions for sustained growth if they do not introduce new policies."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/65413480f57b4eb438829c5546ded6db5c81c2e4_96k.mp3#duration=2.5&t=.mp3"
        },
        {
            "word": "delight",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈlaɪt/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] a feeling of great pleasure and satisfaction 欣喜； 愉悦",
                            "example": " To the audience's delight, she agreed to sing two more songs."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cc536b6ef6485ef6ca7f20c19189c25289171631_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "ivy",
            "pee": [
                {
                    "partOfSpeech": "/ˈaɪvi/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] 常春藤",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/33708b6b953ac8a3cb433e6657b0628c07ab6b6e_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "soak",
            "pee": [
                {
                    "partOfSpeech": "/səʊk/【v.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "if you soak sth., or if you let it soak, you keep it covered with a liquid for a period of time, esp. in order to make it softer or easier to clean 浸；泡",
                            "example": " The wind had blown the rain in and soaked the carpet."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/553ce14bf14c364ed32ea26de567516755850b1e_96k.mp3#duration=2.0&t=.mp3"
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "no more 	… than",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used to emphasize that sb. / sth. does not have a;particular quality or would not do sth. 根本不...；完全不...",
                              "example": "He's no more fit to be the group leader than I am."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0830f9d90b14fdbae4e90f1b6e28f903c87ce15f_96k.mp3#duration=3.4&t=.mp3"
          },
          {
              "word": "get around",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE get round) if news or information gets around, it is told to a lot of people （新闻或消息）传开",
                              "example": "Word got around that the shopping mall might be closed."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/820c0d9434ee305042966e46dee8f981438e989e_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "for instance",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "for example 例如",
                              "example": "We found out that fruit loaf (水果面包) is better than cake or chocolate, for instance. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/676a8f557fe1a897fd082714c9724aecc4349aa6_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "get the hang of sth.",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(infml.) understand the technique of doing sth. 掌握...的窍门",
                              "example": "It's not difficult once you get the hang of it. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8975b22c947aac63dbeba28bcdb70a3b00aee6db_96k.mp3#duration=2.7&t=.mp3"
          },
          {
              "word": "pull up",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "when a vehicle or driver pulls up, the vehicle slows down and stops （车辆或司机）停车",
                              "example": "The taxi pulled up and the driver jumped out."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b45b2597e5a7f80b3aacc748854f1f4325a528f5_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "as far as sb. is concerned",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8a0c155384b255e30e26d9e65841a3cc7f013bde_96k.mp3#duration=3.6&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(spoken) used to show what sb.'s opinion on a subject is or how it affects them 就某人而言；在某人看来",
                              "example": "As far as I am concerned, a change of policy is needed to reduce the unemployment rate."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "wash out",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/474ee50e57d7aebc419dd0db89f66831e960685c_96k.mp3#duration=2.3&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "wash sth. quickly, esp. the inside of a container 洗净（尤指容器内壁）",
                              "example": "When the bottle is empty, wash it out thoroughly before refilling."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "in the end",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c872de8c13a2f43e1c948c874c0cb7d0e6dfe318_96k.mp3#duration=2.7&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "after a period of time, or after everything has been done 最后；终于",
                              "example": "As long as you try hard, you'll surely succeed in the end."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "as it were",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "used when describing sb. / sth. in a way that is not quite exact 可以说是",
                            "example": " Tim became our idol, as it were, the man we all wanted to be."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d33644372d4d64103419363623237d84991ffd83_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "in the first place",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "used to talk about the beginning of a situation, or the situation before sth. happened 一开始；起初",
                            "example": " He didn't remember being given that form; they had probably not even given it to him in the first place."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1f6628ac31c0abfcc6290790589da28b099a77b3_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "set / put sth. in motion",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "make sth. start moving 让...动起来",
                            "example": " The wheels of change have been set in motion."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8c6f24fcf45bea11cb63a56d4ede6381ee88a316_96k.mp3#duration=5.6&t=.mp3"
        },
        {
            "word": "set off",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "start to go somewhere 出发；启程",
                            "example": " What time will we have to set off for Grandma's house tomorrow?"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9b25360dcf1cfefe58cba33263eb25953758b4e6_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "set out",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dbe4450e14d1de5784dd8dc9b247c4d14b4f9740_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "put a group of things down and arrange them 摆放； 陈列",
                            "example": " The market traders began setting out their displays. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "break out of",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5819195e9629dd97fe89155ed9a6ef3ac5d0f448_96k.mp3#duration=2.2&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "escape from a place or situation 逃离（某地）；摆脱（某状况）",
                            "example": " It's taken a long time to break out of my own conventional training."
                        }
                    ]
                }
            ]
        },
        {
            "word": "take one's time",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bf9550543d14162415e20c2e63f09ba2ee28c477_96k.mp3#duration=2.4&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "do sth. slowly or carefully without hurrying 从容不迫；不着急",
                            "example": " There is no need to be so anxious, so let's take our time to get things right."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "Copenhagen",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/59909d85587b31d1a3dd5ba2415d7edfbd5b3b38_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌkəʊpənˈheɪgən/",
                      "explanations_and_examples": [
                          {
                              "explanation": "哥本哈根（丹麦首都）",
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Denmark",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5d7ce289d10054fb9dd51fd3650c4493f3d35c35_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdenmɑːk/",
                      "explanations_and_examples": [
                          {
                              "explanation": "丹麦（欧洲国家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "the Netherlands",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/98bab732cdc99efe922f2b829f76ea4152b4a026_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈneðələndz/",
                      "explanations_and_examples": [
                          {
                              "explanation": "荷兰（欧洲国家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Oslo",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/63e9f0a3efd7f5b37a5c25b78f9eb8ce305a1c17_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɒzləʊ/",
                      "explanations_and_examples": [
                          {
                              "explanation": "奥斯陆（挪威首都）"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "Peter D. Osborne",
            "pee": [
                {
                    "partOfSpeech": "/ˈɒzbən/",
                    "explanations_and_examples": [
                        {
                            "explanation": "彼得 D. 奥斯本（人名）"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/523e9734308f7d2f59b4bcb840cf0040d05fb231_96k.mp3#duration=3.0&t=.mp3"
        },
        {
            "word": "Kodak",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b9433ab7c25a95649d8f495002c41fb4a74b8c2c_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈkəʊdæk/",
                    "explanations_and_examples": [
                        {
                            "explanation": "柯达（相机品牌）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "George Eastman",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/690dc353737d945de95f5d8d2518b32549d5bf30_96k.mp3#duration=2.3&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "乔治・伊斯门（美国发明家、柯达公司创办人）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Mona Lisa",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3cdf0ca9da4d9bbace5b7a61042cdca14eaec8c2_96k.mp3#duration=2.3&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "《蒙娜丽莎》（列奥纳多・达・芬奇所绘的肖像画）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "the Louvre",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/39760b62b596f1ed83e355110d20b7d11d712fc2_96k.mp3#duration=2.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈlu:və/",
                    "explanations_and_examples": [
                        {
                            "explanation": "卢浮宫（法国博物馆，位于巴黎）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Susan Sontag",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0633635ddbd008767f9296bbc14f8cd6507b2e9a_96k.mp3#duration=2.3&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈsɒntæg/",
                    "explanations_and_examples": [
                        {
                            "explanation": "苏珊・桑塔格（美国作家）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Jonas Larsen",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f341d61b27c6783f29413c584c819b2b9e929e51_96k.mp3#duration=2.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈlɑːsən/",
                    "explanations_and_examples": [
                        {
                            "explanation": "乔纳斯・拉森（人名）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Roskilde University",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/adb5d54eedcd2aa4ed2572733391de346ee40af7_96k.mp3#duration=3.1&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈrɒskɪlə/",
                    "explanations_and_examples": [
                        {
                            "explanation": "罗斯基勒大学（丹麦大学，位于西兰大区）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Nikon",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/691f83846ac2e6827384fe9ee51e41278b795130_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈnɪkɒn/",
                    "explanations_and_examples": [
                        {
                            "explanation": "尼康（相机品牌）"
                        }
                    ]
                }
            ]
        }
      ]
  }
]
book2[2] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "drip",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/53e557ac4692a43efb15bb9a98ae68cc11383d6f_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/drɪp/",
                      "explanations_and_examples": [
                          {
                              "explanation": "[vi.]fall in drops （液体）滴下，沥下",
                              "example": "She was hot and sweat dripped into her eyes."
                          },
                          {
                            "explanation": "[v.]let liquid fall in drops 滴（水）；滴下（液体）",
                            "example": "Her boots were muddy and her hair was dripping. "
                            }
                      ]
                  },
              ]
          },
          {
              "word": "breathtaking",
              "pee": [
                  {
                      "partOfSpeech": "/ˈbreθˌteɪkɪŋ/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) breathless 使人喘不过气来的",
                              "example": "She had a car accident and suffered a breathtaking pain."
                          },
                          {
                              "explanation": "2) very impressive, exciting, or surprising 激动人心的；惊人的；令人惊叹的",
                              "example": "The view from my bedroom window was absolutely breathtaking."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8289c220fd8861e1ce48b79dd2492e523c6238c7_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "fulfillment",
              "pee": [
                  {
                      "partOfSpeech": "/fʊɪˈfɪlmənt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] (BrEfulfilment) the feeling of being happy and satisfied with your life because you are doing interesting, useful, or important things 成就感；充实感",
                              "example": "Are you looking for greater fulfillment and satisfaction in your work?"
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1090e48573ef67f63f093786ea641f3fe4a3e6e9_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "joyful",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdʒɔːɪfl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "very happy, or likely to make people very happy 欢乐的；令人高兴的",
                              "example": "It was a joyful reunion of all the family."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/df34f989a13642784f61d946ddd5f7b8885a5d92_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "parallel",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpærəlel/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (fml.) similar and happening at the same time 相似的；同时发生的",
                              "example": "Social changes in Britain are matched by parallel trends in some other countries."
                          },
                          {
                              "explanation": "2) two lines, paths, etc. that are parallel to each other are the same distance apart along their whole length 平行的",
                              "example": "The railway is parallel with the canal."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3052051df2a84efb1634956d102f27e73840c9ac_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "unparalleled",
              "pee": [
                  {
                      "partOfSpeech": "/ʌnˈpærəleld/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) bigger, better, or worse than anything else 无比的；无双的；空前的",
                              "example": "They enjoyed success on a scale unparalleled by any previous pop group."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fa89ab796617fadd91e3fa6559cc43bf9ef11eb9_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "brutal",
              "pee": [
                  {
                      "partOfSpeech": "/ˈbru:tl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) not pleasant and not sensitive to people's feelings伤人的；不顾他人感受的",
                              "example": "She spoke with brutal honesty — I was too old for the job."
                          },
                          {
                              "explanation": "2) very cruel and violent 野蛮的；凶残的",
                              "example": "Jensen is a dangerous man, and can be very brutal and reckless (不顾后果的)."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/55bbea3a517b1a18c2aa9ad6ffc2985095dedf04_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "honesty",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɒnɪsti/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the quality of being honest 诚实；正直；坦诚",
                              "example": "She answered all my questions with her usual honesty."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/45efd9f75ee0d52f3635cfdedfbe8d4df890a9c6_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "unbearable",
              "pee": [
                  {
                      "partOfSpeech": "/unˈbeərəbl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "too unpleasant, painful, or annoying to deal with 难以忍受的；承受不住的；无法容忍的",
                              "example": "The atmosphere at work at the moment is quite unbearable."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9539069950c7376ac77fff888133b2d84d95279f_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "tease",
              "pee": [
                  {
                      "partOfSpeech": "/ti:z/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "laugh at sb. and make jokes in order to have fun by embarrassing them, either in a friendly way or in an unkind way 戏弄；逗弄；拿...取笑（开玩笑）",
                              "example": "I used to hate being teased about my red hair when I was at school."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d32731b4893095ef9f5ddea723ec8316d728bd85_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "taunt",
              "pee": [
                  {
                      "partOfSpeech": "/tɔːnt/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "try to make sb. angry or upset by saying unkind things to them （用语言）挑衅，侮辱，嘲弄，奚落",
                              "example": "The other children used to taunt him in the playground because he was fat and wore glasses."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/40b0dae4dfed8ced327ca15c1f2a9756758dda1f_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "tempt",
              "pee": [
                  {
                      "partOfSpeech": "/tempt/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) make sb. want to have or do sth., even though they know they really should not 诱惑；引诱；诱使",
                              "example": "Don't tempt thieves by leaving valuables clearly visible."
                          },
                          {
                              "explanation": "2) try to persuade sb. to do sth. by making it seem attractive 劝说；鼓励",
                              "example": "They tempted him to join the company by offering him a large salary and a company car."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/873acc8c87cadc7dad9796fe33e93207018cb9b9_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "loyal",
              "pee": [
                  {
                      "partOfSpeech": "/ˈlɔːɪəl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "always supporting your friends, principles, country, etc. 忠贞的；忠实的；忠诚的",
                              "example": "Jack has been a loyal worker in this company for almost 50 years."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5090fc873f92498fb9cb9b3c7a8f8f1fc42bb297_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "resist",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈzɪst/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(usu. in negatives) stop yourself from having sth. that you like very much or doing sth. that you want to do 忍住；按捺",
                              "example": "He was unable to resist the temptation to buy the wallet."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/eda39251e477c42a3f7a0425805371570a2ce3ee_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "celebration",
              "pee": [
                  {
                      "partOfSpeech": "/ˌseləˈbreɪʃn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C, U] the act of celebrating 庆祝；祝贺；颂扬",
                              "example": "This was not a memorial service but a celebration of his life."
                          },
                          {
                              "explanation": "2) [C] an occasion or party when you celebrate sth. 庆祝会；庆祝活动",
                              "example": "There were wild street celebrations when England won the Cup."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4e84f3e673917a143b2134104a9802e9ef5974de_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "alongside",
              "pee": [
                  {
                      "partOfSpeech": "/əˈlɒŋˌsaɪd/prep. ",
                      "explanations_and_examples": [
                          {
                              "explanation": "used to say that people or things do sth. or exist together at the same time 与...一起；与...同时",
                              "example": "Most of the staff refused to work alongside the new team."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "ad. & prep.",
                      "explanations_and_examples": [
                          {
                              "explanation": "next to the side of sth. 在（...）旁边",
                              "example": "He crossed the street and walked alongside the park."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cefde60f280c3dc256883f713e47bcf3c08ad748_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "addiction",
              "pee": [
                  {
                      "partOfSpeech": "/əˈdɪkʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the need to take a harmful drug regularly, without being able to stop 瘾；毒瘾",
                              "example": "He is now fighting his addiction to alcohol. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9aa6d374de333b21eb27147e7ede3e9eabcc3aa0_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "distraction",
              "pee": [
                  {
                      "partOfSpeech": "/dɪˈstrækʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C] a pleasant activity 娱乐；消遣",
                              "example": "After a long day of work, I found boating a distraction."
                          },
                          {
                              "explanation": "2) [C, U] sth. that stops you paying attention to what you are doing 使人分心的事物",
                              "example": "I study in the library as there are too many distractions at home."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cb43a7867f2388c9ed65d319510397411e8870ca_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "sunrise",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsʌnˌraɪz/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C, U] the colored part of the sky where the sun is appearing in the morning 日出；晨曦；朝霞",
                              "example": "There was a glorious sunrise over the mountains."
                          },
                          {
                              "explanation": "2) [U] the time when the sun first appears in the morning 日出（时分）；黎明；拂晓",
                              "example": "They went out at sunrise to go bird-watching."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4683c3cda569b73394a5c29ebbe52c0440cf8041_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "graciously",
              "pee": [
                  {
                      "partOfSpeech": "/ˈgreɪʃəsli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "in a polite, kind, and generous way, esp. to people of a lower rank 有礼貌地，仁慈地，和蔼地，亲切地（尤指对较低阶层的人们）",
                              "example": "Mr. Martel graciously agreed to take time out of his busy schedule to answer some questions."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c3b2fb7e10e9dce95fa14d1ab2afac4764f05769_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "weaken",
              "pee": [
                  {
                      "partOfSpeech": "/ˈwi:kən/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) make sb. lose their physical strength, or becomephysically weak （使）（某人）虚弱（衰弱）",
                              "example": "Elsa was weakened by her long illness."
                          },
                          {
                              "explanation": "2) make sb. / sth. less powerful or less important, or become less powerful （使）变弱，削弱，减弱",
                              "example": "The new evidence weakens the case against her."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/76396470417fde32dc31426a85f47e44a4285644_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "bump",
              "pee": [
                  {
                      "partOfSpeech": "/bʌmp/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a small raised area on a surface 凸起；隆起； 鼓包",
                              "example": "Her bicycle hit a bump in the road and threw her off."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "v.",
                      "explanations_and_examples": [
                          {
                              "explanation": "hit or knock against sth. 碰；撞",
                              "example": "Tim was a clumsy boy, always bumping into the furniture."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9e3e9e20fc2a8f10bc7d32469027ddedf1b97d27_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "foreshadow",
              "pee": [
                  {
                      "partOfSpeech": "/fɔːˈʃædəʊ/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "show or say that sth. will happen in the future 预示；是...预兆",
                              "example": "The recent outbreak of violence was foreshadowed by isolated incidents in the city earlier this year. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/157325901e763e4a932dea5e940ab06ac1882007_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "sideline",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsaɪdˌlaɪn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (on / from the sidelines) not taking part in an activity even though you want to or should do 置身事外；袖手旁观；当旁观者",
                              "example": "You can't stay on the sidelines for ever; it’s time you got involved."
                          },
                          {
                              "explanation": "[C] an activity that you do as well as your main job or business, in order to earn more money 副业； 兼职",
                              "example": "Jim works in a bank, but teaches French in the evenings as a sideline."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/68ead1005b08557a6cf759ab86600cabb4adde29_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "permanently",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpɜːmənəntli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "always, or for a very long time 永久地；长久地",
                              "example": "Michael and his family have settled permanently in the States."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e08680aa81060eaf00b08fa6d1ef67c7b3eeb14e_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "shrink",
              "pee": [
                  {
                      "partOfSpeech": "/ʃrɪŋk/(shrank, shrunk)vi.",
                      "explanations_and_examples": [
                          {
                              "explanation": "(always + ad. / prep.) move back and away from sth., esp. because you are frightened （尤因恐惧而） 退缩，畏缩",
                              "example": "His anger was enough to make the others shrink away from him."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "v.",
                      "explanations_and_examples": [
                          {
                              "explanation": "become smaller, or make sth. smaller, through the effects of heat or water （使）缩小；（使）收缩",
                              "example": "Your sweater will shrink if you wash it at too high a temperature."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d4c154d077a6def73d34aaeb263a10560723a83d_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "tackle",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtækl/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "try to deal with a difficult problem 处理，对付（难题）",
                              "example": "There is more than one way to tackle the problem."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2d3cb66d25fc404b33cc59efbe491061dbd3bbd0_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "prospect",
              "pee": [
                  {
                      "partOfSpeech": "/ˈprɒspekt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the possibility that sth. will happen 可能性；希望",
                              "example": "There is every prospect of the weather remaining dry this week."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/006dadd2041b2a2fdc3d30e6ae3274c3ff526cc3_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "curve",
              "pee": [
                  {
                      "partOfSpeech": "/kɜːv/【n.】[C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) a bend in a road, river, etc. （道路、河流等的）弯曲处",
                              "example": "As he rounded the curve he saw her standing by the gate."
                          },
                          {
                              "explanation": "2) a line that gradually bends like part of a circle 曲线；弧线",
                              "example": "The seats were arranged to form a curve."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cab1fb167d23ad80adfde101d210143dcef8cdcb_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "hurdle",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhɜːdl/【n.】[C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) one of a series of small fences that a person or horse has to jump over during a race （跨栏赛跑或马术比赛中用的）栏架",
                              "example": "She cleared all the hurdles easily and raced to the finishing line."
                          },
                          {
                              "explanation": "2) a problem or difficulty that you must deal with before you can achieve sth. 障碍；困难",
                              "example": "Finding enough money for the project was the first hurdle."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d1cf72ea15178741265d0ee9dcf577194c268af_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "split",
              "pee": [
                  {
                      "partOfSpeech": "/splɪt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (infml.) the end of a marriage or relationship — used esp. in newspapers and magazines 离婚，分手（尤作报刊用语）",
                              "example": "She seems to be getting over her recent split with her fiancé . "
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "v.",
                      "explanations_and_examples": [
                          {
                              "explanation": "(split, split) divide, or make a group of people divide, into smaller groups that have very different opinions （组织内部）产生分歧，分裂",
                              "example": "The party is split over the issue of immigration."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/337b07a1f44241b0e5c7dd1073e6e7a6933d0cdb_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "crack",
              "pee": [
                  {
                      "partOfSpeech": "/kræk/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "break or make sth. break, either so that it gets lines on its surface, or so that it breaks into pieces （使）破裂；（使）裂开",
                              "example": "Due to her carelessness, she fell and cracked a bone in her leg."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/012075a62d34152a53f9de30cce9fa8211d4ced5_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "cracked",
              "pee": [
                  {
                      "partOfSpeech": "/krækt/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "having one or more lines on the surface because it is damaged but not completely broken 有裂缝的； 有裂痕的",
                              "example": "She passed her tongue over her cracked lips and tried to speak."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f301ec1a777602d92750393d867aaeb02713ba40_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "hike",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3697b0c8d1fd144d82e2f37349e9a265406a374a_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/haɪk/【v.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "take a long walk in the mountains or countryside （在...）徒步旅行，远足",
                            "example": " His dream is to hike the world's highest mountain."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a long walk in the mountains or countryside （在山区或乡间的）徒步旅行，远足",
                            "example": " We went for a hike through the woods on Sunday. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "botany",
            "pee": [
                {
                    "partOfSpeech": "/ˈbɒt(ə)ni/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] 植物学",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9102ecabf872e5efcdc90fe3430aaf5d7a39635f_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "safekeeping",
            "pee": [
                {
                    "partOfSpeech": "/ˌseɪfˈki:pɪŋ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the state of being kept safe, or the action of keeping sth. safe 安全保管 ; 妥善保管",
                            "example": " My passport was in the inner pocket of my bag, for safekeeping."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/64431093cb4252233e49ee4c6b8c44c5276319c2_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "hobbyist",
            "pee": [
                {
                    "partOfSpeech": "/ˈhɒbiɪst/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a person who is very interested in a particular hobby 爱好者",
                            "example": " The computer hobbyists are going to love this project."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9e87c6e4744910cb2f4c876ce2656d710df512be_96k.mp3#duration=1.2&t=.mp3"
        },
        {
            "word": "pine needle",
            "pee": [
                {
                    "partOfSpeech": "/ˈpaɪn ˌni:dl/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 松针；松叶",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1adbf9555ab18dbd0f9948cc356ba26e23e0c349_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "weave",
            "pee": [
                {
                    "partOfSpeech": "/wi:v/【v.】(wove, woven)",
                    "explanations_and_examples": [
                        {
                            "explanation": "make cloth, a carpet, a basket, etc. by crossing threads or thin pieces under and over each other by hand or on a loom 编；织",
                            "example": " This type of wool is woven into fabric which will make jackets."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fc5c8fc73810b6d717fb62e2af758878dccd0c3f_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "merge",
            "pee": [
                {
                    "partOfSpeech": "/mɜːdʒ/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "if two things merge, or if one thing merges into another, you cannot clearly see them, hear them, etc. as separate things 相融；融入；渐渐消失在另一物中",
                            "example": "The hills merged into the dark sky behind them."
                        }
                    ]
                },
                {
                    "partOfSpeech": "v.",
                    "explanations_and_examples": [
                        {
                            "explanation": "combine, or join things together to form one thing 合并；融合",
                            "example": " The banks are set to merge next year."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d4fb87ee556abf4967d19e8373fcbcb6b453f2a8_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "indistinguishable",
            "pee": [
                {
                    "partOfSpeech": "/ˌɪndɪˈstɪŋgwɪʃəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "not able to be identified as different or distinct 难以分辨的；难以区分的",
                            "example": " The male of the species is almost indistinguishable from the female."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/53bfbe54960a175364068debfc68e6f270ccad32_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "productivity",
            "pee": [
                {
                    "partOfSpeech": "/ˌprɒdʌkˈtɪvəti/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the rate at which goods are produced, and theamount produced, esp. in relation to the work, time, and money needed to produce them 生产率；生产效率；生产量；生产力",
                            "example": " Studies show that if a working environment is pleasant, productivity increases."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/852af898805bb7028d535440db31828e0ed2683d_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "fragility",
            "pee": [
                {
                    "partOfSpeech": "/frəˈdʒɪləti/【n.】[U]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) the state of being weak or uncertain, and likely to become worse under pressure （形式）脆弱，不稳定",
                            "example": " The collapse of the bank is an reminder of the fragility of the world’s banking system."
                        },
                        {
                            "explanation": "2) the state of being easily broken or damaged 脆弱；易碎；易损坏",
                            "example": " A deficiency of copper (缺铜) can cause increased bone fragility."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/41bed710303e56362d6cbf107e14eea3ce689db9_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "accessible",
            "pee": [
                {
                    "partOfSpeech": "/əkˈsesəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) easy to obtain or use 易得到的；易使用的",
                            "example": " I had to keep the video camera readily accessible in case I saw something that needed to be filmed."
                        },
                        {
                            "explanation": "2) easy to reach or get into 易到达的；易进入的",
                            "example": " The remote desert area is only accessible by helicopter (直升机)."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/91216500615477ca429f95977eefc4f2ec4c0dcd_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "corporation",
            "pee": [
                {
                    "partOfSpeech": "/ˌkɔːpəˈreɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a big company, or a group of companies acting together as a single organization 大型公司；企业集团",
                            "example": " She didn't want to work for a big corporation where everything was so impersonal."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cca2f2363a18975b3f98d86cc53820cae4003d60_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "disposable",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈspəʊzəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) available to be used 可以使用的",
                            "example": " The nation's disposable earnings amounted to 586 billion dollars."
                        },
                        {
                            "explanation": "2) intended to be used once or for a short time and then thrown away 一次性的 ; 用完即弃的",
                            "example": " She joined Kiley at the counter, holding a disposable cup with coffee in it."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/58b33eb257799b1f2dab2c1bc0c8c439f8c67d60_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "amusement park",
            "pee": [
                {
                    "partOfSpeech": "/əˈmju:zmənt ˌpɑːk/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 游乐场",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c633af7397cf5209c9008c3e12d2c01af2a2ee0d_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "emerge",
            "pee": [
                {
                    "partOfSpeech": "/ɪˈmɜːdʒ/【vi.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) start to exist; appear or become known 兴起；开始被人所知",
                            "example": " The state emerges as a leader in the field of next-generation energy."
                        },
                        {
                            "explanation": "2) appear or come out from somewhere 出现；浮现",
                            "example": " The doors opened and people began to emerge into the street."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/49166a29f814a6488659e0648768b6b038ebe01c_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "privilege",
            "pee": [
                {
                    "partOfSpeech": "/ˈprɪvəlɪdʒ/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a special advantage that is given only to one person or group of people 特权；特殊待遇",
                            "example": " Senior management enjoys certain privileges, such as company cars and private healthcare."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b76a1638bfc9580db25d7ce6856ec03b3e1c663f_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "wealthy",
            "pee": [
                {
                    "partOfSpeech": "/ˈwelθi/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (the ~) [pl.] people who have a lot of money, possessions, etc. 有钱人；富人",
                            "example": " The best education should not be available only to the wealthy. "
                        },
                        {
                            "explanation": "2) having a lot of money, possessions, etc. 富有的；有钱的",
                            "example": " He left as a poor, working class boy and returned as an extremely wealthy man."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f3253c61d3f166074c61136f1b7af4242566bd35_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "automatic",
            "pee": [
                {
                    "partOfSpeech": "/ˌɔːtəˈmætɪk/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of a device or process) working by itself with little or no direct human control （装置或流程）自动的",
                            "example": " The door we escaped through had an automatic lock but we didn't know that. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b04f973b2d2aef74bea2882816f6e4bcb4cefbf4_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "unrest",
            "pee": [
                {
                    "partOfSpeech": "/ʌnˈrest/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] a political situation in which people protest or behave violently 动荡；动乱；骚动",
                            "example": " Due to the economic downturn, there's growing social unrest in the country."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/63feaace8def65d3d92dbadb70f4a0c4b128b76d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "shortage",
            "pee": [
                {
                    "partOfSpeech": "/ˈʃɔːtɪdʒ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] a situation in which there is not enough of sth. that people need 短缺；不足；缺乏",
                            "example": " The long hot summer has led to serious water shortages."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0fd6b002e6a81af5ee30ebd5eaa1e2bbd4f700ce_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "recession",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈseʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] a difficult time when there is less trade, business activity, etc. in a country than usual （经济）衰退， 萧条",
                            "example": " We should concentrate on sharply reducing interest rates to pull the economy out of recession. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8714ace1853a9114b097773839ebe93b5c08189_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "discontented",
            "pee": [
                {
                    "partOfSpeech": "/ˌdɪskənˈtentɪd/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "unhappy or not satisfied with the situation you are in 不满的；不满足的；不愉快的",
                            "example": " He felt discontented with the way his life had turned out."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0502570ec592826ea223b9ba41c63befd139f331_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "enjoyable",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈdʒɔːɪəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "giving pleasure 令人愉快的；令人快乐的",
                            "example": " We spent an enjoyable evening talking about old times."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/77eb4cda42f49ed65a3759ee62ce9fc2dd2cbe4a_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "inevitable",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈevɪtəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "certain to happen and impossible to avoid 必然发生的；不可避免的",
                            "example": " It was an inevitable consequence of the decision."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/86b5868953e862894901d24179153e18ec181e16_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "equate",
            "pee": [
                {
                    "partOfSpeech": "/ɪˈkweɪt/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "consider that two things are similar or connected 使等同；同等看待",
                            "example": " I'm always wary (小心翼翼的) of men wearing suits, as I equate this with power and authority."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4fd023c5fc6d158979ca992e509cf445f2312f08_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "dual",
            "pee": [
                {
                    "partOfSpeech": "/ˈdju:əl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(only before noun) having two of sth. or two parts 双的；双重的；两部分的",
                            "example": " The piece of furniture serves a dual purpose as a cupboard and as a table."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b091e57455c2d73f53f06af5c7f0a275eacd1de6_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "duality",
            "pee": [
                {
                    "partOfSpeech": "/dju:ˈæləti/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (fml.) the state of having two of sth. or two parts 双重性",
                            "example": " His poems reveal the duality of his nature, the joy and hope, the fear and despair."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d76340b7423e07f954372dc55ddf2b7a72944c72_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "utopian",
            "pee": [
                {
                    "partOfSpeech": "/ju:ˈtəʊpiən/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "having a strong belief that everything can be perfect, often in a way that does not seem to be realistic or practical 乌托邦的；空想完美主义的",
                            "example": " He was pursuing a utopian dream of world prosperity."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1372dcb1b09f603b6ed43304cdbddddf5aaf943d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "side hustle",
            "pee": [
                {
                    "partOfSpeech": "/ˈsaɪd ˌhʌsl/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (mainly AmE, infml.) a piece of work or a job that you get paid for doing in addition to doing your main job 副业",
                            "example": " Even if you love your job and find your work fulfilling, you can still benefit from a side hustle."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cdc239b044b806c555f9055894fa007437f8b5c4_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "regarding",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈgɑːdɪŋ/prep.",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) concerning sb. / sth.; about sb. / sth. 关于",
                            "example": " Regarding your recent inquiry, I have sent you a copy of our new brochure."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/10fa66aafd10cbacec9d0cdcba9abbd38ce38eb4_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "boundary",
            "pee": [
                {
                    "partOfSpeech": "/ˈbaʊnd(ə)ri/【n.】[C]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) the point at which one feeling, idea, quality, etc. stops and another starts （不同情感、思想、品质等之间的）分野，分界线",
                            "example": " The boundaries between history and storytelling are always being blurred."
                        },
                        {
                            "explanation": "2) the real or imaginary line that marks the edge of a state, country, etc., or the edge of an area of land that belongs to sb. 分界线；边界",
                            "example": " The Mississippi River forms a natural boundary between Iowa and Illinois."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2d64232fb0e74a80f0851a91739544f891ea9dad_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "sake",
            "pee": [
                {
                    "partOfSpeech": "/seɪk/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (for the ~ of sb. / sth., for sb.'s / sth.'s ~) in order to help, improve, or please sb. / sth. 为了某人/某事的缘故",
                            "example": " Their parents only stayed together for the sake of the children. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0d97542aa405ed300f6f775ec379cb5e6eab4c9a_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "meditative",
            "pee": [
                {
                    "partOfSpeech": "/ˈmedɪtətɪv/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) relating to the practice of emptying your mind of thoughts and feelings, in order to relax completely or for religious reasons 冥想的；默想的",
                            "example": " She closed her eyes and went into a meditative state."
                        },
                        {
                            "explanation": "2) thinking deeply and seriously about sth.; involving deep thought 深思的；沉思的；思考的",
                            "example": " When he entered the room, she was in a meditative mood."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8b3a6e8dc9c6a45b1bb581fe8a4864f390e8b29d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "paycheck",
            "pee": [
                {
                    "partOfSpeech": "/ˈpeɪtʃek/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (BrE paycheque) (esp. AmE) the amount of wages sb. earns 薪金；工资",
                            "example": " The new bill could mean a larger paycheck for state employees."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9b592203a181eceaf3c77396b8888e126806ca1e_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "ruin",
            "pee": [
                {
                    "partOfSpeech": "/ˈru:ɪn/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "spoil or destroy sth. completely 毁坏；毁掉；糟蹋",
                            "example": " Huge modern hotels have ruined this once undisturbed coastline."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/70f82a7191d9b9b65f0a5514d5a6441f187f3d3a_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "purity",
            "pee": [
                {
                    "partOfSpeech": "/ˈpjʊərəti/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the quality or state of being pure 纯；纯洁；洁净；纯正；纯粹",
                            "example": " The color white is the color of purity and that is why women typically wear white when they get married."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/93c0d48e6a3a8a3b8623f8f1315e14414683e228_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "enhance",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/16535a54ed9a902004fde8bf2aa7766d8e0da246_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈhɑːns/【vt.】>",
                    "explanations_and_examples": [
                        {
                            "explanation": "improve sth. 改善；改进",
                            "example": " The measures taken should considerably enhance the residents' quality of life."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "by choice",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "if you do sth. by choice, you do it because you want to do it and not because you are forced to do it 自己选择的；自愿的",
                              "example": "She repeated that she was very comfortable and lived here by choice."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c149c03c823cc7021c66f50bf2107bacb3f44ae1_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "(all) to oneself",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "for only sb. to have or use; not shared 独有；专用",
                              "example": "I'm going out, so you’ll have the place to yourself. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/42088cfa838108c6e3f13a8c4aa22bbd81bf73f4_96k.mp3#duration=4.5&t=.mp3"
          },
          {
              "word": "run out (of)",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "1) use all of sth. and not have any more left 用完， 耗尽（某物）",
                              "example": "Few of us would know what to do if the supermarkets ran out of food."
                          },
                          {
                              "explanation": "2) (of a supply of sth.) be used up （供应品）被用完， 被耗尽",
                              "example": "We must act now because time is running out."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/46ad49bb368b2a0a1bf1137722bdc6e1ebed02cd_96k.mp3#duration=3.5&t=.mp3"
          },
          {
              "word": "be sick (and tired) of",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(also be sick to death of) (spoken) be angry or bored with sth. that has been happening for a long time 对某事感到气愤（厌倦）",
                              "example": "She has had the same job for years and is heartily sick of it."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c7d872b0679ad96ad367a49366804f7fa4e6b6e6_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "take sth. out on sb.",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "treat sb. badly when you are angry or upset, even though it is not their fault 向（某人）发泄（不满等）； 拿（某人）出气",
                              "example": "When he's under pressure at work, he takes it out on me. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/274479c3de394084ac9227d3333812dace04ed23_96k.mp3#duration=3.3&t=.mp3"
          },
          {
              "word": "a bump in the road",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(infml.) a problem that arises and interferes with forward progress (usu. only temporarily) 前进中的问题（通常是暂时的）",
                              "example": "The project hit a bump in the road when Tom suddenly resigned."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2e70cc1c7d71daf6a9cee1d1d467f0fdb559c2e6_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "move on",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2131cba5e3d241f8f9fac885f2bfc20083f85313_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "start doing or discussing sth. new 开始做（别的事）； 换话题",
                              "example": "When you finish, move on to the next exercise."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "stand on one's own (two) feet",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c562d692349817fda4d1369e6e163fe867ff570a_96k.mp3#duration=2.8&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "be able to do what you need to do, earn your own money, etc. without help from others 自立；独立自主",
                              "example": "Jack's never learned to stand on his own two feet. "
                          }
                      ]
                  }
              ]
          },
          {
            "word": "by nature",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "essentially or innately 生性",
                            "example": " She was by nature a very sensitive person."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5b21744da5269eb1fe4c51e1d34001e067c1ee84_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "have a hard time doing sth.",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "be difficult for sb. to do sth. 做某事很难",
                            "example": " I had a hard time persuading him to accept the offer."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/796da209d510c341c8b5a0093544a4784cc108a7_96k.mp3#duration=3.2&t=.mp3"
        },
        {
            "word": "lead sb. to do sth.",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "cause sb. to do sth. 导致某人做某事",
                            "example": "What led him to reconsider his position? "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9d4112c7ada65923334a323f00cb71fcf21a5bf6_96k.mp3#duration=3.6&t=.mp3"
        },
        {
            "word": "look to",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "depend on sb. to provide help, advice, etc. 指望；依靠",
                            "example": " They're looking to the new manager to make the company profitable."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6e879f8cd2ab222e55ae61df78fbb7b1dfda07f7_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "make a difference",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9dc63bb116da1ae1ea93143b4b4b82f9cbd79541_96k.mp3#duration=2.2&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "",
                    "explanations_and_examples": [
                        {
                            "explanation": "have an important effect or influence on sb. / sth 有作用；有影响",
                            "example": " Where you live can make such a difference to the way you feel."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
    "name": "Proper names",
    "children": [
        {
            "word": "Erik Barnouw",
            "pee": [
                {
                    "partOfSpeech": "/ˈbɑːnaʊ/",
                    "explanations_and_examples": [
                        {
                            "explanation": "埃里克・巴尔诺 ( 美国广播电视史学家、作家 )"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ac6bfd19f8d8dd23624f6bfaa8b54f65981f2033_96k.mp3#duration=2.2&t=.mp3"
        }
    ]
  }
]

book2[3] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "generalization",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a7ecb4df34630da6a4942efd6382913670592243_96k.mp3#duration=2.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdʒen(ə)rəlaɪˈzeɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (BrE also generalisation) a statement about all the members of a group that may be true in some or many situations but is not true in every case （片面的）概括，泛论",
                              "example": " You can't make generalizations about what men and women are like."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "myth",
              "pee": [
                  {
                      "partOfSpeech": "/mɪθ/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] an idea or story that many people believe, but which is not true （许多人相信的）错误观念 , 荒诞说法",
                              "example": " Contrary to popular myth, women are not worse drivers than men."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1e776068c7679f12d58888e3fa514fb2381a8c47_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "spouse",
              "pee": [
                  {
                      "partOfSpeech": "/spaʊs/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (fml.) a husband or wife 配偶",
                              "example": " Please notice that spouses are welcome to the company picnic."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c049969f2ac27efd9b5d3a94b559afb5816b68d9_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "spousal",
              "pee": [
                  {
                      "partOfSpeech": "/ˈspaʊzl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) (only before noun) connected with a husband or wife; of or from a husband or wife 配偶的",
                              "example": " Here are the 10 things you should never say in a spousal argument."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c1902f08e4440e823468d853f75c1d03c3429b82_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "frustrated",
              "pee": [
                  {
                      "partOfSpeech": "/frʌˈstreɪtɪd/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "feeling annoyed and impatient because you cannot do or achieve what you want 懊丧的；懊恼的；沮丧的",
                              "example": " Stacy got so frustrated that she stood up and walked out of the room."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bf8b20cbbbc8b890ab710dd75b8624ce94f84c25_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "validity",
              "pee": [
                  {
                      "partOfSpeech": "/vəˈlɪdəti/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the state of being logical and true 符合逻辑；正当；正确",
                              "example": " We had serious doubts about the validity of their argument."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/907f85d3db0c93e5a1abd81c97139dcc2ea58ae5_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "stem",
              "pee": [
                  {
                      "partOfSpeech": "/stem/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(~ from) develop as a result of sth. else 源于；来自；由...引起",
                              "example": " Part of the education problem stems from the fact that class sizes have increased dramatically in the last five years."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C]（植物的）茎，梗，柄",
                                "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ee9f258fa8170258dab7fefecb5fb9aeb38639cc_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "forage",
              "pee": [
                  {
                      "partOfSpeech": "/ˈfɒrɪdʒ/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "go around searching for food or other supplies （为找到食物、补给等）四处搜寻",
                              "example": "When it's cold and snowy outside, birds may forage for food in your backyard."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e73a9c24d34df7e810a09c5b7896ac4bca56bb10_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "millennium",
              "pee": [
                  {
                      "partOfSpeech": "/mɪˈleniə/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (pl. millennia) a period of 1,000 years 一千年；千年期",
                              "example": " The year 2000 was celebrated as the beginning of the third millennium."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9692d3f4a1ac766a5fc6d719e261fff8e7a89eb1_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "instinctive",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈstɪŋktɪv/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "based on instinct, not thought or training 本能的；直觉的；天性的",
                              "example": " Animals provide the best examples of instinctive behavior."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a486d17dd2440de355d6aa0bf90f8185b74490aa_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "mode",
              "pee": [
                  {
                      "partOfSpeech": "/məʊd/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (fml.) a particular way or style of behaving, living, or doing sth. 方式；方法；做法",
                              "example": " Many children recognize that cycling and walking are environmentally-friendly modes of transportation."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5f1ba2c704c6440ad744d966db7be64ebd0516f2_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "nutrition",
              "pee": [
                  {
                      "partOfSpeech": "/nju:ˈtrɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the process of giving or getting the right type of food for good health and growth 营养（作用）；滋养",
                              "example": " It is widely known that nutrition and exercise are essential to fitness and health."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a1b9aea63597490d2d2bf30947d61a9fd2931489_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "nutritious",
              "pee": [
                  {
                      "partOfSpeech": "/nju:ˈtrɪəs/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(of food) containing many of the substances which help the body to grow （食物）有营养的，营养丰富的",
                              "example": " The cookbook contains many simple yet highly nutritious meals."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/69d3559b663ace2dbc097b4f49c9784fce75579e_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "edible",
              "pee": [
                  {
                      "partOfSpeech": "/ˈedɪbl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "fit or suitable to be eaten; not poisonous 适宜食用 的；（无毒而）可以吃的",
                              "example": " There are many edible fruits growing wild in the coastal forest."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/654f9f39471ea2894d07ea73400075b6e63c7c46_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "discard",
              "pee": [
                  {
                      "partOfSpeech": "/dɪsˈkɑːd/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "get rid of sth. 扔掉；弃置",
                              "example": "Would you help me remove the seeds from the melon and discard them?"
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/09740de1593ecd8659d17e19c5daec5178449cc0_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "laden",
              "pee": [
                  {
                      "partOfSpeech": "/ˈleɪdn/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "heavily loaded with sth. 载满的；装满的",
                              "example": " He was surprised to find that the tables were laden with food."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b2170158e7119026e0b47cd1c1762fe40c216767_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "heritage",
              "pee": [
                  {
                      "partOfSpeech": "/ˈherɪtɪdʒ/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U, sing.] the traditional beliefs, values, customs, etc. of a family, country, or society （文化）遗产；传统",
                              "example": " These works of art are of great importance to Russia's national heritage."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c021ee4a25c7633b95b2c85d721df9c999e3e545_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "prehistoric",
              "pee": [
                  {
                      "partOfSpeech": "/ˌpri: ˈhɪˈstɒrɪk/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "relating to the time in history before anything was written down 史前的；有历史记载以前的",
                              "example": " We do not have to go back to prehistoric times to witness the change in our diet."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d6aaf808b8b5809f1ac397ef35fe58685f13367a_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "acquisition",
              "pee": [
                  {
                      "partOfSpeech": "/ˌækwɪˈzɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C] sth. that you buy or obtain, often to add to things that you already have 购置物；获得物",
                              "example": " The Art Society is holding an exhibition of recent acquisitions."
                          },
                          {
                              "explanation": "2) [U] the process by which you gain knowledge or learn a skill （知识、技能的）获得，习得",
                              "example": " We need to recognize that second language acquisition is a gradual developmental process."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3097b18429dfdcff4da2d98133247741976d6475_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "humid",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhju:mɪd/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(of the air or climate) warm and damp （空气或气候）温暖潮湿的，湿热的",
                              "example": "It was a hot, humid day, and the only sound was the buzzing of insects."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f72c46fcf6a6c6bb359681c9e7c9d6248ee9d9cc_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "trait",
              "pee": [
                  {
                      "partOfSpeech": "/treɪt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (fml.) a particular quality in sb.'s character （某人性格中的）特性，品质",
                              "example": " It's a human trait to joke about subjects that make us uncomfortable."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3b058e95aaa5e4bc09b286eebf860307b1fdaa7c_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "tendency",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtendənsi/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] an inclination toward a particular characteristic or type of behavior 趋势；趋向；倾向",
                              "example": " For students, there is a tendency to socialize in the evenings."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3bcde1b3c8591c879996b17f80b3e67632b64b95_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "anthropologist",
              "pee": [
                  {
                      "partOfSpeech": "/ˌænθrəˈpɒlədʒɪst/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a person who studies anthropology 人类学家",
                              "example": " Anthropologists study the origin, development, and functioning of human societies and cultures."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e0e24c319648c9d34963bf6eda6d80c59ccf4f91_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "similarity",
              "pee": [
                  {
                      "partOfSpeech": "/ˌsɪməˈlærəti/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the state of being almost the same, or a particular way in which sth. is almost the same 相似性；类似性；相似处；相似点",
                              "example": " The police are checking for similarities with other recent attacks in the area."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9e32644cabe74328bdf5b6b7388c961b9fcd8c60_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "ancestor",
              "pee": [
                  {
                      "partOfSpeech": "/ˈænsestə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a member of your family who lived a long time ago 祖先；祖宗",
                              "example": " Although I'm British myself, my ancestors were actually French."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3b7b8c87dbe69b71b380c4b9b0e1320dc0d9fe6a_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "ancestral",
              "pee": [
                  {
                      "partOfSpeech": "/ænˈsestrəl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "of, relating to, or inherited from an ancestor 祖先的",
                              "example": " The house is the ancestral home of Baron Stourton, but after the family moved out in the 1960s it fell into disrepair."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6cd87ad1233f8dc5e8f2016d6d9d07d3a1f8b35e_96k.mp3#duration=2.9&t=.mp3"
          },
          {
              "word": "inclined",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈklaɪnd/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(be ~ to do sth.; be ~ to sth.) be likely to do sth. or behave in a particular way 有做某事的意向；倾向于做某事",
                              "example": " They'll be more inclined to listen carefully if you don't shout."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/413a3ff23c4cd34f67ba35adea711da7c11a9cac_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "extended",
              "pee": [
                  {
                      "partOfSpeech": "/ɪkˈstendɪd/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(only before noun) long or longer than usual or expected 较长时间的；延期的",
                              "example": " If you are going abroad for an extended period of time, you should consider renting your house out."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c8bc816ef70756760222653e2ff14268ba7b61a8_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "empirical",
              "pee": [
                  {
                      "partOfSpeech": "/ɪmˈpɪrɪkl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(only before noun) based on experiments or experience rather than ideas or theories 以实验（经验）为依据的；经验主义的",
                              "example": " There is strong empirical evidence to suggest that these concerns are not trivial."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/995fd5e2d316333df6fdafecbc1c9dd41aa28483_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "justification",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdʒʌstɪfɪˈkeɪʃn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a good reason why sth. exists or is done 正当理由",
                              "example": " I can see no possible justification for any further tax increases."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/698a10eb61af29331304fdf6f3fc23bcedeeb580_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "inherit",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈherɪt/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "have qualities, physical features, etc. that are similar to those of your parents, grandparents, etc. 经遗传获得（品质、身体特征等）",
                              "example": " Mr. Grass inherited his work ethic from his father."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "v.",
                      "explanations_and_examples": [
                          {
                              "explanation": "receive money, property, etc. from sb. when they die 继承（金钱、财产等）",
                              "example": " He inherited a large sum of money from his grandmother about 10 years ago. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9ff148b66af5c9704549f289b622574c12aae0a8_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "sensible",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsensəbl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "reasonable, practical, and showing good judgment 明智的；合理的；实际的；有判断力的",
                              "example": " People are far more sensible about what and how much they drink these days."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fe81cd7df79d084c9edfeb3571af8ea8a09286a9_96k.mp3#duration=2.2&t=.mp3"
          },
          {
            "word": "stereotype",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6101fbeca4537109d72e53a751268710743655d8_96k.mp3#duration=2.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈsteriəˌtaɪp/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a belief or idea of what a particular type of person or thing is like 模式化的思想；老一套；旧框框",
                            "example": " Current evidence indicates that older people are more healthy than popular stereotypes suggest."
                        }
                    ]
                }
            ]
        },
        {
            "word": "prominence",
            "pee": [
                {
                    "partOfSpeech": "/ˈprɒmɪnəns/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the fact of being important and well-known 重要；杰出；著名",
                            "example": " His rise to prominence would not have been possible without the war."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1aeff861eb6452e010579f742df70aa242b729c8_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "sentiment",
            "pee": [
                {
                    "partOfSpeech": "/ˈsentɪmənt/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) [U] feelings of pity, love, sadness, etc. that are often considered to be too strong or not suitable for a particular situation 多愁善感；感情因素",
                            "example": " He was overwhelmed by sentiment as he thought of his wife."
                        },
                        {
                            "explanation": "2) [C, U] (fml.) an opinion or feeling you have about sth. 意见；观点；感想",
                            "example": " Public sentiment is against any change to the law. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1ed047cdb643760f5cf4e358c5e01d63313b95b6_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "feminine",
            "pee": [
                {
                    "partOfSpeech": "/ˈfemənɪn/",
                    "explanations_and_examples": [
                        {
                            "explanation": "having the qualities or appearance considered to be typical of women; connected with women （指气质或外貌）女性特有的；女性的",
                            "example": " Amelia's report describes the experience from a feminine point of view."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4fca84fe66ae98fbdcb1a3353b6bd44022465db0_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "literary",
            "pee": [
                {
                    "partOfSpeech": "/ˈlɪt(ə)rəri/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "connected with literature 文学的；文学上的",
                            "example": " In a literary essay, you should explore the meaning and construction of the text."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2e5d12d777153f2f28beda81710192552b470dde_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "maternal",
            "pee": [
                {
                    "partOfSpeech": "/məˈtɜːnl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "having feelings that are typical of a caring mother toward a child 母性的；母亲般慈爱的",
                            "example": " She seems to have a strong maternal instinct."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/551c313ff6a994c2155f289980656d34fdc61b5d_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "excessively",
            "pee": [
                {
                    "partOfSpeech": "/ɪkˈsesɪvli/【ad.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "to a much greater level or degree than seems reasonable or appropriate 过度地；过多地",
                            "example": " The country relies excessively on borrowing from abroad."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ec631bbf432fb7a1f1dffe6dcee02af35cb629af_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "gender",
            "pee": [
                {
                    "partOfSpeech": "/ˈdʒendə/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] the fact of being male or female 性别",
                            "example": " It is a country where gender roles have remained largely unchanged."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0a77b9a758e9e3e944486a8157e3dfc66119ef5e_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "inequality",
            "pee": [
                {
                    "partOfSpeech": "/ˌɪnɪˈkwɒləti/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] the unfair difference between groups of people in society, when some have more wealth, status, or opportunities than others 不平等；不平衡；不平均",
                            "example": " There has been an increase in economic inequality between different areas of the country."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/10e5e502840c6af73e4124c289e9768fc52535d8_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "bias",
            "pee": [
                {
                    "partOfSpeech": "/ˈbaɪəs/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U, sing.] an unfair personal opinion that influences your judgment 偏见；成见；偏心",
                            "example": " It's clear that the company has a bias against women."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0223c7c9040a47363c940de0d64551438427b23b_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "publication",
            "pee": [
                {
                    "partOfSpeech": "/ˌpʌblɪˈkeɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] the act of printing a book, a magazine, etc. and making it available to the public; a book, a magazine, etc. that has been published （书刊等的）出版，发行；出版物",
                            "example": " That professor was the author of 70 major scientific publications."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/74770d87f6da36c1afb5d20588bb426d5560439d_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "analyze",
            "pee": [
                {
                    "partOfSpeech": "/ˈænəˌlaɪz/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(BrE analyse) examine or think about sth. carefully, in order to understand it 分析；剖析",
                            "example": " We use a special computer program to analyze all the sales figures."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/343e9d7d434994f0c5612a47404a2b108a44fb3f_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "identify",
            "pee": [
                {
                    "partOfSpeech": "/aɪˈdentɪˌfaɪ/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "recognize and correctly name sb. / sth. 认出，识别（某人或某物）",
                            "example": " Passengers were asked to identify their own suitcases before they were put on the plane."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e9f8ea0b4e9351af23a0a8a1d713cbabcae97ff9_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "confirmation",
            "pee": [
                {
                    "partOfSpeech": "/ˌkɒnfəˈmeɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] a statement, letter, etc. that shows that sth. is true, correct, or definite 证实；证明",
                            "example": " I'm still waiting for confirmation of the test results."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/921f3aa1acf52ad69cde344efac94dfbb8765a74_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "predictable",
            "pee": [
                {
                    "partOfSpeech": "/prɪˈdɪktəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "acting or happening in a way that is expected 可预料的；可预见的",
                            "example": " In March and April, the weather in this area is much less predictable."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/25984e751eef87cf1c184e8b5c9eed8df4dad0bb_96k.mp3#duration=2.3&t=.mp3"
        },
        {
            "word": "startling",
            "pee": [
                {
                    "partOfSpeech": "/ˈstɑːtlɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "very unusual or surprising 异乎寻常的；令人惊奇的",
                            "example": " There has been a startling increase in the number of homeless people."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5f8fa058b22c6c22027940d499e25dc1f62a65b6_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "distinctive",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈstɪŋktɪv/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "having a quality or characteristic that makes sth. different and easily noticed 特有的；特别的；有特色的",
                            "example": " Whatever you think of Larkin's poetry, it's certainly distinctive."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/18c8383d864aa782684e3050eab9dce41de94f2d_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "periodical",
            "pee": [
                {
                    "partOfSpeech": "/ˌpɪəriˈɒdɪkl/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a magazine, esp. one about a serious or technical subject 期刊",
                            "example": " Readers will find a complete list of periodicals dealing with that subject."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7adc0b5aef72214bf24f7e49ed6e5063076d736b_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "concerted",
            "pee": [
                {
                    "partOfSpeech": "/kənˈsɔːtɪd/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(only before noun) done in a planned and determined way, esp. by more than one person, government, country, etc. 齐心协力的；一致的",
                            "example": " Libraries have made a concerted effort to attract young people."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1b5784a1b8b0ed5f59ca6e74858d0831886689f2_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "discourse",
            "pee": [
                {
                    "partOfSpeech": "/ˈdɪskɔːs/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a serious speech or piece of writing on a particular subject （关于某主题的）演讲，论述，著述",
                            "example": " He was hoping for some lively political discourse at the meeting."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0105c4682a84bdfd20563cf0d3d0c2baf5172f40_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "quantitative",
            "pee": [
                {
                    "partOfSpeech": "/ˈkwɒntɪtətɪv/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) relating to amounts rather than to the quality or standard of sth. （数）量的；与数量有关的；定量的",
                            "example": " We need to do a proper quantitative analysis of this problem."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/38726b358f5c4550ab7d78328f2ce25722ed295e_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "representation",
            "pee": [
                {
                    "partOfSpeech": "/ˌreprɪzenˈteɪʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the fact of having sb. to speak, vote, or make decisions for you 代理；代表",
                            "example": " Minority groups need more effective parliamentary representation."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8eafc8d58b5c0698d59b29c233ee6fb0bcc1b5bf_96k.mp3#duration=2.4&t=.mp3"
        },
        {
            "word": "trivial",
            "pee": [
                {
                    "partOfSpeech": "/ˈtrɪviəl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "not serious, important, or valuable 微不足道的；没有什么价值的",
                            "example": " I know it sounds trivial, but I'm worried about it."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/97adfefc01a5d3b9127190c6f5676729238b2191_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "noticeable",
            "pee": [
                {
                    "partOfSpeech": "/ˈnəʊtɪsəbl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "easy to see or notice; clear or definite 显著的；显而易见的",
                            "example": " Road noise tends to be more noticeable in certain weather conditions."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/53043af322acfe322d1d1bf686979b8f1b44f04f_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "disguise",
            "pee": [
                {
                    "partOfSpeech": "/dɪsˈgaɪz/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) hide sth. or change it, so that it cannot be recognized 掩蔽；掩饰",
                            "example": " The speech was seen by many as a thinly disguised attack on the president."
                        },
                        {
                            "explanation": "2) change sb.'s appearance so that people cannot recognize them 装扮；假扮",
                            "example": " He disguised himself by wearing a false beard."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1141ba477dee1ee4c80c58d228635ad094d262dc_96k.mp3#duration=2.7&t=.mp3"
        },
        {
            "word": "unconscious",
            "pee": [
                {
                    "partOfSpeech": "/ʌnˈkɒnʃəs/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (of feelings, thoughts, etc.) existing or happening without you realizing or being aware; not deliberate or controlled （感情、思想等）无意识的，未意识到的",
                            "example": " He seems to be driven by an unconscious desire to do better than everyone else."
                        },
                        {
                            "explanation": "2) unable to see, move, feel, etc. in the normal way because you are not conscious 不省人事的；失去知觉的",
                            "example": " They found him lying unconscious on the floor. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f48147ad8dd70573f7e1d48335f1d92fa6ddc32a_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "publisher",
            "pee": [
                {
                    "partOfSpeech": "/ˈpʌblɪʃə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a person or company whose business is to arrange the writing, production, and sale of books, newspapers, etc. （书、报纸等的）出版者，出版商；出版社",
                            "example": " The publisher planned to produce the journal on a weekly basis."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0bf1ced25531f6fc61676995a97042b2ad1c0a94_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "pursue",
            "pee": [
                {
                    "partOfSpeech": "/pəˈsju:/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "continue doing an activity or trying to achieve sth. over a long period of time 追求；继续进行",
                            "example": " Students should pursue their own interests, as well as do their school work."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/45e3d56dab0229a5b2c53e3f100ee16e4fd84e3b_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "discrimination",
            "pee": [
                {
                    "partOfSpeech": "/dɪˌskrɪmɪˈneɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the practice of treating one person or group differently from another in an unfair way 歧视",
                            "example": " Laws have got to be tougher to stop discrimination against the disabled."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/67ba52c0f7c32232c8cf26d446f92b33adae3491_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "enduring",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈdjʊərɪŋ/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "lasting for a long time 持久的；耐久的",
                            "example": " One of my most enduring memories is of going on holiday to France with my parents."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b42f8c57fe63b911897fbdda5da8d17f8261f62c_96k.mp3#duration=2.3&t=.mp3"
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "apply to",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "have an effect on or concern a particular person, group, or situation 适用于；对...有效",
                              "example": " The offer only applies to flights from London and Manchester."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e4378082b687aafaaac0c2b03361acd797643754_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "at all costs / cost",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "whatever is needed to achieve sth. 不惜一切代价",
                              "example": " I have to avoid being late for work again at all costs, or I'll lose my job."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8eb7deec7bd9523e0db60a49297ea9d6755332a4_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "straight away / off",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE, spoken) immediately or without delay 立刻；马上",
                              "example": " I wrote him a letter and posted it straight away."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8462db7d797157a3b2ea737e7f459331f580a94_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "in terms of",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(also in … terms) used to show what aspects of a subject you are talking about or how you are thinking about it 谈及；就...而言；在...方面；从...方面来说",
                              "example": " It's a mistake to think of Florida only in terms of its tourist attractions."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2031e92f763cad31d5680975b37736e77219c6ac_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "with respect to",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(also in respect of) (fml.) concerning or in relation to sth. 关于...；就...而言",
                              "example": " The two groups were similar with respect to income and status."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/de7f1d0929b4b75a86315947cdb998ae98b7f1ef_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "in line with",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "similar to, or at the same level as sth. 与...相似；与...水平一致",
                              "example": " The new policy is in line with the plans that were discussed last year."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8cf0221b96b23b99da3da3924fc72471801d604f_96k.mp3#duration=2.0&t=.mp3"
          },
          {
            "word": "rise to prominence / fame / power, etc.",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "become important, famous, powerful, etc. 变得更加杰出、著名、强大等",
                            "example": " She played an important supporting role in family as her husband rose to fame as an actor."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ad1bc099e0fe0b72b3be93711c83cdb9a5d66d3a_96k.mp3#duration=5.4&t=.mp3"
        },
        {
            "word": "at stake",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "at issue or in question 待解决的；成问题的",
                            "example": "His own personal future was at stake."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/853b394ddd895467b4f49e1b963a93f1d50f3515_96k.mp3#duration=1.9&t=.mp3"
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "B.C.E",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/53a2dbe70d850b86ac44b98b06e3973309be19d1_96k.mp3#duration=2.1&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "(before common era) 公元前"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "the Middle East",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8df56466e851dfea816e0560f34068b668d6a98_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "中东（一般泛指欧、亚、非三洲连接的地区）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Kruger",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3876124c0eb295b9627535bee333141b6e4d781d_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈkru:gə/",
                      "explanations_and_examples": [
                          {
                              "explanation": "克鲁格（人名）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Byker",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4db4dabd0f3fbfbf70a8336818c5d0d5ee503b7d_96k.mp3#duration=1.3&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈbaɪkə/",
                      "explanations_and_examples": [
                          {
                              "explanation": "拜克（人名）"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "Jane Austen",
            "pee": [
                {
                    "partOfSpeech": "/ˈɒstɪn/",
                    "explanations_and_examples": [
                        {
                            "explanation": "简・奥斯汀（英国小说家）"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c96d98831b687813f58f712954869660d123259a_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "G. H. Lewes",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/57c1ee4f316e04dbd641a778a0553743eda1b3c2_96k.mp3#duration=2.1&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈlu:ɪs/",
                    "explanations_and_examples": [
                        {
                            "explanation": "(George Henry Lewes)乔治・亨利・刘易斯（英国哲学家、文学评论家和剧作家）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "George Eliot",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a6611fc74ae4cfe8ec609ed8eb5f381b1478ceae_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈelɪət/",
                    "explanations_and_examples": [
                        {
                            "explanation": "乔治・艾略特（英国小说家）"
                        }
                    ]
                }
            ]
        }
      ]
  }
]

book2[4] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "console",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3fd77bb5d9243c940c2482daa5ea933dc91ef1a4_96k.mp3#duration=3.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈsəʊl/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make sb. feel better when they are feeling sad or disappointed 安慰；慰藉",
                              "example": "He consoled himself that he would see Kate again soon."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "heal",
              "pee": [
                  {
                      "partOfSpeech": "/hiːl/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) become mentally or emotionally strong again after a bad experience, or help sb. to do this （在精神或感情上）（使）复原，（使）坚强起来",
                              "example": "Bianca was the kind of woman who could heal his soul, if he had time to let her."
                          },
                          {
                              "explanation": "2) (also heal up) become healthy again; make sth. healthy again （使）康复，复原",
                              "example": "It took a long time for the wounds to heal."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5f86808d552e772c4d301e1da35a77d0f32202ec_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "coincidence",
              "pee": [
                  {
                      "partOfSpeech": "/kəʊˈɪnsɪd(ə)ns/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] when two things happen at the same time, in the same place, or to the same people in a way that seems surprising or unusual 巧合；巧事",
                              "example": "I think it is more than coincidence that all the complaints have come from the same group of people."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/884ace96f8c36855ccd39495754b4df33f827421_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "therapy",
              "pee": [
                  {
                      "partOfSpeech": "/ˈθerəpi/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a treatment that helps sb. feel better, grow stronger, etc., esp. after an illness 治疗；疗法",
                              "example": "Many patients receiving these new therapies respond rapidly to them and get a lot of clinical benefit."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/17798ae3174de697d341625c666da70dedd6197b_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "propose",
              "pee": [
                  {
                      "partOfSpeech": "/prəˈpəʊz/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) suggest sth. as a plan or course of action 提议； 建议",
                              "example": "In his speech he proposed that the UN should set up an emergency center for the environment. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/101920917635c11e7945c61ad047faf661354da9_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "fleeting",
              "pee": [
                  {
                      "partOfSpeech": "/ˈfli:tɪŋ/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(usu. before noun) lasting for only a short time 短暂的；飞逝的",
                              "example": "For one fleeting moment, Paula allowed herself to forget her troubles."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f6a9b97b505f74051906a81084fcd55ddf5c192e_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "betrayal",
              "pee": [
                  {
                      "partOfSpeech": "/bɪˈtreɪəl/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the act of betraying sb. / sth. or the fact of being betrayed 背叛；出卖",
                              "example": "She wondered if he felt hurt at his best friend's betrayal but didn't have the courage to ask."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2446b121dfb913b4120207fc4d25ccd215acd67b_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "endure",
              "pee": [
                  {
                      "partOfSpeech": "/Inˈdjʊə/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "continue to exist for a long time 持续",
                              "example": "He wasn't the only one who doubted the relationship would endure."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "vt.",
                      "explanations_and_examples": [
                          {
                              "explanation": "be in a difficult or painful situation for a long time without complaining 忍耐；忍受",
                              "example": "It seemed impossible that anyone could endure such pain."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3e023d9187c265790305a63d4e77edda17031a37_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "companionship",
              "pee": [
                  {
                      "partOfSpeech": "/kəmˈpænjənʃɪp/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] when you are with sb. you enjoy being with, and are not alone 友谊；友好交往",
                              "example": "That feeling of companionship can make a huge difference, especially at a stressful job."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/89b3fd0e084be60c092e93359a52d4f18563be27_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "insight",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪnsaɪt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a sudden clear understanding of sth. or part of sth., esp. a complicated situation or idea （尤指对复杂情况、看法的）顿悟，猛醒",
                              "example": "The article gives us a real insight into the causes of the present economic crisis."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ce9c143c6b250fdf18ce1c453b16dab80e9571d2_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "narrator",
              "pee": [
                  {
                      "partOfSpeech": "/nəˈreɪtə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 叙述者；讲述者",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a05cf5bc43c4d7fcf87e56b13cf629aa2acae54d_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "monologue",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmɒnəˌlɒg/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (AmE also monolog) a long speech by one person 长篇独白",
                              "example": "Blogs are not just about one person sharing in a monologue with everyone else listening."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fed0c1494e20afb343f14344f822592b6bca7cc6_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "paradoxically",
              "pee": [
                  {
                      "partOfSpeech": "/ˌpærəˈdɒksɪkli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "in a way that is surprising because it is the opposite of what you would expect 自相矛盾地；反常地",
                              "example": "Paradoxically, the economy is improving although many families complain about the poverty in which they live."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/66e1baca6ea59f1c491eeebb4a17c49abbc14094_96k.mp3#duration=2.8&t=.mp3"
          },
          {
              "word": "interior",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈtɪəriə/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(only before noun) belonging to mental or spiritual life 内心的；精神的",
                              "example": "Interior monolog is defined as the thoughts you have running through your brain or the things that you silently tell yourself."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, usu. sing.] the inner part or inside of sth. 内部；里面",
                              "example": "The interior of the church was dark. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/82422827050ce9c41d7915c76121668b24a0e630_96k.mp3#duration=2.7&t=.mp3"
          },
          {
              "word": "universal",
              "pee": [
                  {
                      "partOfSpeech": "/ˌju:nɪˈvɜːsl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "true or suitable in very situation 普遍正确的；广泛适用的",
                              "example": "It is an almost universal truth that the more weare promoted in a job, the less we exercise the skills we initially used to perform it."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a67f61a16bcedd6baf391d6b054e91931fcd6895_96k.mp3#duration=3.1&t=.mp3"
          },
          {
              "word": "universality",
              "pee": [
                  {
                      "partOfSpeech": "/ˌju:nɪvɜːˈsæləti/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the quality or state of being true or suitable in every situation 普遍性；通用性",
                              "example": "His lyrics aim for a certain timeless universality."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2b83366c7cb2aab0c573700739b15b5b032c652d_96k.mp3#duration=3.0&t=.mp3"
          },
          {
              "word": "timelessness",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtaɪmləsnəs/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the quality of not changing as the years go past, or as fashion changes 永恒；不朽",
                              "example": "It is said that all diamonds are symbolic of love, commitment, and timelessness, but adding yellow to the stone gives it even deeper meaning."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/aa6de39b26febb54877922a2b61c8b6af610f64e_96k.mp3#duration=2.7&t=.mp3"
          },
          {
              "word": "subconscious",
              "pee": [
                  {
                      "partOfSpeech": "/ˌsʌbˈkɒnʃəs/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "existing in the mind but not immediately available to consciousness 下意识的；潜意识的",
                              "example": "There are conscious thoughts that you're aware of and subconscious ones that you're not. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f8b22de3d1eb99f360124c5afe0b237666d7cbd4_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "ease",
              "pee": [
                  {
                      "partOfSpeech": "/iːz/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make or become less severe, difficult, unpleasant, painful, etc. 缓解；减轻",
                              "example": "The school needs to take some measures to ease the burden on busy teachers."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the fact that sth. is easy to do 容易；轻易；不费劲",
                              "example": "He studied hard every day so that he could pass the exam with ease."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0ebc238cd2290469acfa763986d36b7a5881df6e_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "empathetic",
              "pee": [
                  {
                      "partOfSpeech": "/ˈempəˌθetɪk/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(also empathic) having the ability to understand sb. else's feelings or emotions 同情的；共鸣的",
                              "example": "Providing a loving home environment can help the child to become independent, self-confident, and empathetic toward others. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/48b975d744c5648c5e35ad575016f787d9af0383_96k.mp3#duration=2.4&t=.mp3"
          },
          {
              "word": "mild",
              "pee": [
                  {
                      "partOfSpeech": "/maɪld/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) a mild illness or health problem is not serious 不严重的；轻微的",
                              "example": "She had a mild headache, and went to bed much earlier than usual."
                          },
                          {
                              "explanation": "2) not very strong or hot-tasting 不浓烈的；淡的；不辣的",
                              "example": "I like this kind of cheese because it has a pleasant mild flavor. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/77c868c68cbe8b12f92430391b3cf3f8a9eb6b02_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "symptom",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsɪmptəm/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] sth. wrong with your body or mind which shows that you have a particular illness 症状",
                              "example": "Tiredness is one of the most common symptoms of stress."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c879ff76cdeb5970720bc1c61f58a90957c7bd27_96k.mp3#duration=2.6&t=.mp3"
          },
          {
              "word": "bibliotherapist",
              "pee": [
                  {
                      "partOfSpeech": "/ˌbɪblɪəˈθerəpɪst/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 阅读治疗专家",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d1e781cdb73b0e6a481dfb98b497833cdedeab5f_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "continually",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈtɪnjʊəli/",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) in a way that happens repeatedly 多次重复地；频繁地",
                              "example": "We are continually reassessing the situation."
                          },
                          {
                              "explanation": "2) in a way that continues for a long time without stopping 持续地；不间断地",
                              "example": "The telephone has been ringing continually in the office all morning."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d2c12668bc36207b9ece697437393b20605a0e3a_96k.mp3#duration=2.5&t=.mp3"
          },
          {
              "word": "grieve",
              "pee": [
                  {
                      "partOfSpeech": "/griːv/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "feel extremely sad, esp. because sb. you love has died （尤指因所爱之人去世而）感到悲痛",
                              "example": "He died, and every day since then I have grieved for him."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9e49df360a6128ba41a14ea7bb7c7fae31e71a05_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "plot",
              "pee": [
                  {
                      "partOfSpeech": "/plɒt/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] the events that form the main story of a book, film, or play （书、电影、戏剧的）情节",
                              "example": "Although the cast (全体演员) was different back then, the plot was strikingly similar."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/77bd9a6c49b7cc6992504a86b1d885a145a6f4ae_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "fictional",
              "pee": [
                  {
                      "partOfSpeech": "/ˈfɪkʃnəl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "fictional people, events, etc. are imaginary and from a book or story 虚构的；编造的；小说（中）的",
                              "example": "He has created many lively fictional characters with his wonderful writing."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/13c23ac7b09b443276596d7c18007382f6b8f319_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "retirement",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈtaɪəmənt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] when you stop working, usu. because of your age 退休；退职",
                              "example": "He became a keen golfer after his retirement from politics."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4ae7efb15aad68519b6e2bab19a9552a45ab4dfe_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "transient",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtrænziənt/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) continuing only for a short time 短暂的；转瞬即逝的；一时的",
                              "example": "The trading data show that these events had minimal and transient effect on the price of gold and silver."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/60460976d61e7a0ce1bd485a2f1e8036a797c117_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "transience",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtrænziəns/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the state of continuing only for a short time 短暂；转瞬即逝",
                              "example": "History is a combination of permanence and transience."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/00b004edbb0afa1e37098abb1f6d432f42c8e34f_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "messy",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmesi/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (of a situation) complicated and unpleasant to deal with （状况）棘手的",
                              "example": "If you find yourself in a messy situation, please take these five strategies to heart. "
                          },
                          {
                              "explanation": "2) dirty or untidy 脏的；乱的",
                              "example": "Sorry, the place is so messy because I haven't had time to clear up. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a0c5471c511f65bfc31e81e60ee9c246a98005cf_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "grief",
              "pee": [
                  {
                      "partOfSpeech": "/gri:f/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] extreme sadness, esp. because sb. you love has died 悲痛，极度悲伤（尤指因所爱之人去世）",
                              "example": "The grief she felt over Helen's death was almost unbearable."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0c2590ecfc625d6146c885b4ea4a1fa1efa55685_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "despair",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/26b90eb7d480508e5734334c36be97452c60292e_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/dɪˈspeə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] a feeling that you have no hope at all 绝望",
                              "example": "A few positive words can turn despair into hope. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "memoir",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cc651b44c8afdc6ae2614826668a0a386e3b4b2d_96k.mp3#duration=2.3&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmemˌwɑː/【n.】 [C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (fml.) a short piece of writing about a person or place that you knew well, or an event that you experienced 传略；实录",
                              "example": "His memoir of his friend Professor Fleeming Jenkin was published soon after his departure."
                          },
                          {
                              "explanation": "2) (~s) [pl.] a book by sb. important and famous in which they write about their life and experiences （名人）回忆录",
                              "example": "Angelou's first volume of memoirs dealt with her childhood."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "narrative",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e6de81148a12554c96b258039124aeb99552ff2b_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈnærətɪv/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [U] (fml.) the act, process, or skill of telling a story 叙述；叙述技巧",
                              "example": "The novel contains too much dialog and not enough narrative. "
                          },
                          {
                              "explanation": "2) [C] (fml.) a description of events in a story, esp. in a novel （尤指小说中的）叙述，记叙",
                              "example": "At several points in the narrative the two stories cross."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "optimistic",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/15000c904137f04273e80455ecfa973122139124_96k.mp3#duration=2.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɒptɪˈmɪstɪk/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "believing that good things will happen in the future 乐观的；乐观主义的",
                              "example": "Bankers are cautiously optimistic about the country's economic future."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "transform",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/90be5242972c8a235951a8d4c7387b99a9a03113_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/trænsˈfɔːm/【vi.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "undergo a change in appearance, form, or character 改观；变形；转化",
                              "example": "The trip to the cinema transforms into a full-day activity for the family."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "vt.",
                      "explanations_and_examples": [
                          {
                              "explanation": "completely change the appearance, form, or character of sb. / sth., esp. in a way that improves it 使改观；使变形；使转化",
                              "example": "The movie transformed her almost overnight from an unknown schoolgirl into a star."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "precious",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5d8bee34fe59f525b0f30d2783dfbe13a07ac047_96k.mp3#duration=2.2&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈpreʃəs/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) greatly loved or treasured by sb. 珍爱的；心爱的",
                            "example": "Look after my daughter — she's very precious to me."
                        },
                        {
                            "explanation": "2) valuable and important and not to be wasted or used without care 宝贵的",
                            "example": "Books were very scarce and very precious in this village, and only a few men could read them."
                        }
                    ]
                }
            ]
        },
        {
            "word": "voyage",
            "pee": [
                {
                    "partOfSpeech": "/ˈvɔːɪɪdʒ/【n.】 [C] ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (~ of discovery) a situation in which you learn a lot of new things about sb. / sth. （对某人或某事有大量新发现的）发现之旅",
                            "example": "Writing a biography is an absorbing voyage of discovery."
                        },
                        {
                            "explanation": "2) a long journey in a ship or spacecraft （乘船或宇宙飞船的长途）航行",
                            "example": "The voyage from England to India used to take six months."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/68419605dfe5514391e0d8db33a5de552452ff95_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "edition",
            "pee": [
                {
                    "partOfSpeech": "/ɪˈdɪʃn/【n.】 [C] ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) the copies of a book, newspaper, etc. that are produced and printed at the same time 版次",
                            "example": "The textbook was first published in 1858 and is now in its 39th edition."
                        },
                        {
                            "explanation": "2) the form that a book, newspaper, magazine, etc. is produced in 版本",
                            "example": "The regional editions of the paper contain specific information for that area."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ce910345e3b74723807d284c6bca6208e95afc6c_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "hyphen",
            "pee": [
                {
                    "partOfSpeech": "/ˈhaɪfn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 连字符；连（字）号",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c0972916e666aedcfed823368711cff839939e06_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "pigeonhole",
            "pee": [
                {
                    "partOfSpeech": "/ˈpɪdʒ(ə)nˌhəʊl/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] （墙上的）鸽笼式分类架，信件格，文件格",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9eb2a3f02ea1e198125c4a30ccce49b3971fef1f_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "henceforth",
            "pee": [
                {
                    "partOfSpeech": "/ˌhensˈfɔːθ/【ad.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(also henceforward) (fml.) from this time on 从今以后；今后；从现在起",
                            "example": "All financial and economical questions were henceforth to be decided by a majority of votes."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/735efdb7494543b912021c7e2359485050059e9a_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "pot belly",
            "pee": [
                {
                    "partOfSpeech": "/ˈpɒtˌbeli/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 大肚子",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cdc373228319a222b2dde65ccfd89c26e261e7bb_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "betray",
            "pee": [
                {
                    "partOfSpeech": "/bɪˈtreɪ/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "be disloyal to sb. who trusts you, so that they are harmed or upset 背叛（信任你的人）；对...不忠；出卖",
                            "example": "But don't you think you betray him by not giving him a chance?"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4bfc4463fe2912d1c059ece46db111b7700acda7_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "unacceptable",
            "pee": [
                {
                    "partOfSpeech": "/ˌʌnəkˈseptəbl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "so wrong or bad that cannot be allowed 不能接受的",
                            "example": "The recommendations from this report are unacceptable to many black people."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/368e9275000db9b85e1114aacb74aa1ea55d5b61_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "millisecond",
            "pee": [
                {
                    "partOfSpeech": "/ˈmɪlɪˌsekənd/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 毫秒；千分之一秒",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/02e7fc318896f49446d18f0f47edb17672108189_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "tap",
            "pee": [
                {
                    "partOfSpeech": "/tæp/【v.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "hit sb. / sth. quickly and lightly 轻敲；轻拍；轻叩",
                            "example": "Tap the X or Z key to scroll (滚动) to the right or to the left."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (esp. BrE) （水、煤气等管道或容器的）龙头， 阀门"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/371c0b61b4028ce5db06c40b96a7abd8fb84a364_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "texter",
            "pee": [
                {
                    "partOfSpeech": "/ˈtekstə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (esp. BrE) 发送（手机） 短信息的 人",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/12c94bf3f9e4f1a487bff668fa329ec5075a887c_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "punctuation",
            "pee": [
                {
                    "partOfSpeech": "/ˌpʌŋktʃuˌeɪʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the marks used to divide a piece of writing into sentences, phrases, etc. 标点符号（总称）",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2a12f4428cfd97e64765485b2792230e171330c5_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "savage",
            "pee": [
                {
                    "partOfSpeech": "/ˈsævɪdʒ/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "attack or treat brutally 攻击；残害",
                            "example": "The animal then turned on him and he was savaged."
                        }
                    ]
                },
                {
                    "partOfSpeech": "a.",
                    "explanations_and_examples": [
                        {
                            "explanation": "very violent or cruel 凶猛的；残暴的",
                            "example": "This was a savage attack on a defenseless young girl."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/afbb1bc2474922c41f2942fabbe3e6a38c239460_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "rape",
            "pee": [
                {
                    "partOfSpeech": "/reɪp/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "damage or destroy sth. by using it in an unsuitable way 蹂躏；破坏",
                            "example": "Is the idea that texting is raping our vocabulary exaggerated?"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ec2ee6003ed08de0d4309132f9b8a82c5bae5255_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "quiver",
            "pee": [
                {
                    "partOfSpeech": "/ˈkwɪvə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 箭筒；箭囊；箭袋",
                            "example": ""
                        }
                    ]
                },
                {
                    "partOfSpeech": "vi.",
                    "explanations_and_examples": [
                        {
                            "explanation": "shake slightly because you are cold, or because you feel very afraid, angry, excited, etc. 颤抖；发抖",
                            "example": "Her lips quivered and then she started to cry. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/488e22e8ab816430099d6525cd891cc87397a4de_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "ridicule",
            "pee": [
                {
                    "partOfSpeech": "/ˈrɪdɪˌkju:l/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] unkind laughter or remarks that are intended to make sb. / sth. seem stupid 嘲笑；奚落",
                            "example": "He had become an object of ridicule among the other students."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5055d0107654dc88147d4fe98c25dc2aecf8ebd7_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "irritating",
            "pee": [
                {
                    "partOfSpeech": "/ˈɪrɪˌteɪtɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "annoying 使人恼火的",
                            "example": "He's the most irritating man I've ever met."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/376c6869dbcb82dc7d77d9ffccfd016587cad5e8_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "chatter",
            "pee": [
                {
                    "partOfSpeech": "/ˈtʃætə/【vi.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(also chatter away / on) talk quickly in a friendly way without stopping, esp. about things that are not serious or important 唠叨；喋喋不休",
                            "example": "She chattered away happily until she noticed I wasn't listening."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a405429ba0fb07a46e833599961f930bf72004d2_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "smiley",
            "pee": [
                {
                    "partOfSpeech": "/ˈsmaɪli/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 微笑符（电子邮件中使用的表示愉快的符号，如 :-)）",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/41adbedbcfe923b950bb33662d305d2aa2f15470_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "emoticon",
            "pee": [
                {
                    "partOfSpeech": "/ɪˈməʊtɪˌkɒn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] （在电子邮件和因特网上使用的）表情符号",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/697522ed5147660791e20b39315e461fdadae5de_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "colon",
            "pee": [
                {
                    "partOfSpeech": "/ˈkəʊlɒn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 冒号",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4d1ccd8fb2a779ade305d88050b1182a07f91dbd_96k.mp3#duration=1.1&t=.mp3"
        },
        {
            "word": "dash",
            "pee": [
                {
                    "partOfSpeech": "/dæʃ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 破折号",
                            "example": ""
                        }
                    ]
                },
                {
                    "partOfSpeech": "vi.",
                    "explanations_and_examples": [
                        {
                            "explanation": "go or run somewhere very quickly 猛冲；疾奔",
                            "example": "She dashed into the room, grabbed her bag, and ran out again."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1f30bae72fc093859623f02f94c168b9e0a02b9b_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "bracket",
            "pee": [
                {
                    "partOfSpeech": "/ˈbrækIt/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, usu. pl.] (AmE parenthesis) 圆括弧；圆括号",
                            "example": "Last year's sales figures are given in brackets. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5836442f1f6bbd791bc7c3efc9fe5e049ff81230_96k.mp3#duration=1.2&t=.mp3"
        },
        {
            "word": "abbreviation",
            "pee": [
                {
                    "partOfSpeech": "/əˌbri:viˈeɪʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "a short form of a word or expression 缩略语；缩写",
                            "example": "We will use this abbreviation in this article and throughout the series."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1f8473092858d7fbd29321908fa04c1a7241f7b0_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "offensive",
            "pee": [
                {
                    "partOfSpeech": "/əˈfensɪv/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "very rude or insulting and likely to upset people 无理的；冒犯的；令人恼火的",
                            "example": "The program contains language which some viewers may find offensive."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/df0c70318615d76f3aec45260e980ae5b698d539_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "inoffensive",
            "pee": [
                {
                    "partOfSpeech": "/ˌɪnəˈfensɪv/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "unlikely to offend or upset anyone 不冒犯人的；不会得罪人的",
                            "example": "Her husband was a small, inoffensive-looking man."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5cfd1a97af5872efd0466ce297d13515d53453b2_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "increasingly",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈkri:sɪŋli/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "more and more all the time 不断增加地；越来越多地",
                            "example": "Increasingly, businesses are having to reduce their cost in order to survive."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ebf280137ff69cc39aa1f586b85cdbe216118574_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "obscure",
            "pee": [
                {
                    "partOfSpeech": "/əbˈskjʊə/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) difficult to understand 费解的；晦涩的",
                            "example": "For some obscure reason, the group is very popular. "
                        },
                        {
                            "explanation": "2) not well known and usu. not very important 无名的；默默无闻的；鲜为人知的",
                            "example": "He was born around 1650 but his origins remain obscure."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f0b8434397b3c573bca4bedf121e4bb56d5ffb68_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "recipient",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈsɪpiənt/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (fml.) sb. who receives sth. 接受者；领受者",
                            "example": "I felt glad that I was a giver of pleasure, not merely a passive recipient."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dfc13369b0230744cc221906fb803c3500fb110c_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "ambiguity",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0bb0d909ef86362f76aa8d5da95edd7e326556b4_96k.mp3#duration=2.0&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌæmbɪˈgju:əti/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "the state of being unclear, confusing, or not certain, or things that produce this effect 模棱两可；不明确（的事物）",
                            "example": "There was an element of ambiguity in the president's reply. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "barrier",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/91bfb5e31b1acd627a65202f7b2712793b56507f_96k.mp3#duration=1.3&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈbæriə/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a rule, problem, etc. that prevents people from doing sth., or limits what they can do 障碍；壁垒",
                            "example": "Problems with childcare remain the biggest barrier to women succeeding at work. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "humble",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/150157845d62c707ee34a21349ffbf8df2802540_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈhʌmbl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (in my ~ opinion) used humorously to give your opinion about sth. 愚以为，依拙见（幽默用法）",
                            "example": "There is no greater mass-produced, affordable safety device around in my humble opinion."
                        },
                        {
                            "explanation": "2) not considering yourself or your ideas to be as important as other people's 谦虚的；谦卑的",
                            "example": "Be humble enough to learn from your mistakes."
                        }
                    ]
                }
            ]
        },
        {
            "word": "complaint",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d873c784da6ed13713e9cd48ee80ff52efd1675_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/kəmˈpleɪnt/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) [C] sth. that you complain about 投诉的事；不满的事",
                            "example": "My main complaint is that we can't go out to the playground anymore."
                        },
                        {
                            "explanation": "2) [C, U] a statement in which sb. complains about sth. 投诉",
                            "example": "If you wish to make a complaint, you should see the manager."
                        }
                    ]
                }
            ]
        },
        {
            "word": "revolution",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2890ac836ceafbc0b22e7c500b2fc9e481b84fb4_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌrevəˈlu:ʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "a complete change in ways of thinking, methods of working, etc. （思想、工作方式等的）彻底变革，革命",
                            "example": "In the last 10 years there has been a revolution in education."
                        }
                    ]
                }
            ]
        },
        {
            "word": "globe",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/06bcfcb83388ced068b860e3a9465d81e9871666_96k.mp3#duration=1.3&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/gləʊb/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(the ~) [sing.] the world 地球；世界",
                            "example": "Our company is really international and we export our goods all over the globe."
                        }
                    ]
                }
            ]
        },
        {
            "word": "adaptable",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/12a4a1a1866ffe76daaef3767346355fe9c73ef8_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/əˈdæptəbl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "able to change in order to be successful in new and different situations 能适应的；适应性强的",
                            "example": "Since the workout is adaptable and fun, you will be able to learn the techniques with ease."
                        }
                    ]
                }
            ]
        },
        {
            "word": "netspeak",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/69a21094c4feb92862232fb9b5efc4dd6e98de87_96k.mp3#duration=1.3&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈnetˌspi:k/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] 网络语言"
                        }
                    ]
                }
            ]
        },
        {
            "word": "ridiculous",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/693da5abb52bc3d970cfcd36b2d5ffa508abb5fd_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/rɪˈdɪkjʊləs/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "very silly or unreasonable 愚蠢的；荒唐的；可笑的",
                            "example": "It's ridiculous that we have to wait two weeks for the operation."
                        }
                    ]
                }
            ]
        },
        {
            "word": "ever-changing",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1fdbe092ce3c4271881982bec8c827348b55258e_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌevəˈtʃeɪndʒɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "changing all the time 不断变化的",
                            "example": "In this way we can best meet the needs of the ever-changing market through innovative technology and design."
                        }
                    ]
                }
            ]
        },
        {
            "word": "spoil",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/45f571903e29c5c77dab893ab7844145a7e94234_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/spɔɪl/【vt.】 (spoiled, spoiled; BrE also spoilt, spoilt)",
                    "explanations_and_examples": [
                        {
                            "explanation": "have a bad effect on sth. so that it is no longer attractive, enjoyable, useful, etc. 毁掉；糟蹋；破坏",
                            "example": "They had an entire week, so there was no need to rush into a conversation that might spoil everything."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "one after the other",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(also one after another) if a series of events or actions happen one after another, each one happens soon after the previous one 一个接一个地；接二连三地",
                              "example": "Ever since we moved here it's been one problem after the other."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9e13a14289e474868a1f1c27071c76c5c1b50ab4_96k.mp3#duration=2.9&t=.mp3"
          },
          {
              "word": "in the hope of / that",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "because you want sth. to happen 抱着...的希望",
                              "example": "Shoppers flocked to the sales in the hope of finding a bargain."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e726edb7213f183408d9f6907bc736fbd4a10ae7_96k.mp3#duration=4.7&t=.mp3"
          },
          {
            "word": "leaf through",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "turn the pages of a book quickly, without reading it properly 匆匆翻阅",
                            "example": "I picked up the magazine and leafed through it."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/52b77297a1fae7fc6126bd584c2e068452e0ce9b_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "fall on/upon",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "if your eyes fall on sth., or your gaze, glance falls on sth., you notice it （某人的目光）落在某物上",
                            "example": " His eyes fell on her bag.Are you going somewhere?"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/64ae6e764d4ee93d71349a9f64ecfff369eb7b82_96k.mp3#duration=3.0&t=.mp3"
        },
        {
            "word": "fall victim to sth.",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/264528677068fd76debdc0a03f15b1836e73248e_96k.mp3#duration=2.4&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(written) be badly affected or destroyed by sth. 受到...的损害",
                            "example": "Many small businesses have fallen victim to the recession."
                        }
                    ]
                }
            ]
        },
        {
            "word": "no longer ",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/764604f34b50e7fe8e9bd92d27c4a6eb01f78989_96k.mp3#duration=2.0&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "not any more 不再",
                            "example": "Now that Tony was no longer present, there was a distinct change in her attitude."
                        }
                    ]
                }
            ]
        },
        {
            "word": "a tall order",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7b6f5f64358711c3483dbc39dd9e4d278ac0e702_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(infml.) a request or piece of work that is almost impossible 很难实现的要求，奢求；很难完成的工作",
                            "example": "Finding a replacement is going to be a tall order."
                        }
                    ]
                }
            ]
        },
        {
            "word": "figure out ",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/af23a557d41d619268c1163bc07fc18b9c50ad32_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "think about a problem or situation until you find the answer or understand what has happened 弄懂；搞清楚 ",
                            "example": "There will be a full investigation to figure out what caused the accident."
                        }
                    ]
                }
            ]
        },
        {
            "word": "see to",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/520269887641268f7cb64c99cf748d1707231f94_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "deal with sth. or do sth. for sb. 照料；处理",
                            "example": "You try to have some sleep. I'll see to the children's breakfast."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "Michel de Montaigne",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8542b3f3f6511910e325a947f6c0b2e5f722cddd_96k.mp3#duration=3.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/mʊŋˈtenj/",
                      "explanations_and_examples": [
                          {
                              "explanation": "米歇尔・德・蒙田 ( 法国作家、哲学家 )"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "University of Sussex",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2cc80a68b4d3342517ecb2d08ba6f129f61fc7f4_96k.mp3#duration=3.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsʌsɪks/",
                      "explanations_and_examples": [
                          {
                              "explanation": "萨塞克斯大学 (英国大学，位于英格兰)"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Helen Garner",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f3aefe554fc139c7fdb70532656959ff213fff87_96k.mp3#duration=2.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "海伦・加纳 （澳大利亚作家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Robert Dessaix",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4b92686a872ced6c5833256a49bf2ed424cefff4_96k.mp3#duration=2.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/dɪˈseɪ/",
                      "explanations_and_examples": [
                          {
                              "explanation": "罗伯特・德塞（澳大利亚作家）"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "Angus Stevenson",
            "pee": [
                {
                    "partOfSpeech": "/ˌæŋgəs ˌsti:v(ə)ns(ə)n/",
                    "explanations_and_examples": [
                        {
                            "explanation": "安格斯・史蒂文森（'牛津英语词典'系列主编）"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/65bf0abb5f9ad536e9e21e9d5a16b8e35d38286b_96k.mp3#duration=2.4&t=.mp3"
        }
      ]
  }
]

book2[5] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "whole wheat",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/109afe510b393277dd9ecc4a05a4d466702ca6dc_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhəʊl ˌwi:t/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE wholemeal) 用全麦做的；用全麦面粉做的",
                              "example": "The cool temperature helps keep whole wheat flour fresh for a longer time."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "ham",
              "pee": [
                  {
                      "partOfSpeech": "/hæm/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] 火腿（肉）",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fb016e295c8ca6e9c947db09effa2b626c2284e8_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "grill",
              "pee": [
                  {
                      "partOfSpeech": "/grɪl/【v.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "cook under or over direct heat 烤；烧；焙",
                              "example": "The meat tastes best when you grill it for 20 minutes on each side."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d43a578a110daa512f502603b0e3e11663360078_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "toast",
              "pee": [
                  {
                      "partOfSpeech": "/təʊst/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "make (bread, cheese, etc.) brown by placing it close to heat 烤，烘（面包、奶酪等）",
                              "example": "Toast the bread lightly on both sides and it will be ready."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] bread that has been heated so that it is brown on both sides and no longer soft 烤面包（片）；吐司",
                              "example": "I'd like coffee and two pieces of toast with butter."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ac453a1f1d9d388e166d0b8abea6dc99c5f9f957_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "historian",
              "pee": [
                  {
                      "partOfSpeech": "/hɪˈstɔːriən/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C]a person who studies history and / or writes about it 历史学家；史学工作者",
                              "example": "His father is a famous historian, specializing in the history of Germany."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/edb9c6cfc77a0d806d013ee1212451992dea9846_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "resourcefulness",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈzɔːsflnəs/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the quality of being good at finding ways to deal with difficult situations 机智；有办法",
                              "example": "Because of his adventures, he is a person of far greater experience and resourcefulness."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5d5e63be5caa6adfc3682193909c114e563fb79f_96k.mp3#duration=2.3&t=.mp3"
          },
          {
              "word": "immigration",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɪmɪˈgreɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the process of entering another country to make one's life there 移居；移民入境",
                              "example": "The government has decided to tighten the immigration policy."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9b34a678ab771a745db19c60a15680362d62f305_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "globalization",
              "pee": [
                  {
                      "partOfSpeech": "/ˌgləʊbəlaɪˈzeɪʃn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] (BrE also globalisation) the process of making sth. such as a business operate in a lot of different countries all around the world, or the result of this 全球化",
                              "example": "Economic globalization has changed the nature of competition among cities in developing countries."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f2dc532dbdd01917c016005b711e7570921a02a8_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "tuna",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtju:nə/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] (pl. tuna or tunas) 金枪鱼（肉）",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6e82731fba3274e7b9263e62d8c137737c072e14_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "originate",
              "pee": [
                  {
                      "partOfSpeech": "/əˈrɪdʒəˌneɪt/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(fml.) (~ from / in) come from a particular place or start in a particular situation 开始；发源",
                              "example": "All theories originate from practice and in turn serve practice. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/37c758571f24c7e284202569e1b948030b4369be_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "conserve",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈsɜːv/【vi.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "reduce the amount of money, time, goods, etc. that you use 削减；节省",
                              "example": "He tried to conserve on fuel during the long winter."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "vt. ",
                      "explanations_and_examples": [
                          {
                              "explanation": "keep sth. from being wasted, damaged, lost, or destroyed 保护；保存",
                              "example": "We must conserve our forests and woodlands for our future generations."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/84edbebd34689a78f578b6391750cb8625282f25_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "excess",
              "pee": [
                  {
                      "partOfSpeech": "/ɪkˈses/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U, sing.] a larger amount of sth. than is allowed or needed 过分；过量",
                              "example": "The test revealed an excess of alcohol in the driver's blood."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6d3c873a76ed815acea7f238217b83626adc5731_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "leftover",
              "pee": [
                  {
                      "partOfSpeech": "/ˈleftˌəʊvə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(~s) [pl.] food remaining uneaten after a meal 剩饭菜",
                              "example": "At my grandma's, I sometimes had leftovers and it was my grandpa who ate them."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "a.",
                      "explanations_and_examples": [
                          {
                              "explanation": "(only before noun) remaining after all the rest has been used, taken, or eaten 未用完的；剩余的；未吃完的",
                              "example": "This recipe makes use of leftover chicken from the roast chicken recipe."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e38a75554081ab84358d4e8864ab5d4d7278fe83_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "mayonnaise",
              "pee": [
                  {
                      "partOfSpeech": "/ˌmeɪəˈneɪz/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 蛋黄酱",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e9b22f575386221be967bf8e5f994872c0b806ff_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "lettuce",
              "pee": [
                  {
                      "partOfSpeech": "/ˈletɪs/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] 莴苣；生菜",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0c63f87b782cfcfeef193d8c147d1061785a6460_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "convention",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈvenʃn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [C, U] behavior and attitudes that most people in a society consider to be normal and right 惯例；常规；习俗",
                              "example": "It is a matter of convention that businessmen should wear suit. "
                          },
                          {
                              "explanation": "2) [C] a large formal meeting for people who belong to the same profession or organization or who have the same interests 大会；会议；集会",
                              "example": "They have chose him to represent their city at the convention. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/90048f8ae792a68fba1353e4d200afc928dc75a9_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "turnover",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtɜːnˌəʊvə/【n.】[U, sing.]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) the rate at which goods are sold in a shop or store and replaced by others （商店的）货物周转率",
                              "example": "The store greatly reduced the prices to make a quick turnover."
                          },
                          {
                              "explanation": "2) [U, sing.] (BrE) the amount of business done during a particular period 营业额",
                              "example": "I believe they've doubled their turnover since those advertisements appeared in the press."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1414ed689c40fdb2d452083b6fd4147419810fd9_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "canned",
              "pee": [
                  {
                      "partOfSpeech": "/kænd/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(of food) preserved in a tin （食物）罐装的",
                              "example": "They tend to buy cheap processed foods like canned chicken. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3d32db65b95551c0788653f7484999139648b99e_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "downside",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdaʊnˌsaɪd/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[sing.] the disadvantage or negative aspect of sth. 不利方面",
                              "example": "There is a downside of living in the countryside: It takes long time to commute to work."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cd0e2fd0c13ba5d96a1368dfdea9a1ca17ede3b2_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "popularity",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpɒpjʊˈlærəti/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "the state of being liked, enjoyed, or supported by a large number of people 流行；受欢迎",
                              "example": "We are doing a weekly poll on the president, and clearly his popularity has declined."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/13a50808c4a9ded50ea39e86426b43b1af39da98_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "unintended",
              "pee": [
                  {
                      "partOfSpeech": "/ˌʌnɪnˈtendɪd/ a. ",
                      "explanations_and_examples": [
                          {
                              "explanation": "not deliberate 无意的；无心的",
                              "example": "Technological advances are often accompanied by unintended consequences such as pollution and global warming."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/140ee2904b30905c9cf7b91549f958429f81a412_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "scrap",
              "pee": [
                  {
                      "partOfSpeech": "/skræp/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (~s) [pl.] food left after a meal 残羹剩饭",
                              "example": "The rats run around, searching for scraps in the rubbish."
                          },
                          {
                              "explanation": "2) [C] a small piece of paper, cloth, etc. 小片；小块；碎屑",
                              "example": "He wrote his address on a scrap of paper. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/442ffc26a7a8776307c1d52797ced6b5d6af21f3_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "conscience",
              "pee": [
                  {
                      "partOfSpeech": "/ˈkɒnʃ(ə)ns/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the part of your mind that tells you whether what you are doing is morally right or wrong 良心；良知",
                              "example": "I have battled with my conscience over whether I should actually send this letter."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cdec9f4800c0d7e782b63a302f5789dee2a5f377_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "environmentalism",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˌvaɪrənˈmentlɪz(ə)m/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the study of the environment and the belief that it must be protected from damage by human activities 环境保护主义",
                              "example": "The teacher asked the students to find more information on environmentalism on the Internet."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/927de0c345af2591c3ca8701849ffbf672067485_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "elite",
              "pee": [
                  {
                      "partOfSpeech": "/ɪˈli:t/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a group of people who have a lot of power and influence because they have money, knowledge, orspecial skills （社会）精英；上层人士",
                              "example": "In this country, only the elite can afford an education for their children."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dca4b35cbb2b9f87b6335e31abaffaf0d40a94db_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "chafing dish",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtʃeɪfɪŋ ˌdɪʃ/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a metal pan over a heater, used to cook or to keep things warm at the table （有加热装置的）火锅，暖锅",
                              "example": "Last Friday I got back to town and had chafing dishes with my family members."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d0923c914cd4bcea7ac5339b5952636584ba8d86_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "layer",
              "pee": [
                  {
                      "partOfSpeech": "/ˈleɪə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "an amount or piece of a material or substance that covers a surface or that is between two other things 表层；层",
                              "example": "There is a thin layer of coal between the two layers of rock."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c0bd1b69e2759a0c2d42cea82c777f206dd8ac32_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "triangle",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtraɪæŋgl/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 三角形；三角形物体",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/12f75a152513a6f9fe0cc5124a38d45d197aed57_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "toothpick",
              "pee": [
                  {
                      "partOfSpeech": "/ˈtu:θˌpɪk/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 牙签",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/80f5437f1f3f4d430617925f466ecc57dc0e3398_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "combination",
              "pee": [
                  {
                      "partOfSpeech": "/ˌkɒmbɪˌneɪʃn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [U] the act of combining or state of being combined 联合；组合",
                              "example": "After running through the numbers in every possible combination, we finally hit on a solution."
                          },
                          {
                              "explanation": "2) [C] two or more things joined or mixed together to form a single unit 结合体；联合体；混合体",
                              "example": "The best approach may well be to use a combination of both methods."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cf2ee22d3bef26320641b02cc44456cbe11341af_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "elegance",
              "pee": [
                  {
                      "partOfSpeech": "/ˈelɪgəns/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the quality of being attractive and showing a good sense of style 高雅",
                              "example": "In the dining room the decoration creates an atmosphere of elegance."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fbb016511ec23e5bdcb33a5a192344b41207f75c_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "permanent",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5213eb902b703ed231283460f4a3df55ad8651e2_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpɜːmənənt/ a. ",
                      "explanations_and_examples": [
                          {
                              "explanation": "lasting or intended to last for a long time or forever 长久的；永久的",
                              "example": "Heavy drinking can cause permanent damage to the brain."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "cuisine",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7428c85074b790569cf56ed39752af964f47c5b4_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/kwɪˈzi:n/ n.[U]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) food cooked in a certain way 菜肴；饭菜",
                              "example": "The dining room has lakeside views and offers excellent cuisine."
                          },
                          {
                              "explanation": "2) a particular style of cooking 烹饪（法）",
                              "example": "Chinese cuisine is an art, which grew out of a highly developed civilization."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "conservative",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d5ad7321b16969d84e020e5eb1f4c0826d267981_96k.mp3#duration=2.1&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈsɜːvətɪv/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "not liking changes or new ideas 保守的；守旧的",
                              "example": "The young people are the most eager to learn and the least conservative in their thinking."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "conservatism",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/db1e0459ec5d62481e69cc11e39bd993e62a1041_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/kənˈsɜːvəˌtɪz(ə)m/ n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] dislike of changes or new ideas 保守；守旧主义",
                              "example": "Jones himself was a curious mixture of radicalism (激进主义) and conservatism. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "loyalty",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7f76eb509e79360205196f6c01fdb114e7e06cff_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈlɔːɪəlti/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "the quality of remaining faithful to your friends, principles, country, etc. 忠诚；忠贞；忠实",
                              "example": "I was deeply impressed by his loyalty to his brother."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "dainty",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d876afcceddb1bb71db32aa9a74578a468243dd0_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdeɪnti/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "small, pretty, and delicate 小巧的；精致的",
                              "example": "We visited her uncle's place and were given tea and some dainty little cakes."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "resign",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/288a7a8d12088b4e726105b8a46a0b1f647c6f3d_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈzaɪn/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "officially announce that you have decided to leave your job or an organization 辞职；放弃（工作、职位）",
                              "example": "Tom has since resigned his membership of the golf club."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "chow mein",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/be89b6add8689a9d446a25eef698b74bdc41a0fb_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌtʃaʊ ˈmeɪn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 炒面"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "doctorate",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/868acc3af443a6a80d5737aa2979db0888d48ee4_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈdɒkt(ə)rət/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a university degree of the highest level 博士学位",
                              "example": "He received his doctorate in political science at Columbia University."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "mystery",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/45c8e56ac53cd15b88c6ed916a0c48f2c512a248_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmɪst(ə)ri/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] sth. which cannot be explained or understood 神秘的事；不可思议的事",
                              "example": "It's a mystery to me how she ever passed that exam."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "specifically",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/10b366e7bd72282f932be4ec7bdea30aed9f3f90_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/spəˈsɪfɪkli/【ad.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "for the stated kind and no other; particularly 专门地；特定地；具体地",
                              "example": "I asked her to repeat specifically the words that Patti had used."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "bun",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/775e861d2ebdfe91fb20b009d08d3cd14567b1cc_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/bʌn/【n.】 [C]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) (BrE also bap) 小圆面包"
                          },
                          {
                              "explanation": "2) (BrE) 小圆糕点"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "gravy",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/983d476276f88307c350c96559be95744f3fb735_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈgreɪvi/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] （调味用的）肉汁"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "classic",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/24b7f65a28a06878dac571424180dcbc1333d7f6_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈklæsɪk/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) of a very typical and well-known kind 典型的",
                              "example": "Too many job hunters make the classic mistakeof thinking only about what's in it for them."
                          },
                          {
                              "explanation": "2) of the highest quality or class and esp. serving as a model 一流的；经典的",
                              "example": "Huckleberry Finn is a classic children's movie."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "filling",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5a5b785d6f349bda65ad27bc89385e81c330d157_96k.mp3#duration=1.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈfɪlɪŋ/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(of food) making one's stomach feel full （食物）耐饥的，果腹的",
                              "example": "Although it is tasty, crab is very filling. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "munch",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/be8e94317896b48381b93d9ff2d3522ed5f3b7b2_96k.mp3#duration=1.3&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/mʌntʃ/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "eat sth. steadily and often noisily, esp. sth. hard and / or dry 大声嚼，用力嚼（尤其硬或干的食物）",
                              "example": "The horse was munching away at my hat."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "canteen",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7ce4b7d62493e66f4378f2faff84246c0821d91b_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/kænˈti:n/ n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (esp. BrE) （工厂、学校等的） 食堂，餐厅"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "dime",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2ae68f27c0830ec376558755c271a913d9abcc95_96k.mp3#duration=2.1&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/daɪm/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] （美国和加拿大的）十分硬币"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "expat",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8f84bda3ccef1307b2ba54a9cea2affc451645da_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/eksˈpæt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (infml.) a person living in a foreign country 居住在国外的人；侨民",
                              "example": "I had the vague idea that I could now vote electronically, but in fact no expat can do so."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "confession",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/157401f627bfa3c6a4a9ee24e81b8081d8907f69_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/kənˈfeʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] the act of admitting one's crimes, faults, etc. 承认；坦白",
                            "example": "I have a confession to make — I scraped (擦坏) your car when I was parking mine."
                        }
                    ]
                }
            ]
        },
        {
            "word": "devote",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈvəut/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "use all or most of your time, effort, etc. in order to do sth. or help sb. 致力；献身；倾注",
                            "example": "After graduating from law school, he devoted his energies to writing films."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/557bc9651cf4feb86d6e30de30f883a78fc5ff63_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "devoted",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈvəʊtɪd/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "showing great fondness or loyalty; caring a great deal 忠实的；热爱...的",
                            "example": "There is absolutely no doubt that this woman was a totally devoted and caring mother."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b454bad9d0f7af548498ea6c9e34cb245f60ebbb_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "insatiable",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈseɪʃəbl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "impossible to satisfy 无法满足的",
                            "example": "The public has an insatiable appetite for stories about the famous people."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cc2440322a0a2d09948c3f2ce31dab95e557d5e8_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "craving",
            "pee": [
                {
                    "partOfSpeech": "/ˈkreɪvɪŋ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a very strong desire for sth. 渴望；热望",
                            "example": "Surprisingly, his headache and fatigue subsided (减轻) and, what is more, his craving for alcohol disappeared."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/346ee60ef5b05734edae3c06b2e81c56e07e23c8_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "tropical",
            "pee": [
                {
                    "partOfSpeech": "/ˈtrɒpɪkl/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "coming from, found in, or typical of the tropics 来自热带的；产于热带的；热带的",
                            "example": "Under normal conditions, the ocean currents of the tropical Pacific travel from east to west."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d72f6131a1ce789b2487abad10dc578240ae029e_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "challenging",
            "pee": [
                {
                    "partOfSpeech": "/ˈtʃælɪndʒɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "difficult in an interesting or enjoyable way 富有挑战性的",
                            "example": "Mike found a challenging job as a computer programmer."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/51b40c94ed1fd0e01d28bb3fb7822a45f33bd46a_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "calculus",
            "pee": [
                {
                    "partOfSpeech": "/ˈkælkjʊləs/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] 微积分",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0f6978e8effb257ed622a8a515d33eb808dfa13f_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "adjust",
            "pee": [
                {
                    "partOfSpeech": "/əˈdʒʌst/【v.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "gradually become familiar with a new situation （使）适应；（使）习惯",
                            "example": "I felt I had adjusted to the idea of being a mother very well. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/05a2291cc1e14a1060ee36fd0e910b23d9ad0720_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "dorm",
            "pee": [
                {
                    "partOfSpeech": "/dɔːm/【n.】 [C]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (BrE hall of residence, infml.) （大学里的）学生宿舍楼",
                            "example": ""
                        },
                        {
                            "explanation": "2) (esp. BrE, infml.) 大寝室；宿舍"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/631b0b507a30122176f7a32378c35d40f2755da9_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "zucchini",
            "pee": [
                {
                    "partOfSpeech": "/zʊˈki:ni/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (pl. zucchini or zucchinis) (BrE courgette) （绿皮）密生西葫芦",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ef82bf1852bf3bb9a20e25be8fd1c89e37f0d026_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "cucumber",
            "pee": [
                {
                    "partOfSpeech": "/ˈkju:ˌkʌmbə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] 黄瓜",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/17434cdd4d6ec4b9a795f69ebb8183064fa1be1d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "disposal",
            "pee": [
                {
                    "partOfSpeech": "/dɪˈspəʊzl/【n.】 [U]",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) the power or opportunity to use sb. / sth. 处置权",
                            "example": "During their visit, I put my car at their disposal."
                        },
                        {
                            "explanation": "2) the act or means of getting rid of sth. 清理；处理",
                            "example": "We should not give up this option for the disposal of nuclear waste."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/556b801fe8f83cada7854f1216cd5c8b20f71751_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "peruse",
            "pee": [
                {
                    "partOfSpeech": "/pəˈru:z/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) examine or consider with attention and in detail 仔细研究；仔细考虑",
                            "example": "Officials of the union are perusing the deal."
                        },
                        {
                            "explanation": "2) (fml.) read sth, esp. in a careful way 读；（尤指）细读，精读",
                            "example": "She found the information while she was perusing a copy of Life magazine."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0119be536d6c396ddd7f71b825d1118e56f9d362_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "grimly",
            "pee": [
                {
                    "partOfSpeech": "/grɪmli/【ad.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) in a worried or unhappy way 担忧地；不快地",
                            "example": "We have to get those windows open,I announced grimly to my husband."
                        },
                        {
                            "explanation": "2) seriously 严肃地",
                            "example": "Now, I can wait for you,he said grimly, but hurry up."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d5b3891e559075bbb4a266d9efe7a88de7b47ffa_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "mealy",
            "pee": [
                {
                    "partOfSpeech": "/ˈmi:li/a. ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fruits or vegetables) dry and not tasting good （水果或蔬菜）干巴难吃的",
                            "example": "The apples we bought yesterday are kind of mealy."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3cbc338a2ce0d6c7ccb8c24c3707499a00d0310d_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "pinkish",
            "pee": [
                {
                    "partOfSpeech": "/ˈpɪŋkɪʃ/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "of a light shade of red 浅粉红色的",
                            "example": "Her nostrils (鼻孔) were pinkish, as though she had a cold."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ea6872749012992a3266567706d8dda3b2ee260a_96k.mp3#duration=2.1&t=.mp3"
        },
        {
            "word": "iceberg lettuce",
            "pee": [
                {
                    "partOfSpeech": "/ˌaɪsbɜːg ˈletɪs/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] 卷心莴苣",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a0ab57de2cf2ee65c0d242dc87503485f9a91b25_96k.mp3#duration=2.2&t=.mp3"
        },
        {
            "word": "wrap",
            "pee": [
                {
                    "partOfSpeech": "/ræp/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(also ~ up) put paper or cloth over sth. to cover it （用纸或布）包，裹（某物）",
                            "example": "He wrapped a bandage around my injured wrist."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3ace1261e76fd960ddb12d6712e54c6a6cffe2f0_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "wrapper",
            "pee": [
                {
                    "partOfSpeech": "/ˈræpə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] the piece of paper or plastic that covers sth. when it is sold （商品的）包装纸（塑料）",
                            "example": "The kids were asked to put the sweet wrappers into the rubbish bin. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f07f5a2dbf262f3d6657a98fea60fd742b689ffa_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "peel",
            "pee": [
                {
                    "partOfSpeech": "/piːl/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] the skin of some fruits and vegetables, esp. the thick skin of fruits such as oranges, which you do not eat （水果和蔬菜的）外皮（尤指橙子等不能食用的厚皮）",
                            "example": "Usually, we speak of orange peel and apple peel, but of tomato skin."
                        }
                    ]
                },
                {
                    "partOfSpeech": "vt.",
                    "explanations_and_examples": [
                        {
                            "explanation": "remove the skin from fruits or vegetables 剥去（削去）（水果或蔬菜）的皮",
                            "example": "She sat down in the kitchen and began to peel potatoes."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9fa033d3e98471d1efc39d163c833d742ab0b868_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "unworldly",
            "pee": [
                {
                    "partOfSpeech": "/ʌnˈwɜːldli/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) not having a lot of experience of life 不谙世故的；天真的",
                            "example": "I cannot believe you have such unworldly views on things as a grown man."
                        },
                        {
                            "explanation": "2) not interested in money or possessions 对钱财不感兴趣；脱俗的",
                            "example": "As a bit unworldly singer, he hates commercial advertising and social activities."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cb28a2ffaa8d81e13abc2d1a29dcbd97cc969aa1_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "cultured",
            "pee": [
                {
                    "partOfSpeech": "/ˈkʌltʃəd/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "having or showing good education, manners, and an interest in art, music, literature, etc. 有文化的；有教养的；有修养的",
                            "example": "The people who will be on the committee are moral, cultured, and competent. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c292ada12322a2c7987e0e2f8067d8777bee506d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "realization",
            "pee": [
                {
                    "partOfSpeech": "/ˌrɪəlaɪˈzeɪʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U, sing.] (BrE also realisation) the process of becoming aware of sth. 认识；意识；领悟",
                            "example": "There is now a growing realization that things cannot go on like this for much longer."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/70a93b86b2f6bf6967b9b239f64662c06d910bd9_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "grant",
            "pee": [
                {
                    "partOfSpeech": "/gra:nt/【vt.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) (take sb. / sth. for granted) be so used to sb. / sth. that you do not recognize their true value any more and do not show that you are grateful （因习以为常）视...为理所当然（而对其不重视）",
                            "example": "I came into adult life clueless about a lot of things that most people take for granted."
                        },
                        {
                            "explanation": "2) (fml.) give sb. sth. or allow them to have sth. that they have asked for 给予；准予",
                            "example": "In response to the lawyer's appeals, the Home Secretary granted a free pardon (赦免). "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d1b48845984a1bcf740aff3abe7b4366b1d232d_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "motivation",
            "pee": [
                {
                    "partOfSpeech": "/ˌməʊtɪˈveɪʃn/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) [C] the reason why you want to do sth. 动机；原因",
                            "example": "What was your motivation for becoming a doctor?"
                        },
                        {
                            "explanation": "2) [U] eagerness and willingness to do sth. without needing to be told or forced to do it 动力；积极性",
                            "example": "Jack is an intelligent pupil, but he lacks motivation."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6ce6e7cedcedfc5c262918a3ad05eaf0f3832574_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "priority",
            "pee": [
                {
                    "partOfSpeech": "/praɪˈɒrəti/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] sth. that needs attention, consideration, service, etc. before others 优先处理的事；当务之急",
                            "example": "After several burglaries (入室盗窃) in the area, security is now a high priority."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/eb2cc533fc67c8f3bbeda84f5fd5010ceb5b8a3c_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "golden",
            "pee": [
                {
                    "partOfSpeech": "/ˈgəʊld(ə)n/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "of the color of gold 金色的",
                            "example": "He was so attracted by the girl with golden hair that he did not hear anything his father said."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/de7322f4dc35f1f1f75120d95cad80d594357258_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "yolk",
            "pee": [
                {
                    "partOfSpeech": "/jəʊk/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] 蛋黄",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/19db73228d9044f3930d3a721c82c3312d2eb770_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "crunch",
            "pee": [
                {
                    "partOfSpeech": "/krʌntʃ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "the sound of sth. being crushed or like sth. being crushed or broken 嘎吱的响声",
                            "example": "I heard a loud crunch as the truck ran into the wall."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cced435b0fed941480267f5e7b5731d9920fb1a8_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "organic",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6d99e462d802e8d62bc64d0f0a709f74d650df95_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ɔːˈgænɪk/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "relating to farming or gardening methods of growing food without using artificial chemicals, or produced or grown by these methods 不使用化肥的；有机的； 绿色的",
                            "example": "Now organic farming is expanding everywhere in China."
                        }
                    ]
                }
            ]
        },
        {
            "word": "free-range",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/08ecc3287f6664f77704e21d4221c543d21b198c_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌfri: ˈreɪndʒ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "relating to a type of farming which allows animals such as chickens and pigs to move around and eat naturally, rather than being kept in a restricted space 放养的；散养的",
                            "example": "She says that free-range chickens taste much better than factory-farmed ones."
                        }
                    ]
                }
            ]
        },
        {
            "word": "participate",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1d8d2573cd854bfe0ec507b08f989a67f2d3064b_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/pɑːˈtɪsɪˌpeɪt/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) take part in an activity or event 参加；参与",
                            "example": "China will actively participate in global affairs and play a constructive role in it."
                        }
                    ]
                }
            ]
        },
        {
            "word": "melt",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/12d531c6129cfccf1d345ea0692daa795b1353bf_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/melt/【v.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "become or make sth. become liquid as a result of heating （使）熔化，融化",
                            "example": "The snow had melted, but the lake was still frozen solid."
                        }
                    ]
                }
            ]
        },
        {
            "word": "sustenance",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/059f7eed82ef32fbdd373286c2b1826f9e008b7b_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈsʌstənəns/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] (fml.) food which keeps people or animals strong and healthy 营养；食物",
                            "example": "Throughout human history we have depended on nature for sustenance, well-being, and development."
                        }
                    ]
                }
            ]
        },
        {
            "word": "profound",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/af69df80fa1b626e99eaef7841e94355428f1e87_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/prəˈfaʊnd/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "very great 巨大的；重大的",
                            "example": "The mother's behavior has a profound impact on the developing child. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "far-reaching",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/71262b15ae5e11e8764e368e0591717801de2c64_96k.mp3#duration=2.2&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌfɑːˈri:tʃɪŋ/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "having a great influence or effect 影响深远的",
                            "example": "The report outlines the most far-reaching changes in housing policy for 30 years."
                        }
                    ]
                }
            ]
        },
        {
            "word": "grave",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4c765ec2f27a9eddef00bc69f51d6102d0a6d247_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/greɪv/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "grave problems, situations, or worries are very great or bad 严重的；重大的；严峻的",
                            "example": "The situation poses a grave threat to world peace."
                        }
                    ]
                },
                {
                    "partOfSpeech": "n.",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a place in the ground where a dead body is buried 墓穴；坟墓",
                            "example": "She tore the rose apart and scattered the petals (花瓣) over the grave."
                        }
                    ]
                }
            ]
        },
        {
            "word": "prediction",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/133fff77a52c1f4afe1ccae6b452495bcfb5266b_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/prɪˈdɪkʃn/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] a statement about what you think is going to happen, or the act of making this statement 预言；预测",
                            "example": "He was unwilling to make a prediction about which books would sell well in the coming year."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "reach out to",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "ask sb. for help 请求...的帮助",
                              "example": "She urged him to reach out to his family."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/456f06b5166a4111081e46a6c03e8a1682a9f56f_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "of one's choosing / choice",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "that you choose by yourself 自己选择（或选定）的",
                              "example": "Meals on a tour like ours could be eaten in any restaurant of one's choosing."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cd05edb3c06a69da325ec9ef735b27d4741701e0_96k.mp3#duration=4.2&t=.mp3"
          },
          {
              "word": "fill (sb.) up",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(make you) eat enough food so that you no longer feel hungry 使吃饱",
                              "example": "They filled me up with cakes and sandwiches."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f897d7127025503d9f63e6f6a24106b4f9ae7d43_96k.mp3#duration=3.6&t=.mp3"
          },
          {
              "word": "from scratch",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "if you start sth. from scratch, you begin it without using anything that existed or was prepared before 从头做起；从零开始",
                              "example": "It's completely ruined, so we'll have to start from scratch."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/93c18f70ee7923746737cf75abd1acc7a255d6e2_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "come up with",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "think of an idea, answer, etc. 想出，提出（主意、答案等）",
                              "example": "The airline has come up with a novel solution to the problem of jet lag."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9b5be0133c99ba5da290305332d5716921e2cb6b_96k.mp3#duration=2.2&t=.mp3"
          },
          {
              "word": "speed up",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/da468fa325bf9086b351c5d0930aaa6538fa61a3_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(cause to) move, go, or happen faster （使）加速，增速",
                              "example": "Speed up! We need to get there in time."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "to go",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7dba95a7e45ac1457e83c7dea15effd8998a7c5c_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(AmE) (of cooked food sold in a shop) be taken away and not eaten in the shop （食物）带出餐馆吃的，外卖的",
                              "example": "Two chicken dinners with corn to go, please, he said in a hurry."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "call for sth.",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4a09f831070b2b41f97cea2a8726660ae0ad942b_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "need sth. 需要",
                              "example": "This kind of work calls for a lot of patience."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "to this day",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2a129a79ac21b72b78e800a560a16d11acf16fff_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "up to and including the present moment 至今",
                              "example": "Even to this day we don't know what happened for sure."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "thanks to",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d1b5a33be0b4d952fc7d550b7f100b6dce62d226_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "because of 由于；因为",
                              "example": "The company has had a successful year, thanks to the improvement in export sales."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "get (sb.) through",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "pass or assist sb. in passing (a difficult, testing experience, or period) 熬过或助人熬过（困境）",
                            "example": "I don't know how we're going to get through the winter."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/54e4ccf1f0e963ab0a3d8be2181150b27f39d94e_96k.mp3#duration=4.2&t=.mp3"
        },
        {
            "word": "make fun of",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "laugh, or cause others to laugh, rather unkindly at 嘲笑；取笑",
                            "example": "People make fun of her because she wears such strange hats."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8a7b5ff73df653b4ac950104b34be526ccc72c04_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "at one's disposal",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fd2fdef8a6ceb275b68b1bcffc216058b197282d_96k.mp3#duration=2.7&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "able to be used freely by sb. 供某人支配",
                            "example": "We will use all the means at our disposal to solve this problem."
                        }
                    ]
                }
            ]
        },
        {
            "word": "pick out",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3487d229f67c11fb2585d1cddd4de0e006fd6c28_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "recognize sb. / sth. in a group of people or things 分辨出；辨认出",
                            "example": "Steven describes himself as \"a regular guy — you couldn't pick me out of a crowd.\""
                        }
                    ]
                }
            ]
        },
        {
            "word": "keep sth. to oneself",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c4630b3785acabd0f00443e4e71e20bf3d0cf7d6_96k.mp3#duration=3.2&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "not tell anyone about sth. 把...秘而不宣；不将...说出去",
                            "example": "I have to tell someone. I can't keep it to myself."
                        }
                    ]
                }
            ]
        },
        {
            "word": "be far removed from sth.",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e960ae8a5351e63bbf1749a11abf598e56f69021_96k.mp3#duration=3.3&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "",
                    "explanations_and_examples": [
                        {
                            "explanation": "be very different from sth; not be connected with sth. 与...大相径庭；与...不相干",
                            "example": "Many of these books are far removed from the reality of the children's lives. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "rely on",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f0e2b215e9450a291659e0922dd3ad045f6662c9_96k.mp3#duration=2.1&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "be dependent on 依靠",
                            "example": "They have to rely on the river for their water."
                        }
                    ]
                }
            ]
        },
        {
            "word": "in season",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c41eb5f1f1e5c61a221bcda156091366def63fab_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(of fruits or vegetables) easily available and ready to eat because it is the right time of year for them （水果或蔬菜）当令的",
                            "example": "These are the dog days (伏天); watermelons are just in season."
                        }
                    ]
                }
            ]
        },
        {
            "word": "next to",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8a565710525fec449dfc333b3fe082cbdb4fe944_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "following in order or importance after sb. / sth. 仅次于；紧接",
                            "example": "Next to biology, I like physics best."
                        }
                    ]
                }
            ]
        },
        {
            "word": "for the most part",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ad41e87816e2b86b8fbb4bbb08e7129a7383675e_96k.mp3#duration=2.1&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "mostly; usually 通常；多半",
                            "example": "These small pieces of land were purchased for the most part by local people. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "down / along the road",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ef5336af2d039a3c757b6b54d701668e148974e5_96k.mp3#duration=3.9&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "in the future 在将来；今后",
                            "example": "She might be able to help you pursue a promotion down the road."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "Megan Elias",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/20f09811cc8256f0c548f78f837fcd133c03cf75_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌmegən ɪˈlaɪəs/",
                      "explanations_and_examples": [
                          {
                              "explanation": "梅甘・伊莱亚斯（人名）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Boston University",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/84bd98590ba4caf17c1c44d0415c52a54ee978ef_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "波士顿大学（美国大学，位于马萨诸塞州）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Paul Freedman",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3bc8b7eee5edf77c76031df43498a6f44a6a6bc9_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈfri:dˌmæn/",
                      "explanations_and_examples": [
                          {
                              "explanation": "保罗・弗里德曼（人名）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Yale University",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/480c215dd6e24a027191c15a68267d15e3f3720b_96k.mp3#duration=2.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "耶鲁大学（美国大学，位于康涅狄格州）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Waldorf",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d9765a429fb3ae44b630b73c758217f768ff11c7_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈwɔːldɔːf/",
                      "explanations_and_examples": [
                          {
                              "explanation": "沃尔多夫（人名）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Wallis Simpson",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d8dbad28289dcebacaaf4c63fc41b06f859e8dea_96k.mp3#duration=2.0&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌwɒlɪs ˈsɪmps(ə)n/",
                      "explanations_and_examples": [
                          {
                              "explanation": "沃利斯・辛普森（温莎公爵夫人、爱德华八世的妻子）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Edward VIII",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/801f383327e48e3a37ded5d999a11e144602e665_96k.mp3#duration=2.3&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "爱德华八世（英国国王，后放弃王位）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Fall River",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b571d51aedf0b6f28a25c30d5d2c0932a244f354_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "福尔里弗（美国城市，位于马萨诸塞州）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Massachusetts",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5affecbb1dcc7e4980ae8abb15572b6e7f3e0753_96k.mp3#duration=2.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌmæsəˈtʃu:sɪts/",
                      "explanations_and_examples": [
                          {
                              "explanation": "马萨诸塞州（位于美国东北部）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Imogene Lim",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/65c9a183510e350557e13db9b4c5a0814a341fe3_96k.mp3#duration=2.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪmədʒi:n ˈlim/",
                      "explanations_and_examples": [
                          {
                              "explanation": "伊莫金・利姆（人名）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "VancouverIsland University",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ebee9582ce171c950988210452230cf80402503c_96k.mp3#duration=3.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/vænˈku:və/",
                      "explanations_and_examples": [
                          {
                              "explanation": "温哥华岛大学（加拿大大学，位于不列颠哥伦比亚省）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Brown University",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/22ac35c77f5a6c13eeb86106651d33eb0849a504_96k.mp3#duration=2.5&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "布朗大学（美国大学，位于罗得岛州）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "New England",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d90e3b4296379eadb3327b72eeaa17bbf541d4ff_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "新英格兰（美国东北部地区）"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "Appalachia",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5c44427900bb8a62cea6a8193ca9033b813b8330_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌæpəˈleɪtʃiə/",
                    "explanations_and_examples": [
                        {
                            "explanation": "阿巴拉契亚（美国东部地区）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "iPod",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/51523c857b636493e8a5ee6ef5b182e17c2d8c09_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "苹果公司推出的便携式多功能数字多媒体播放器"
                        }
                    ]
                }
            ]
        }
      ]
  }
]

book2[6] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "cabin",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bc478cc39f65a1b0e361142ef9eb376d8b6ebf9e_96k.mp3#duration=1.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈkæbɪn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] （尤指建于林中或山上的）小木屋",
                              "example": ""
                          }
                      ]
                  }
              ]
          },
          {
              "word": "meteor",
              "pee": [
                  {
                      "partOfSpeech": "/miːtiə/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 流星",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9d1895a73edc12dea928068e2d87c148e57df97f_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "smoky",
              "pee": [
                  {
                      "partOfSpeech": " /ˈsmaʊki/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "having the appearance, smell, or taste of smoke 似烟的；有烟熏味的",
                              "example": "Standing on the platform, we could see the smoky outline of the farther shore. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0d28a9c33d5b0a76a07b5921929033a249e6c25d_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "trail",
              "pee": [
                  {
                      "partOfSpeech": "/treɪl/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a long line or a series of marks that have been left by sb. / sth. 痕迹",
                              "example": "The wounded elephant left a trail of blood behind it."
                          }
                      ]
                  },
                  {
                      "partOfSpeech": "v.",
                      "explanations_and_examples": [
                          {
                              "explanation": "pull sth. behind you, esp. along the ground, or be pulled in this way 拖；拉；拖在后面",
                              "example": "A plane trailing a banner was circling overhead."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5f2cdfe0057bfcc0f0db2dbd277b8d19256dce89_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "sugary",
              "pee": [
                  {
                      "partOfSpeech": "/ˈʃʊgəri/",
                      "explanations_and_examples": [
                          {
                              "explanation": "like sugar 糖状的；粒状表面的",
                              "example": "Rhyolites (流纹岩) are rocks with a rather distinctive sugary texture or feel."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f51e6fee24b25a6c600cd06eb050f8c377ff0367_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "winter solstice",
              "pee": [
                  {
                      "partOfSpeech": "/ˌwɪntə ˈsɒlstɪs/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 冬至",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/717d86ba302ffa38e23377208b3bdbf78e20a317_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "irreplaceable",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɪrɪˈpleɪsəbl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "too special, valuable, or unusual to be replaced by anything else （因太特别、贵重或少见而）不可替代的，独一无二的",
                              "example": "The works of art that were burned in the big fire are irreplaceable."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5d4f92b0f1e1d4c871aab74d0ad8875a3998c2c3_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "rhythm",
              "pee": [
                  {
                      "partOfSpeech": "/ˈrɪðəm/【n.】 [C, U] ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) a regular pattern of changes 规则变化；节律模式；节奏",
                              "example": "Long journeys can disrupt your body's natural rhythm. "
                          },
                          {
                              "explanation": "2) a regular repeated pattern of sounds or movements 节律；节拍；节奏",
                              "example": "She started moving to the rhythm of the music."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/045bedd41b9ee9cb5e2bdcf3b014cd581f6f1d4b_96k.mp3#duration=1.1&t=.mp3"
          },
          {
              "word": "nightfall",
              "pee": [
                  {
                      "partOfSpeech": "/naɪtˌfɔːl/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the time when it begins to get dark in the evening 黄昏；傍晚",
                              "example": " Don't worry, Michael. We'll all be back by nightfall."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d1e9f4600e1392ff2bc6252cfbbb445d9867acfb_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "artificial",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɑːtɪˈfɪʃl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "not real or not made of natural things but made to be like sth. that is real or natural 人造的；人工的",
                              "example": "Energy is being wasted by using artificial lighting when daylight is adequate."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/351b87244779aa6a7d2689b6a3021dfc44b264c0_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "night shift",
              "pee": [
                  {
                      "partOfSpeech": "/ˈnaɪt ˌʃɪft/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a period of time at night when people regularly work, esp. in a factory （尤指工厂的）夜班",
                              "example": "She is on the night shift this week, but on the day shift next week."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/844341f9b148ea4a8a882c57c5359331ebd87444_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "probable",
              "pee": [
                  {
                      "partOfSpeech": "/ˈprɒbəbl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "likely to exist, happen, or be true 可能存在的；可能发生的；很可能的",
                              "example": "The probable result of global warming will be a rise in sea levels."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6b040b90d6a81559a3ddf4c5341e549a1a6242c6_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "reduction",
              "pee": [
                  {
                      "partOfSpeech": "/rɪˈdʌkʃn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a decrease in the amount, size, or price of sth., or the act of decreasing sth. （数量、尺寸或价格的）减少，缩小，下降",
                              "example": "The company promised they would make no staff reductions for at least two years. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/249c443f93236cc3ec38271ed278286bb29ec811_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "hormone",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhɔːməʊn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 激素；荷尔蒙",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/25009a6746a6703cd00e5ba8824ed6d76a89ed97_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "melatonin",
              "pee": [
                  {
                      "partOfSpeech": "/ˌmeləˈtəʊnɪn/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 褪黑激素 （有时用作安眠药）",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cfa26bbfdbcc8a45ba57b0115b043af84d3330e9_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "disorder",
              "pee": [
                  {
                      "partOfSpeech": "/dɪsˈɔːdə/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (medical) a mental or physical illness which prevents part of your body from working properly 失调；紊乱；障碍",
                              "example": "After weeks of tests they discovered that he had a rare disorder of the lung."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8fc76dfcddffedf444f8841b4a6825a16faa36e_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "diabetes",
              "pee": [
                  {
                      "partOfSpeech": "/ˌdaɪəˈbi:ti:z/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 糖尿病",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4748226e704e8bdaf79292f07e08a645dc8f5132_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "obesity",
              "pee": [
                  {
                      "partOfSpeech": "/əʊˈbi:səti/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] a condition in which sb. is too fat in a way that is dangerous for their health 过度肥胖",
                              "example": "Obesity can lead to heart disorders and other health problems."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/01ad92dde006725f1aef94bcf0ed917fc48bdff1_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "migrate",
              "pee": [
                  {
                      "partOfSpeech": "/maɪˈgreɪt/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(of birds, animals, etc.) travel regularly from one part of the world to another （鸟、兽等）迁徙",
                              "example": "More than two million ducks migrate to the lake each fall."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8951dbd24f3722e5d915f9800ba0a7b42f5a43f_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "sea turtle",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsi: ˌtɜːtl/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (AmE also turtle) 海龟",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a7f0ca94eadcddfa0567bd53e8f5e4ad352d23ed_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "pest",
              "pee": [
                  {
                      "partOfSpeech": "/pest/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a small animal or insect that destroys crops or food supplies （毁坏庄稼或食物的）有害小动物，害虫",
                              "example": " I hope it won't be long before we can get rid of the pests altogether."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5f949c2d1405cd6dd1002e34709dff596fb07c74_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "bulldozer",
              "pee": [
                  {
                      "partOfSpeech": "/ˈbʊlˌdəʊzə/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] 推土机",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d32c65ac8d090092cd7f551181998bcbb4e0439_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "habitat",
              "pee": [
                  {
                      "partOfSpeech": "/ˈhæbɪˌtæt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] the natural home of a plant or animal （动植物的）生活环境；（动物的）栖息地",
                              "example": "These measures will protect the habitat of endangered species such as wolves. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/67768e04d528e3b8086c9526b1ff559bb652a853_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "disrupt",
              "pee": [
                  {
                      "partOfSpeech": "/dɪsˈrʌpt/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "prevent sth. from continuing in its usual way by causing problems 扰乱；使混乱",
                              "example": "Climate change and extreme weather could seriously disrupt the agricultural economy."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f33ac1695d512c4b8554bf30c0d30adfa64c63d3_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "ecosystem",
              "pee": [
                  {
                      "partOfSpeech": "/ˈi:kəʊˌsɪstəm/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] all the animals and plants in a particular area, and the way in which they are related to each other and to their environment 生态系统",
                              "example": "Many species of burrowing (掘洞的) insects are essential for maintaining a healthy soil ecosystem. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a137c2556c0cd5d2778663d02ad1449ac6bd9b15_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "collapse",
              "pee": [
                  {
                      "partOfSpeech": "/kəˈlæps/【vi.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) suddenly fail or become too weak to continue 突然失败；垮掉；崩溃",
                              "example": "The country's auto industry nearly collapsed due to increased foreign competition."
                          },
                          {
                              "explanation": "2) fall down or fall in suddenly, often after breaking apart 倒坍；塌下",
                              "example": "The roof collapsed under the weight of snow."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fb2644e449a378636f3ed2e1b67e684096cc9fa2_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "illuminate",
              "pee": [
                  {
                      "partOfSpeech": "/ɪˈlu:mɪˌneɪt/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make a light shine on sth., or fill a place with light 照射；照亮",
                              "example": "A small path was illuminated by orange lamps concealed in the flower beds. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bd967290c676d6a64a6d7970caf0592713fd8da5_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "intimate",
              "pee": [
                  {
                      "partOfSpeech": "/ˈɪntɪmət/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) private and friendly so that you feel comfortable 幽静舒适的；温馨的",
                              "example": "The guests at the country club always enjoy its intimate atmosphere."
                          },
                          {
                              "explanation": "2) having an extremely close friendship 亲密的；密切的",
                              "example": "We're not on intimate terms with our neighbors."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a3564db76ddd62528ee0cb82992cf83edae01e05_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "flame",
              "pee": [
                  {
                      "partOfSpeech": "/fleɪm/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] hot bright burning gas that you see when sth. is on fire 火焰",
                              "example": "They sat around the campfire, watching the flickering (摇曳的) flames."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4373373682f833c042115ca19adf30a06519a038_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "solitude",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsɒləˌtju:d/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] the state of being completely alone, esp. when this is pleasant or relaxing 独处",
                              "example": "He spent his free time in solitude, reading or walking in the hills."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8585909429323955d0af5d364435de694cd213f5_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "invaluable",
              "pee": [
                  {
                      "partOfSpeech": "/ɪnˈvæljuəbl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "extremely useful 极有价值的",
                              "example": "His experience of teaching in overseas schools proved invaluable. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0d59f4d9147544cc80e0a5f93297949038aced79_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "soulful",
              "pee": [
                  {
                      "partOfSpeech": "/ˈsəʊlfl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "expressing deep, usu. sad, emotions 深情的；伤感的",
                              "example": "Jeanne was a romantic, mysterious young woman with soulful blue eyes and brown skin."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c29f469f7417836599f6390d6d888fb06ee10011_96k.mp3#duration=1.2&t=.mp3"
          },
          {
              "word": "starry",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/70e6f7b645434f3abcbe179da88e94bc05602478_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈstɑːri/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "having many stars 布满星星的",
                              "example": "We had our dinner on the grassland underneath a starry sky."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "blanket",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0df0e00c9e400de97c82aa75cf5887c8379fcd4a_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈblæŋkɪt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) [sing.] a thick covering or area of sth. 厚（的覆盖）层",
                              "example": "The valley was covered with a blanket of mist."
                          },
                          {
                              "explanation": "2) [C] 毯子；毛毯"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "diminish",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0a3dc2c21aa9e500daa2b908184e379c5bceb59f_96k.mp3#duration=1.6&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/dɪˈmɪnɪʃ/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "become or make sth. become smaller or less （使）减小；（使）减少",
                              "example": "Her enthusiasm for knitting was by now fast diminishing. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "monument",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5d2c686c1dc2c93093440104ea3300a71c9f2523_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmɒnjʊmənt/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "a building, statue, or other large structure that is built to remind people of an important event or famous person 纪念碑；纪念塔；纪念馆",
                              "example": "These are the monuments to generations of individual farmers ploughing (犁) their fields."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "salmon",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e89ca8acc657dd319dfbb418bbbbe65121bb41d6_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈsæmən/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] (pl. salmon) 鲑鱼（肉）；三文鱼（肉）；大麻哈鱼（肉）",
                            "example": ""
                        }
                    ]
                }
            ]
        },
        {
            "word": "pal",
            "pee": [
                {
                    "partOfSpeech": "/pæl/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (infml.) a close friend 密友；好友",
                            "example": "Margherita and I have been pals since we were at primary school."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bfa57eedf4bbaee17f591fc77d63028426a131fc_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "skitter",
            "pee": [
                {
                    "partOfSpeech": "/ˈskɪtə/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(always + ad. / prep.) move very quickly and lightly, like a small animal （像小动物那样）轻快地跑",
                            "example": "Shaking the snow off their hair and coats, the girls skittered up the stairs into the house."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6e87be21d3afc882fa283679c41ad399c455dbf3_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "windup",
            "pee": [
                {
                    "partOfSpeech": "/ˈwaɪndʌp/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(BrE wind-up) (only before noun) relating to a machine or toy that you turn part of several times, in order to make it move or start working （机器或玩具）装有发条的，用手柄操作的",
                            "example": "Directly in front of him were two windup monkeys, one with a guitar and the other with a drum."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/768d86eef1e1f7cc90ce5749123891f1e0f2cfbd_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "spray",
            "pee": [
                {
                    "partOfSpeech": "/spreɪ/【vi.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of liquid or small bits) quickly scatter through the air （液体或碎屑）飞溅，飞散",
                            "example": "The water sprayed from the hose (水龙带) and onto the grassland."
                        }
                    ]
                },
                {
                    "partOfSpeech": "vt.",
                    "explanations_and_examples": [
                        {
                            "explanation": "force liquid out of a container so that it comes out in a stream of very small drops and covers an area 喷；喷洒",
                            "example": "Someone had sprayed blue paint over his car. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ffa0a8a6f1ff4c54110f72b2146b97c0e877842d_96k.mp3#duration=1.2&t=.mp3"
        },
        {
            "word": "flop",
            "pee": [
                {
                    "partOfSpeech": "/flɒp/【vi.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(always + ad. / prep.) fall or drop heavily 沉重地落下",
                            "example": "I finally got home and flopped down on the bed."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/235276822b9f1573ad93c4a8df1a9c825fc2a8a7_96k.mp3#duration=1.2&t=.mp3"
        },
        {
            "word": "magnetic",
            "pee": [
                {
                    "partOfSpeech": "/mægˈnetɪk/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "concerning or produced by magnetism 磁的；磁性的",
                            "example": "Pigeons navigate less accurately when the Earth's magnetic field is disturbed."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0a868ec7e947aa666e9ea51bcc9229a7480514c8_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "alas",
            "pee": [
                {
                    "partOfSpeech": "/əˈlæs/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) used when mentioning a fact that you wish was not true 不幸地 （表示但愿并非如此）",
                            "example": "Donald, alas, died last winter, even though he had shown signs of recovery for a while."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e573fcbf3e5a7507f49d0cb23b16aad794dc41a9_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "rainbow trout",
            "pee": [
                {
                    "partOfSpeech": "/ˈreɪnˌbəʊ ˌtraʊt/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] (pl. rainbow trout or rainbow trouts) 虹鳟",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/afd8d9dd86b15999e8459b870f82237f6e5e74f5_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "exquisitely",
            "pee": [
                {
                    "partOfSpeech": "/ɪkˈskwɪzɪtli/【ad.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "in a very beautiful and delicate way 精美地；精致地",
                            "example": "She could not take her eyes away from the exquisitely charming portrait. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4a8271bf63ba9c3f7702de45642095dc314b04f2_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "rocky",
            "pee": [
                {
                    "partOfSpeech": "/ˌrɒki/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "covered with rocks or made of rock 岩石覆盖的；由岩石形成的",
                            "example": "The small village sits on a rocky hill overlooking the sea."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/39c3dc4b5c3a1e59760ae9273706260052c6d38f_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "Omega-3",
            "pee": [
                {
                    "partOfSpeech": "/ˌəʊmɪgə ˈθri:/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] 奥米伽3（一组多元不饱和脂肪酸）",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f5f79f6cdb8afc04cf07c2ed7ab41430bdf93b3e_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "staple",
            "pee": [
                {
                    "partOfSpeech": "/ˈsteɪpl/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a food that is needed and used all the time 基本食物；主食",
                            "example": "The aid workers are distributing corn, milk, vegetables, and other staples. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a30b015464e91718307f8d43964721fd52ceb295_96k.mp3#duration=1.2&t=.mp3"
        },
        {
            "word": "spawn",
            "pee": [
                {
                    "partOfSpeech": "/spɔːn/【v.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "produce eggs in large quantities at the same time （鱼或蛙）大量产卵",
                            "example": "The salmon swim upstream to spawn in late summer or fall. "
                        }
                    ]
                },
                {
                    "partOfSpeech": "vt.",
                    "explanations_and_examples": [
                        {
                            "explanation": "make a series of things happen or start to exist 使大量出现；使大量生产；酿成",
                            "example": "New technology has spawned new business opportunities. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/785ae9822bbd9206d15a8037f53de159cc4d6230_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "cod",
            "pee": [
                {
                    "partOfSpeech": "/kɒd/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] (pl. cod) 鳕鱼（肉）",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ecb30564b8061adc1b63c0749268fb88a622ee22_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "backfire",
            "pee": [
                {
                    "partOfSpeech": "/ˌbækˈfaɪə/【vi.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of a plan or action) have the opposite effect to the one you intended （计划或行动）发生意外，产生事与愿违的结果",
                            "example": "The company's new policy backfired when a number of employees threatened to quit."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8a9cbc8e6a0d8708169ab83a948a59c661ca69c6_96k.mp3#duration=1.5&t=.mp3"
        },
        {
            "word": "coastal",
            "pee": [
                {
                    "partOfSpeech": "/ˈkəʊstl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(only before noun) in the sea or on the land near the coast 近海的；沿海的；海岸的",
                            "example": "This kind of fish is found worldwide in tropical oceans, at the edge of coastal waters and in the open sea."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0f58a218326ce338bfae4b1cdd598361bc7ef387_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "thrive",
            "pee": [
                {
                    "partOfSpeech": "/θraɪv/【vi.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "become very strong and healthy or very successful 茁壮成长；兴旺；欣欣向荣",
                            "example": "It is still unclear whether these companies will continue to thrive in the future."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/19111de3e7f79143b88f5f179f1c53e66048fa09_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "abundance",
            "pee": [
                {
                    "partOfSpeech": "/əˈbʌndəns/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U, sing] a large quantity of sth. 充裕；丰富",
                            "example": "One quality that the team possessed in abundance was fighting spirit."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a9eae00e2d7c9bfef70073a0d11fd28bc10ae497_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "blessing",
            "pee": [
                {
                    "partOfSpeech": "/ˈblesɪŋ/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] sth. that improves your life, helps you in some way, or makes you happy 幸事；幸运；福气",
                            "example": "This modern medical equipment allows patients to live a more normal life, which is a real blessing."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2ffa61a0585012f9ad9990f3eaa97b730b153f0c_96k.mp3#duration=1.7&t=.mp3"
        },
        {
            "word": "diner",
            "pee": [
                {
                    "partOfSpeech": "/ˈdaɪnə/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] （餐厅的）用餐者",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a5802b140542cd469fb2800ff792d79d15c29d3b_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "fattiness",
            "pee": [
                {
                    "partOfSpeech": "/ˈfætInəs/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the state of containing a lot of fat 富含脂肪",
                            "example": "With much protein but little fattiness, beef is the healthy food sought by many people."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/14ebd23731ca62ac788c814b8f5b7d9839c674e8_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "moist",
            "pee": [
                {
                    "partOfSpeech": "/mɔɪst/【a.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "slightly wet, esp. in a way that is pleasant or suitable 潮湿的；湿润的",
                            "example": "This fruit cake will keep moist for several days if it is stored in the refrigerator. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7e3798c759db32789d7e20ed564318a7238992cb_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "overcook",
            "pee": [
                {
                    "partOfSpeech": "/ˌəʊvəˈkʊk/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "cook food for too long 将（食物）煮得过熟",
                            "example": "A customer complained that the vegetables were overcooked."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cb11afa6945f81862b6e5b3b633dd0bfb2822d5e_96k.mp3#duration=1.9&t=.mp3"
        },
        {
            "word": "Norwegian",
            "pee": [
                {
                    "partOfSpeech": "/nɔːˈwi:dʒ(ə)n/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 挪威人",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/01bb2c9198d078aa3f80d9557d8be0ca7746a457_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "surplus",
            "pee": [
                {
                    "partOfSpeech": "/ˈsɜːpləs/【n.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, U] an amount of sth. that is more than what is needed or used 剩余；过剩；剩余额；多余的量",
                            "example": "This country produces more oil than it needs and sells the surplus to the rest of the world."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b5b43bd3ade5151b66b9bb7a4d7a15b11cd78530_96k.mp3#duration=1.6&t=.mp3"
        },
        {
            "word": "incorporate",
            "pee": [
                {
                    "partOfSpeech": "/ɪnˈkɔːpəˌreɪt/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "include sth. as part of a group, system, plan, etc. 把 （某事物）并入，包含",
                            "example": "We've incorporated many environmentally friendly features into the design of the building."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4c3e1aca94eeb4b38b290a528ebfd778b699c3bb_96k.mp3#duration=2.0&t=.mp3"
        },
        {
            "word": "flesh",
            "pee": [
                {
                    "partOfSpeech": "/fleʃ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] （人或动物的）肉",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/86e9c2290c14c8cadca5f07f5c5fcb5d9f644930_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "sushi",
            "pee": [
                {
                    "partOfSpeech": "/ˈsu:ʃi/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] 寿司",
                            "example": ""
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3b4dbece1de6c9ba770d56cb056cb8ba03caa680_96k.mp3#duration=1.4&t=.mp3"
        },
        {
            "word": "avocado",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/03f73e80da778e5df6e95aba008a88ae0d0ea473_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌævəˈkɑːdəʊ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] (BrE also avocado pear) (pl. avocados) 鳄梨；牛油果"
                        }
                    ]
                }
            ]
        },
        {
            "word": "marketing",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8a437036e9b28a3f05fff881586ba18ff7d5698b_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈmɑːkɪtɪŋ/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[U] the activity of deciding how to advertise a product, what price to charge for it, etc., or the type of job in which you do this 促销；营销；销售",
                            "example": "The reason their cars sold so well was that they had a brilliant marketing strategy."
                        }
                    ]
                }
            ]
        },
        {
            "word": "antibiotic",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/665d4047f8d7c8166330d4f38a8771f36c5cc02c_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌæntibaɪˈɒtɪk/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C, usu. pl.] 抗生素",
                            "example": "",
                        }
                    ]
                }
            ]
        },
        {
            "word": "toxin",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3eb95ac311fe8a3a681eccceb8f1cb9707bd91e2_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] 毒素 （尤指细菌产生的致病物质）",
                            "example": "",
                        }
                    ]
                }
            ]
        },
        {
            "word": "overtake",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/93584fb0c59f57848790adbaa225a031017a1edf_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌəʊvəˈteɪk/【v.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "(overtook, overtaken) develop or increase more quickly than sb. / sth. else and become more successful, more important, or more advanced than them （发展或增长）超越，超过",
                            "example": "Television soon overtook the cinema as the most popular form of entertainment."
                        }
                    ]
                }
            ]
        },
        {
            "word": "fragile",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/efa96dfdc9c95b9649dedeba40aa049a3542baa7_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈfrædʒaɪl/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "weak or uncertain, and likely to become worse under pressure 脆弱的",
                            "example": "This area has a range of fragile ecosystems and rare plants. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "domesticated",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c0b3e2614d64088473bda7ef420d8a670bf8a3e0_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/dəˈmestɪˌkeɪtɪd/【a.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of animals or plants) brought or kept under control or cultivation （动物或植物）驯化的",
                            "example": "A domesticated animal, accustomed to being fed by hand, may not be able to live without man. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "breed",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b7d30045d977dfbdac96ae3e8bde14637c5c46a8_96k.mp3#duration=1.2&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/bri:d/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] a type of animal that is kept as a pet or on a farm （宠物或牲畜的）品种",
                            "example": "What breed of dog is that? I've never seen one like it before. "
                        }
                    ]
                },
                {
                    "partOfSpeech": "vi.",
                    "explanations_and_examples": [
                        {
                            "explanation": "(of animals) mate in order to have babies （动物）繁殖",
                            "example": "Many animals breed only at certain times of the year."
                        }
                    ]
                }
            ]
        },
        {
            "word": "threaten",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a7b73550b9e1d9d657662094da76efc8acccdec3_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈθretn/【vt.】 ",
                    "explanations_and_examples": [
                        {
                            "explanation": "1) be likely to harm or destroy sth. 威胁到；危及",
                            "example": "By August, it was clear that the volcano could threaten the whole island."
                        },
                        {
                            "explanation": "2) say that you will cause sb. harm or trouble if they do not do what you want 威胁；恐吓",
                            "example": "Postal workers are threatening a strike if they don't receive a pay increase."
                        }
                    ]
                }
            ]
        },
        {
            "word": "joyride",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fb08fca8b8fd1a9e1a244abe6f373d07482bd75b_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈdʒɔːɪraɪd/【n.】",
                    "explanations_and_examples": [
                        {
                            "explanation": "[C] an act of driving around for enjoyment in a car, esp. one that was taken without permission and is driven in a dangerous manner 驾车兜风（尤指偷来别人汽车进行危险驾驶）",
                            "example": "A police spokesman said the incident appeared to have been a joyride."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "in the making",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "in the process of becoming sth. or being made 在形成中；在生产中",
                              "example": "His book was finally published. He said that it was 10 years in the making."
                          }
                      ],
                      "partOfSpeech": ""
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/602e9f4cbf858802092e08d2b22041d3aa2eaa8d_96k.mp3#duration=2.1&t=.mp3"
          },
          {
              "word": "simply put / to put it simply",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used for saying that you are explaining sth. in a clear and simple way 简单地说",
                              "example": "Anyway, simply put, we still owe them a large amount of money. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9b238a0ba027958914a0a4faef6f251298210c8c_96k.mp3#duration=3.7&t=.mp3"
          },
          {
              "word": "in short supply",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "available only in small quantities, so that there is not enough 供应不足；短缺",
                              "example": "Electricity and fresh water are in short supply on the island."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dcad98f27d34dbae0e685eab189c53aab8f9f573_96k.mp3#duration=2.1&t=.mp3"
          },
          {
            "word": "tap into",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "make use of a source of energy, knowledge, etc. that already exists 利用 , 发掘，开发（已有的能源、知识等）",
                            "example": "She hopes that additional sources of educational funding can be tapped into to help the poor children. "
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a052857132e5c3e3b19b6d022698893baaf3470c_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "to the point",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "dealing only with the important subject or idea, and not including any unnecessary discussions 简明恰当的；简洁中肯的",
                            "example": "Her comments on the current issues were brief and to the point."
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/65f27e592724b14250412d53d6d6be12af28d4e6_96k.mp3#duration=1.8&t=.mp3"
        },
        {
            "word": "in large part / measure",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/909bddffa6188bc4fdef03455bf4c1ddae5d3baf_96k.mp3#duration=3.5&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(fml.) mostly 基本上；在很大程度上",
                            "example": "Their success was due in large part to their ability to speak Spanish."
                        }
                    ]
                }
            ]
        },
        {
            "word": "lend oneself to sth.",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/60bf948cceca5396b1fd0966aa83f64676cf25b5_96k.mp3#duration=2.6&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "be suitable for being used in a particular way 适用于某事物",
                            "example": "None of his books really lends itself to being made into a film."
                        }
                    ]
                }
            ]
        },
        {
            "word": "cut corners",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c894409fb0c4da0291609277f6a411c7d3f7e72f_96k.mp3#duration=2.1&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "save time, money, or energy by doing things quickly and not as carefully as you should （为了节约时间、金钱或精力而）马虎从事",
                            "example": "There's a temptation to cut corners when you're pushed for time, but it's not worth it."
                        }
                    ]
                }
            ]
        },
        {
            "word": "phase out",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0274c25b20ccbd7bb01b6491a1ee81cb715fc54d_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "gradually stop using or providing sth. 逐步停止使用（提供）",
                            "example": "It is highly probable that the subsidy for car manufactures is to be phased out next year. "
                        }
                    ]
                }
            ]
        },
        {
            "word": "in my book",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/94739edadfe0b2d5c95fa664f806e8c4362b8ed6_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "(spoken) said when giving your opinion 依我看；在我看来",
                            "example": "Well, in my book, if you steal, you deserve to get caught."
                        }
                    ]
                }
            ]
        }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "Minnesota",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/18fdba5d3282c07c996a75f25803bd15bce2ddf4_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌmɪnɪˈsəʊtə/",
                      "explanations_and_examples": [
                          {
                              "explanation": "明尼苏达州（位于美国北部）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "the Milky Way",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9a0fdc8c9092a6200d974ddb0a855f0c7800c9bf_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "银河"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "the World Health Organization",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6450aeb88b247f8659f72e3792598b33fa898b4c_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "世界卫生组织"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "the American Medical Association",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6e1c466d779b494b062ac06306cdb76b84bdf655_96k.mp3#duration=2.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "美国医学会"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Vincent van Gogh",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/46350111e95a84894e6183e571beaffd5be23d7a_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌvæn ˈgɒf/",
                      "explanations_and_examples": [
                          {
                              "explanation": "文森特・凡・高 （荷兰画家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "NASA",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ac9d2e864e51a9e5850493e108acd23579c99dc5_96k.mp3#duration=1.1&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(National Aeronautics and Space Administration) 美国国家航空航天局"
                          }
                      ]
                  }
              ]
          },
          {
            "word": "GPS",
            "pee": [
                {
                    "partOfSpeech": "",
                    "explanations_and_examples": [
                        {
                            "explanation": "(Global Positioning System) 全球（卫星）定位系统"
                        }
                    ]
                }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/fad78b7d50d97e8be369d604d1022f330dcf30ea_96k.mp3#duration=1.3&t=.mp3"
        },
        {
            "word": "Yukon River",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b26db44aa1d5cd4e2ccf4496e65cdd2a2e96ca38_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈju:kɒn/",
                    "explanations_and_examples": [
                        {
                            "explanation": "育空河（北美洲主要河流之一，流经加拿大和美国）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "the Hudson",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/cd5e65db645d92dfccb76ac7aee69981316963e3_96k.mp3#duration=1.2&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈhʌds(ə)n/",
                    "explanations_and_examples": [
                        {
                            "explanation": " (Hudson River) 哈得孙河（主要位于美国纽约州内）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Maine",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3888ff96ea8d80df89db5ddc7e69fc3ee6abf04a_96k.mp3#duration=1.1&t=.mp3",
            "pee": [
                {
                    "explanations_and_examples": [
                        {
                            "explanation": "/meɪn/",
                            "example": "缅因州（位于美国东北部）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Scandinavia",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b583010024deab42e17a879d5eb61fd756035ac2_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˌskændɪˈneIviə/",
                    "explanations_and_examples": [
                        {
                            "explanation": "斯堪的纳维亚（欧洲西北部文化区，包括挪威、瑞典和丹麦，有时也包括冰岛、芬兰和法罗群岛）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Puget Sound",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/c706d09ec13ba5f9ea49019143384ded219ea147_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈpju:dʒɪt/",
                    "explanations_and_examples": [
                        {
                            "explanation": "皮吉特湾（位于美国华盛顿州）"
                        }
                    ]
                }
            ]
        },
        {
            "word": "Skagit River",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/426e34df13d6fa3cb240719da39039480ee1c4c2_96k.mp3#duration=1.9&t=.mp3",
            "pee": [
                {
                    "partOfSpeech": "/ˈskædʒɪt/",
                    "explanations_and_examples": [
                        {
                            "example": "斯卡吉特河（位于北美洲，流经加拿大和美国）"
                        }
                    ]
                }
            ]
        }
      ]
  }
]

book2[7] = [
  {
      "name": "New words",
      "children": [
          {
              "word": "robotics",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2ff79fd4b3812b10da018c7585f504fc6eeda42f_96k.mp3#duration=1.7&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/rəʊˈbɒtɪks/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 机器人（制造与应用）学",
                              "example": ""
                          }
                      ]
                  }
              ]
          },
          {
              "word": "yoga",
              "pee": [
                  {
                      "partOfSpeech": "/ˈjəʊgə/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 瑜伽",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5c438306e0e1baa643134a99919de5b6938f980e_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "AI",
              "pee": [
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] (artificial intelligence) 人工智能",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0f713ae8ee525cc6b56b9e59f766611af8846cd2_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "eliminate",
              "pee": [
                  {
                      "partOfSpeech": "/ɪˈlɪmɪˌneɪt/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "completely get rid of sth. that is unnecessary or unwanted 消除；根除",
                              "example": "There is no solution that will totally eliminate the possibility of theft. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/db210729b4e89241e25d3bb6a4f6abaf732f6ed9_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "specialization",
              "pee": [
                  {
                      "partOfSpeech": "/ˌspeʃəlaɪˈzeɪʃn/【n.】[C, U] (BrE also specialisation)",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) the practice of limiting your interests or activities to one particular subject 专业化；专门化",
                              "example": "Increased specialization has reduced the number of doctors good at managing emergencies."
                          },
                          {
                              "explanation": "2) an activity or subject that you know a lot about 专业",
                              "example": "His specialization in translation led him to start his own company."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f22b5a29930bb82237b45548c83cfa4e1028403f_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "routinize",
              "pee": [
                  {
                      "partOfSpeech": "/ru:ˈti:naɪz/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE also routinise) if you routinize a way of doing sth., you make it a normal part of a job or process 使惯例化；使成常规",
                              "example": "To improve efficiency, routinize as much of your morning as possible."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a3c8164c07e137f3553466a9acf337d50d6091f8_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "automate",
              "pee": [
                  {
                      "partOfSpeech": "vt.",
                      "explanations_and_examples": [
                          {
                              "explanation": "start using computers and machines to do a job, rather than people 使自动化",
                              "example": "Massive investment is needed to automate the production process. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/08216cca231eec472f371388d82374e5fac2e436_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "DJ",
              "pee": [
                  {
                      "partOfSpeech": "n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (disc jockey) sb. who plays records on a radio show or in a club where you can dance （电台）音乐唱片节目主持人；（俱乐部）打碟师，舞曲唱片播放员",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/27962feea7c86755217d5f4c34d5d4e9adf0d2bf_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "consequently",
              "pee": [
                  {
                      "partOfSpeech": "/ˈkɒnsɪkwəntli/【ad.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "as a result 结果；因此；所以",
                              "example": "The company is trying to reduce its costs; consequently, staff who leave are not being replaced."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e3c671514901eff882ea67ff1a997f8ad49164d7_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "evaluate",
              "pee": [
                  {
                      "partOfSpeech": "/ɪˈvæljuˌeɪt/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "judge how good, useful, or successful sth. is 评估； 评价",
                              "example": "It can be difficult to evaluate the effectiveness of different medical treatments. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2c8ec56d925fbf1a34added97c4802367a2abbe3_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "algorithm",
              "pee": [
                  {
                      "partOfSpeech": "/ˈælgəˌrɪð(ə)m/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] (technical) 演算法；计算程序",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ec2861c267c5be3a49974feab80f623f7d854e1c_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "manipulate",
              "pee": [
                  {
                      "partOfSpeech": "/məˈnɪpjʊˌleɪt/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "make sb. think and behave exactly as you want them to, by skillfully deceiving or influencing them 操纵，控制（某人的思想和行为）",
                              "example": "As a politician, he knows how to manipulate public opinion. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e7b3fe205066ed4e9c4740ad4c9209b50fa37510_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "mystical",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmɪstɪkl/【a.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "(also mystic) (usu. before noun) having spiritual powers or qualities that are difficult to understand or to explain 神秘的；不可思议的；难以解释的",
                              "example": "Watching the sun rise over the mountain was an almost mystical experience. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/16bfcf8cec35aec10ec30d9f30ad57f9dd58cc8e_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "biochemical",
              "pee": [
                  {
                      "partOfSpeech": "/ˌbaɪəʊˈkemɪkl/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "connected with the chemistry of living things 生物化学的",
                              "example": "People can become addicted to the biochemical changes brought about by heavy exercise. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5503132762d78e773a9bf20789cbbf8f2b7f0dce_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "biometric",
              "pee": [
                  {
                      "partOfSpeech": "/ˌbaɪəʊˈmetrɪk/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(usu. before noun) using measurements of human features, such as fingers or eyes, in order to identify people 生物特征识别的",
                              "example": "The major biometric methods include face, voice, and fingerprint recognition. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/83ec6821508227328d6b16826b77ed3e111c5a95_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "calculate",
              "pee": [
                  {
                      "partOfSpeech": "/ˈkælkjʊˌleɪt/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) guess sth. using as many facts as you can find 预测；估计",
                              "example": "Researchers calculated that this group was at a higher risk of heart disease."
                          },
                          {
                              "explanation": "2) find out how much sth. will cost, how long sth. will take, etc., by using numbers 计算；核算",
                              "example": "You should calculate how much time this assignment will take before you start doing it. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5dab412b200e556f9f1ba4a6f2c610af3b56d7c9_96k.mp3#duration=1.1&t=.mp3"
          },
          {
              "word": "analysis",
              "pee": [
                  {
                      "partOfSpeech": "/əˈnæləsɪs/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C, U] a careful examination of sth. in order to understand it better （对事物的）分析",
                              "example": "At the meeting, they presented a detailed analysis of 12 schools in London."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/541e6e7853a67348faf8bfec19d2b1eeb4691772_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "output",
              "pee": [
                  {
                      "partOfSpeech": "/ˈaʊtˌpʊt/【n.】[C, U]",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) the information produced by a computer （计算机的）输出信息",
                              "example": "You run the software, you look at the output, and then you make modifications (修改). "
                          },
                          {
                              "explanation": "2) the amount of goods or work produced by a person, machine, factory, etc. 产量；产品",
                              "example": "Government statistics show the largest drop in industrial output for 10 years."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0b8aa8e693f88b088a32b861cd49132903c6f8db_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "tailor",
              "pee": [
                  {
                      "partOfSpeech": "/ˈteɪlə/【vt.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "make sth. so that it is exactly right for sb.'s particular needs or for a particular purpose 根据特定需要制作；定做",
                              "example": "Most travel agents are willing to tailor travel arrangements to meet individual requirements."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/49713a1ad36bad1861b189d6245960913e3d1e46_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "echo",
              "pee": [
                  {
                      "partOfSpeech": "/ˈekəʊ/【vt./vi】",
                      "explanations_and_examples": [
                          {
                              "explanation": "repeat (another's words, ideas, etc.) 附和",
                              "example": "Her feelings are echoed by other parents whose kids have left home."
                          },
                          {
                            "explanation": "if a sound echoes, you hear it again because it was made near sth. such as a wall or hill （声音）回响；发出回声",
                            "example": "Her footsteps echoed in the empty room."
                        },
                      ]
                  },
                ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9ed5ca99902e9e35278dc62de005846cb128595c_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "distress",
              "pee": [
                  {
                      "partOfSpeech": "/dɪˈstres/ n.",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] a feeling of extreme unhappiness 忧虑；苦恼；悲伤",
                              "example": "Luke's poor academic performance caused his parents great distress. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6983d3c0ca6cbde6bb1f86f2217ad5c5cb90052d_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "melody",
              "pee": [
                  {
                      "partOfSpeech": "/ˈmelədi/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[C] a tune, esp. the main tune in a piece of music written for several instruments or voices 旋律；曲调；（尤指）主旋律",
                              "example": "They played some lovely melodies at the end of the concert."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a1c634d0b81234d0c30002f8c13ce3f991afbb2a_96k.mp3#duration=1.3&t=.mp3"
          },
          {
              "word": "peculiarity",
              "pee": [
                  {
                      "partOfSpeech": "/pɪˌkju:liˈærəti/【n.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] sth. that is a feature of only one particular place, person, situation, etc. （某地方、某人或某情况等的）特点，独特性",
                              "example": "A sharp ringing in the ears is a peculiarity of the disease. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3a3cc733c0bd7f2c4ad95a005a35fe32f44f2975_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "dislike",
              "pee": [
                  {
                      "partOfSpeech": "/dɪsˈlaɪk/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "think sb. / sth. is unpleasant and not like them 不喜欢；讨厌",
                              "example": "He disliked it when she phoned him so late at night. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b273f8a2b82ad185cc1fc37038f9dc64f74652a1_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "oxytocin",
              "pee": [
                  {
                      "partOfSpeech": "/ˌɒksɪˈtəʊsɪn/【n.】",
                      "explanations_and_examples": [
                          {
                              "explanation": "[U] 催产素",
                              "example": ""
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a9ca01299491cd79d6393189ff60dc33c52153c9_96k.mp3#duration=1.7&t=.mp3"
          },
          {
              "word": "compose",
              "pee": [
                  {
                      "partOfSpeech": "/kəmˈpəʊz/【v.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "1) write a piece of music 作（曲）",
                              "example": "Mozart composed his last opera shortly before he passed away. "
                          },
                          {
                              "explanation": "2) (be composed of) be formed from a number of substances, parts, or people 由...组成",
                              "example": "The committee is composed of doctors, nurses and members of the public. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/410fda1753e46fd47047719ffdde15fc0fceecb4_96k.mp3#duration=1.4&t=.mp3"
          },
          {
              "word": "personalized",
              "pee": [
                  {
                      "partOfSpeech": "/ˈpɜːsnəlaɪzd/【a.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "(BrE also personalised) adapted to personal requirements or tastes 个性化的",
                              "example": "His car has a personalized number plate. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/968ee399d7f33e447d8514a0ec4139c1d2c596c7_96k.mp3#duration=1.6&t=.mp3"
          },
          {
              "word": "besides",
              "pee": [
                  {
                      "partOfSpeech": "/bɪˈsaɪdz/prep. ",
                      "explanations_and_examples": [
                          {
                              "explanation": "apart from sb. / sth.; in addition to sb. / sth. 除...之外（还）",
                              "example": "I've got no family besides my parents. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2e11b19a70aae130a7615bb50049d1867ec3f843_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "surpass",
              "pee": [
                  {
                      "partOfSpeech": "/səˈpɑːs/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "be even better or greater than sb. / sth. else 超过；胜过",
                              "example": "The film's success has surpassed all expectations."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3a9e9e006f3ca95349144ab007fee024fc9a7664_96k.mp3#duration=1.8&t=.mp3"
          },
          {
              "word": "outperform",
              "pee": [
                  {
                      "partOfSpeech": "/ˌaʊtpəˈfɔːm/【vt.】 ",
                      "explanations_and_examples": [
                          {
                              "explanation": "be more successful than sb. / sth. else 做得比...好；胜过",
                              "example": "In recent years, our economy has outperformed most other industrial economies."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/f10a5fd4905223c54caa58ebf61c2aa834f627f5_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "rational",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a03fd94eb84581a379a7912b3d603e796814b3b3_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/ˈræʃn(ə)l/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "rational thoughts, decisions, etc. are based on reasons rather than emotions （想法、决定等）合理的，基于理性的",
                    "example": "Parents need to be fully informed before they can make a rational decision."
                  }
                ]
              }
            ]
          },
          {
            "word": "biological",
            "pee": [
              {
                "partOfSpeech": "/ˌbaɪəˈlɒdʒɪkl/【 a. 】",
                "explanations_and_examples": [
                  {
                    "explanation": "relating to the natural processes performed by living things 生物的；与生物有关的",
                    "example": "Breathing and sleeping are examples of biological rhythms in humans."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5bb79b8ae156c99ebbfe9a8d07b981de6e78f5c4_96k.mp3#duration=1.9&t=.mp3"
          },
          {
            "word": "genetic",
            "pee": [
              {
                "partOfSpeech": "/dʒəˈnetɪk/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "relating to genes or genetics 基因的；遗传学的",
                    "example": "I'm giving a seminar on the latest developments in genetic research next week. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a3ba8db8799c2d0500e56a1ab80e6b8f3ed6b0c1_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "microbe",
            "pee": [
              {
                "partOfSpeech": "/ˈmaɪkrəʊb/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[C] an extremely small living thing which can only be seen if you use a microscope. Some microbes can cause diseases. 微生物",
                    "example": "Was it not the duty of the doctor to kill the microbes?"
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/8ace2b2b8bffacfa9a9afc9268b4301f34ba0348_96k.mp3#duration=1.6&t=.mp3"
          },
          {
            "word": "intuitively",
            "pee": [
              {
                "partOfSpeech": "/ɪnˈtju:ətɪvli/【ad. 】",
                "explanations_and_examples": [
                  {
                    "explanation": "in a way that is based on feelings rather than facts or proof 基于直觉地",
                    "example": "She had sensed, intuitively, that Larry was interested in her."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/5980a405ca00a512ed4b60600047c7b4eec5471c_96k.mp3#duration=1.8&t=.mp3"
          },
          {
            "word": "willingly",
            "pee": [
              {
                "partOfSpeech": "/ˈwɪlɪŋli/【ad.】",
                "explanations_and_examples": [
                  {
                    "explanation": "in a way that shows you are happy or pleased to do sth. or that you do not object to doing sth. 欣然地；愿意地；乐意地",
                    "example": "Sixty percent of voters said they would willingly pay higher taxes for better health care."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/716c03160af955cf4faab1dfaa08b65a9dabb8fa_96k.mp3#duration=1.3&t=.mp3"
          },
          {
            "word": "broccoli",
            "pee": [
              {
                "partOfSpeech": "/ˈbrɒkəli/【 n.】",
                "explanations_and_examples": [
                  { "explanation": "[U] 西兰花", "example": "" }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0213b19cc99d9c6d7bed0f0f6c27d94d8541c9fc_96k.mp3#duration=1.3&t=.mp3"
          },
          {
            "word": "recoil",
            "pee": [
              {
                "partOfSpeech": "/rɪˈkɔɪl/【vi.】",
                "explanations_and_examples": [
                  {
                    "explanation": "move your body quickly away from sb. / sth. because you find them or it frightening or unpleasant 退缩；畏缩",
                    "example": "Howard recoiled a little at the sharpness in my voice."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1f303371b51407fc8ff8e38e775880d54c9a3014_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "horror",
            "pee": [
              {
                "partOfSpeech": "/ˈhɒrə/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[U] a feeling of great shock, fear, or disgust 震惊；惊恐；厌恶",
                    "example": "The thought of being left alone filled her with horror."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4e6794621d840b254d078770a67f93be7788fa8b_96k.mp3#duration=1.1&t=.mp3"
          },
          {
            "word": "distaste",
            "pee": [
              {
                "partOfSpeech": "/dɪsˈteɪst/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[U] a feeling that sb. / sth. is unpleasant or morally offensive 不喜欢；厌恶；反感",
                    "example": "She was trying her best not to show her distaste."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/afbd8b50f46df652022060b6865e58c7c29b4ac7_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "variation",
            "pee": [
              {
                "partOfSpeech": "/ˌveərɪˈeɪʃn/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[C, U] a difference between similar things, or a change from the usual amount or form of sth. （相似物体之间的）差异；（数量或形式的）变化，变动",
                    "example": "There might be striking variations within a species."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2f46812c222f135c4bdbd8dfde9e406c331cec85_96k.mp3#duration=1.6&t=.mp3"
          },
          {
            "word": "taste bud",
            "pee": [
              {
                "partOfSpeech": "/ˈteɪst ˌbʌd/【n.】",
                "explanations_and_examples": [
                  { "explanation": "[C, usu. pl.] 味蕾", "example": "" }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/56fa1b4d6a71a9a5234bd786a800a85f3d41b8a1_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "receptor",
            "pee": [
              {
                "partOfSpeech": "/rɪˈseptə/【 n. 】",
                "explanations_and_examples": [
                  {
                    "explanation": "[C] a nerve ending which receives information about changes in light, heat, etc. and causes the body to react in particular ways 感受器；受体",
                    "example": "In the year 2000, taste receptors that detect this chemical were discovered on the tongue. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b3d8d417ab6c80fbc066eab88e4caab9a5326c90_96k.mp3#duration=1.5&t=.mp3"
          },
          {
            "word": "thiourea",
            "pee": [
              {
                "partOfSpeech": "/ˌθaɪəʊˈjʊərɪə/【 n.】",
                "explanations_and_examples": [
                  { "explanation": "[U] 硫脲", "example": "" }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1230638a9cf16ff47adfc87e821721d174c0f0bd_96k.mp3#duration=1.8&t=.mp3"
          },
          {
            "word": "plentiful",
            "pee": [
              {
                "partOfSpeech": "/ˈplentɪfl/【a. 】",
                "explanations_and_examples": [
                  {
                    "explanation": "more than enough in quantity 丰富的；充足的",
                    "example": "I provided a plentiful supply of games to keep the children occupied."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d529e45cf37d6b4272782bff81a7edd574ebf8b5_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "DNA",
            "pee": [
              {
                "partOfSpeech": "【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "(deoxyribonucleic acid) 脱氧核糖核酸",
                    "example": ""
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/64922cfb9c3831d2679d010eeccbec8427c94449_96k.mp3#duration=2.4&t=.mp3"
          },
          {
            "word": "disgusting",
            "pee": [
              {
                "partOfSpeech": "/dɪsˈgʌstɪŋ/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "extremely unpleasant and making you feel sick 令人恶心的；使人极其反感的；令人厌恶的",
                    "example": "The kitchen was in a disgusting state when she left. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/02b39343ceb2900846c3ff11d33e02ddf672eea5_96k.mp3#duration=1.9&t=.mp3"
          },
          {
            "word": "reasonable",
            "pee": [
              {
                "partOfSpeech": "/ˈri:znəbl/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "fair, practical, and sensible 有道理的；合情合理的",
                    "example": "Be reasonable — you can't expect her to do all the work on her own!"
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1eadbdd0e637a4896323b37974a26141d48195b2_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "relieve",
            "pee": [
              {
                "partOfSpeech": "/rɪˈli:v/【vt.】",
                "explanations_and_examples": [
                  {
                    "explanation": "reduce sb.'s pain or unpleasant feelings 减轻；缓解 ( 疼痛或不快的感觉 )",
                    "example": "This kind of drug can help to relieve the pain, but it should be used carefully."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2a5a2ae99e95bbf9b4e950320a7277919a1cce20_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "relieved",
            "pee": [
              {
                "partOfSpeech": "/rɪˈli:vd/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "feeling happy because you are no longer worried about sth. 宽慰的；放心的",
                    "example": "She looked immensely relieved when she heard the news."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ef11513efd2ea0de757cd2e9d4c0bdca521fc572_96k.mp3#duration=1.8&t=.mp3"
          },
          {
            "word": "innate",
            "pee": [
              {
                "partOfSpeech": "/ˌɪˈneɪt/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "an innate quality or ability is sth. you are born with （素质或能力）天生的，与生俱来的",
                    "example": "Children seem to have an innate ability to learn language."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/60a0338ab1cb4b3630795bf87cb1fba75c3217c3_96k.mp3#duration=2.0&t=.mp3"
          },
          {
            "word": "desirable",
            "pee": [
              {
                "partOfSpeech": "/dɪˈzaɪrəbl/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "1) sexually attractive 性感迷人的",
                    "example": "He was with the young woman whom his classmates thought most desirable."
                  },
                  {
                    "explanation": "2) (fml.) sth. that is desirable is worth having or doing 理想的；值得拥有的；值得做的",
                    "example": "The ability to speak a foreign language is highly desirable. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d1e79ee743715a9a61c6b8c6a701a573067877a4_96k.mp3#duration=1.8&t=.mp3"
          },
          {
            "word": "mate",
            "pee": [
              {
                "partOfSpeech": "/meɪt/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "1) [C] (infml.) a husband, wife, or other sexual partner 丈夫；妻子；配偶；性伴侣",
                    "example": "Many matchmaking sites compile lists of potential mates using basic information."
                  },
                  {
                    "explanation": "2) [C] sb. you work with, do an activity with, or share sth. with 同事；同伴",
                    "example": "Some of my office mates are planning to throw a party for me."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d6776358c38ef5ecb7339386b34bb4e1ba6f119d_96k.mp3#duration=1.6&t=.mp3"
          },
          {
            "word": "shapely",
            "pee": [
              {
                "partOfSpeech": "/ˈʃeɪpli/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "(esp. of a woman or part of her body) having an attractive or well-proportioned shape （尤指女子或其部分身体）好看的，匀称的",
                    "example": "She was about my age and had long, shapely legs and a beautiful smile. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/88ca6bac8a7f00b43c4cd73d7fc41c706a62586a_96k.mp3#duration=1.3&t=.mp3"
          },
          {
            "word": "sparkling",
            "pee": [
              {
                "partOfSpeech": "/ˈspɑːklɪŋ/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "shining and flashing with light 闪亮的；闪光的",
                    "example": "This is a region of sparkling lakes, rushing streams, and dense forests."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/0dae9006248d02f8ce1e6fdcb9f1abece6765b96_96k.mp3#duration=1.6&t=.mp3"
          },
          {
            "word": "attractive",
            "pee": [
              {
                "partOfSpeech": "/əˈtræktɪv/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "very pleasing in appearance or sound 好看的；好听的；有吸引力的",
                    "example": "I thought he was very attractive and obviously very intelligent."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/425738c0f387cba1bfd23a8ff5220cd3fe2190e5_96k.mp3#duration=1.7&t=.mp3"
          },
          {
            "word": "evolutionary",
            "pee": [
              {
                "partOfSpeech": "/ˌi:vəˈlu:ʃn(ə)ri/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "relating to the way in which plants and animals develop and change gradually over a long period of time 进化的",
                    "example": "Some scholars are keen to see evolutionary theory challenged in university lecture halls."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/438466d7b3a12d57b2ae713b48d938503fb27342_96k.mp3#duration=1.6&t=.mp3"
          },
          {
            "word": "virtually",
            "pee": [
              {
                "partOfSpeech": "/ˈvɜːtʃʊəli/【ad.】",
                "explanations_and_examples": [
                  {
                    "explanation": "almost 几乎",
                    "example": "This kind of bird has become virtually extinct in most of the country."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/259cf7c226daa6a79de84a00c45170a2ad9f9294_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "reproduce",
            "pee": [
              {
                "partOfSpeech": "/ˌri:prəˈdju:s/【v.】",
                "explanations_and_examples": [
                  {
                    "explanation": "if an animal or plant reproduces, or reproduces itself, it produces young plants or animals 生殖；繁殖",
                    "example": "Many single cell organisms reproduce by splitting in two."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/98089b64508a80dd709b2efccdcd0e381e11b816_96k.mp3#duration=2.0&t=.mp3"
          },
          {
            "word": "parental",
            "pee": [
              {
                "partOfSpeech": "/pəˈrentl/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "relating to being a parent and esp. to being responsible for a child's safety and development 父亲的；母亲的；父母的",
                    "example": "Parental consent is required before the operation can take place. "
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3f8d0319197d5d49a28238781d1c0f9e98406a96_96k.mp3#duration=1.4&t=.mp3"
          },
          {
            "word": "offspring",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b3dd2bb5f52410a46a935076ea500c65dd913324_96k.mp3#duration=1.3&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/ˈɒfˌsprɪŋ/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[C] (pl. offspring) sb.'s child or children — often used humorously （某人的）子女，子孙，后代（常为幽默用法）",
                    "example": " Tom's sister came over on Saturday with all her offspring."
                  }
                ]
              }
            ]
          },
          {
            "word": "disinterest",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ef95aa30f858efd6c2d84c7f0d306afc41afe0f7_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/dɪsˈɪntrəst/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[U] a lack of interest 无兴趣",
                    "example": "The exception to Tom's disinterest in social issues was education."
                  }
                ]
              }
            ]
          },
          {
            "word": "organ",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/9837b7a7a21f91a42c4822d5efb3d994edb77638_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/ˈɔːgən/【n.】",
                "explanations_and_examples": [
                  { "explanation": "[C] 器官" }
                ]
              }
            ]
          },
          {
            "word": "disheartening",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/44ff797fadfc2a77600bb98387bdc3492f64464f_96k.mp3#duration=1.7&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/dɪsˈhɑːtnɪŋ/【a. 】",
                "explanations_and_examples": [
                  {
                    "explanation": "making you lose hope and determination 令人灰心的；令人气馁的",
                    "example": "It is disheartening to see what little progress has been made. "
                  }
                ]
              }
            ]
          },
          {
            "word": "destined",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/ddc2ee668847edf2459c4f04db5281ef5526af1e_96k.mp3#duration=1.6&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/ˈdestɪnd/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "(not before noun) seeming certain to happen at some time in the future 注定的；必然的",
                    "example": "He feels that he is destined to become a musician, just like his father."
                  }
                ]
              }
            ]
          },
          {
            "word": "slave",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3f64cea2cc197e99656404367c1d2c6f84bd65d5_96k.mp3#duration=1.0&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/sleɪv/【n.】 [C]",
                "explanations_and_examples": [
                  {
                    "explanation": "1) (be a ~ of / to sth.) be so strongly influenced by sth. that you cannot make your own decisions — used to show disapproval 成为某事物的奴隶，完全受某事物控制（含贬义）",
                    "example": "How can she not see that she has become a slave of fashion? "
                  },
                  {
                    "explanation": "2) sb. who is owned by another person and works for them for no money 奴隶",
                    "example": "By the time I was 10, I had become her slave, doing all the housework."
                  }
                ]
              }
            ]
          },
          {
            "word": "magnificent",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4debddfcde817bd8a99fd8611817ae262fa3d500_96k.mp3#duration=2.0&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/mægˈnɪfɪsnt/【a.】",
                "explanations_and_examples": [
                  {
                    "explanation": "extremely attractive and impressive; deserving praise 壮丽的；宏伟的；值得赞扬的",
                    "example": "I think he deserves congratulations for a magnificent job well done."
                  }
                ]
              }
            ]
          },
          {
            "word": "remedy",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3bce984f36188c068dd320bc2e2ebe9f47db39ab_96k.mp3#duration=1.5&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/ˈremədi/",
                "explanations_and_examples": [
                  {
                    "explanation": "[vt.] 1) deal with a problem or improve a bad situation 解决；补救；纠正；改善",
                    "example": "To remedy the situation, the water must be chemically treated. "
                  },
                  {
                    "explanation": "[n.][C] 2) a way of dealing with a problem or making a bad situation better （问题的）解决方式；（糟糕状况的）补救方法",
                    "example": "There is no simple remedy for unemployment."
                  }

                ]
              },
            ]
          },
          {
            "word": "compassion",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/915c1594e49730faa605b5a96b7002145c302422_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
              {
                "partOfSpeech": "/kəmˈpæʃn/【n.】",
                "explanations_and_examples": [
                  {
                    "explanation": "[U] a strong feeling of sympathy for sb. who is suffering, and a desire to help them 怜悯；同情",
                    "example": "He was filled with overwhelming love and compassion for his wife."
                  }
                ]
              }
            ]
          }
      ]
  },
  {
      "name": "Phrases and expressions",
      "children": [
          {
              "word": "line of work",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "the type of work sb. does 专业；行业",
                              "example": "You can expect to meet some very interesting people in my line of work."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/bf0c19227e4aac3a2cc2a0935190e42755be86d1_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "in the long run",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "later in the future, not immediately 从长远来看",
                              "example": "It seems a lot of effort but I'm sure it's the best solution in the long run. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/77bb566b56996795cb0e5fe2c9d4de9bdb8abccf_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "in the short term",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used to describe what will happen a short time in the future 短期内",
                              "example": "This decision will cost us more in the short term, but will be beneficial in the long term. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/2649ab81af75df462ab2dcc855d01371911676d9_96k.mp3#duration=2.0&t=.mp3"
          },
          {
              "word": "flesh and blood",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used to emphasize that sb. has human feelings or weaknesses, often when contrasting them with machines 血肉之躯",
                              "example": "I am only flesh and blood, like anyone else."
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/68ecb91b4d89860d7bca25cf7e323d38f390d6e2_96k.mp3#duration=1.9&t=.mp3"
          },
          {
              "word": "go over",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "search or examine sth. very carefully 仔细搜查（检查）某物",
                              "example": "Go over your work before you hand it in. "
                          }
                      ]
                  }
              ],
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/661444ad0f436701ef831426716d8fc8a9cce372_96k.mp3#duration=1.5&t=.mp3"
          },
          {
              "word": "get in touch with sth.",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/e8dd572c71636568a14d9d204a8d6998f8917ac7_96k.mp3#duration=2.3&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "(esp. AmE) realize and understand sth. such as your feelings and attitudes 认识到某事物，了解某事物（如自己的情感、态度等）",
                              "example": "I am finally able to get in touch with who I am."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "cheer up",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/dcb7162d71e858b39facc34bf1b5e6304a60b0ed_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "become less sad, or make sb. feel less sad （使）高兴起来；（使）振作起来",
                              "example": "Here is a bit of news that will cheer you up."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "sb.'s heart skips / misses a beat",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4b80b4df8029ac109ad40268d25be98ff0641ea6_96k.mp3#duration=5.6&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "used to say sb. suddenly feels a moment of fear, excitement, etc. 某人心跳停顿了一下（表示突然感到惊恐、兴奋等）",
                              "example": "My heart skipped a beat when I saw who it was. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "edit out",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/76146a20126d9f71688b61f76d562a414765af2f_96k.mp3#duration=1.5&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "remove sth. when you are preparing a book, a piece of film, etc. for printing or broadcasting （在编辑、剪辑等过程中）删除，去掉",
                              "example": "Anything offensive will be edited out at a later stage of the production."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "play on / upon",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/4f9d0fc74fb5bfdcccfbad80194c9bab53da11ae_96k.mp3#duration=2.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "use a feeling, fact, or idea in order to get what you want, often in an unfair way 利用（某一感情、事实或观点）",
                              "example": "The advertisement plays on our emotions, showing a doctor holding a newborn baby."
                          }
                      ]
                  }
              ]
          },
          {
              "word": "catch on",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6bf99287aaafebd2d74360912850af086e84ffba_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "become popular and fashionable 流行",
                              "example": "The idea of glasses being a fashion item has been slow to catch on. "
                          }
                      ]
                  }
              ]
          },
          {
              "word": "stand / have a chance / hope (of doing sth.)",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/98338e5f8057140f3fe036450ffd5193b89ed927_96k.mp3#duration=9.5&t=.mp3",
              "pee": [
                  {
                      "explanations_and_examples": [
                          {
                              "explanation": "be likely to be able to do sth. or to succeed 有机会/有希望（做某事）",
                              "example": "She will stand a chance of passing the exam if she works hard."
                          }
                      ]
                  }
              ]
          },
          {
            "word": "make sense",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "if sth. makes sense, there seems to be a good reason or explanation for it 解释得通；有道理",
                    "example": "Why did she do a thing like that? It doesn't seem to make sense."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/3fad30eef64184ff5a298300ab7831c34a16e852_96k.mp3#duration=1.5&t=.mp3"
          },
          {
            "word": "dig into",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "try to find out about sth. unknown or secret 探究； 探寻",
                    "example": "When you dig into the data a bit though, things look gloomier."
                  }
                ]
              }
            ],
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/20151a86ecfe055e5baa6b39c608b67d9c658478_96k.mp3#duration=1.8&t=.mp3"
          },
          {
            "word": "hit upon / on",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7a845567f48067a91ae84114391684647276b510_96k.mp3#duration=2.6&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "have an idea or discover sth. suddenly or unexpectedly 突然想出（主意）；无意中发现（某事）",
                    "example": "When we first hit upon the idea, everyone told us it would never work. "
                  }
                ]
              }
            ]
          },
          {
            "word": "give / lose one's heart to",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1ff64e74b78d4b5928a0acccd3f277f3ef14fdaa_96k.mp3#duration=4.6&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "start to love sb. very much 爱上某人",
                    "example": "The minute we met I knew this was the girl I wanted to give my heart to."
                  }
                ]
              }
            ]
          },
          {
            "word": "as to",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/535c7ffa742d2f91b2ddf61e8348c98952567e08_96k.mp3#duration=1.4&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "concerning sb. / sth. 关于某事",
                    "example": "Frank was very uncertain as to whether it was the right job for him."
                  }
                ]
              }
            ]
          },
          {
            "word": "green with envy",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/35738afff55736ad191c6aa031554c4755663a40_96k.mp3#duration=2.2&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "very unhappy because sb. has sth. that you want 十分忌妒；眼红",
                    "example": "Chad is heading off to Spain for the week, and I'm green with envy. "
                  }
                ]
              }
            ]
          },
          {
            "word": "set out to do sth.",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/b7e8909595d103d8ac159a3f813757b489086213_96k.mp3#duration=2.5&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "start doing sth. or making plans to do sth. in order to achieve a particular result （为达到某个结果而）开始做某事，着手进行",
                    "example": "He has achieved what he set out to do three years ago."
                  }
                ]
              }
            ]
          },
          {
            "word": "be on the case",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/1fe74b587a00e1c25cc11a68214b9a32a4c805e6_96k.mp3#duration=2.0&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "(spoken) if sb. says they are on the case, they know about a problem and are going to try to solve it 负责处理某事；负责解决某事",
                    "example": "We need to book a flight before it's too late.  Don't worry, I'm on the case."
                  }
                ]
              }
            ]
          },
          {
            "word": "beyond one's control",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/928c88aa5b7b042918fe28beaab50cf920c65421_96k.mp3#duration=2.3&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "used to say sth. is impossible for sb. to control 无法控制",
                    "example": "There was nothing we could do about it — the situation was beyond our control."
                  }
                ]
              }
            ]
          },
          {
            "word": "lend (one's) support",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/7d381a862f5f0c323d6de3d1fecb422668c54938_96k.mp3#duration=1.8&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "support sb. / sth. 给予支持",
                    "example": "The president is lending support to the governor's re-election campaign."
                  }
                ]
              }
            ]
          },
          {
            "word": "take sth. personally",
            "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/a01b83ea0946b2bec10dbe2e820af1685897512a_96k.mp3#duration=2.8&t=.mp3",
            "pee": [
              {
                "explanations_and_examples": [
                  {
                    "explanation": "get upset by the things other people say or do, because you think that their remarks or behaviors are directed at you in particular 因认为某人的言行针对自己而不快",
                    "example": "Don't take it personally; she is rude to everyone. "
                  }
                ]
              }
            ]
          }
      ]
  },
  {
      "name": "Proper names",
      "children": [
          {
              "word": "Mozart",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/d1e9f8130ed4c6fd238eefbee072372dc24d95f8_96k.mp3#duration=1.2&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈməʊtsɑːt/",
                      "explanations_and_examples": [
                          {
                              "explanation": "莫扎特（奥地利作曲家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "iTunes Store",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/64f7f221d89f2975b256330524c0bd7875aacccc_96k.mp3#duration=1.9&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "",
                      "explanations_and_examples": [
                          {
                              "explanation": "苹果音乐商店（由苹果公司营运的线上商店，提供音乐、电视、电影等媒体的下载服务）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Shakespeare",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/593a3eb9497aa496a358f88459edab8d1229f5cb_96k.mp3#duration=1.3&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˈʃeɪkˌspɪə/",
                      "explanations_and_examples": [
                          {
                              "explanation": "莎士比亚（英国剧作家、诗人）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Frida Kahlo",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/278b3637b2f29e8816899c1e4aa7fd23a91af481_96k.mp3#duration=1.8&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌfri:də ˈkɑːləʊ/",
                      "explanations_and_examples": [
                          {
                              "explanation": "弗丽达・卡洛（墨西哥画家）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Beyoncé ",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/6e0527ff4fd68f0132d939673c171835169b4fda_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/biˈjɒnseɪ/",
                      "explanations_and_examples": [
                          {
                              "explanation": "碧昂斯（美国流行音乐歌手）"
                          }
                      ]
                  }
              ]
          },
          {
              "word": "Britney Spears",
              "audio": "http://course.media.unipus.cn/edx/course-v1:Unipus+nce_4_rw_2+20200131/resource/audio/64bf1d05c5df22ecbb56cfe67c673634f520097d_96k.mp3#duration=1.4&t=.mp3",
              "pee": [
                  {
                      "partOfSpeech": "/ˌbrɪtni ˈspɪəz/",
                      "explanations_and_examples": [
                          {
                              "explanation": "布兰妮・斯皮尔斯（美国流行音乐歌手）"
                          }
                      ]
                  }
              ]
          }
      ]
  }
]
export default book2